import React, { useState, useCallback, useRef, useEffect } from 'react';
import { Avatar, IconButton, Chip, useMediaQuery, Box, Dialog, DialogTitle, Typography, DialogContent, DialogActions, Button, Slider, TextField, LinearProgress, Collapse, Link, useTheme as useTheme$1, Menu, InputAdornment, MenuItem, Divider, FormControlLabel, Checkbox } from '@mui/material';
import { makeStyles, useTheme, createStyles } from '@mui/styles';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { CloseRounded as CloseRounded$1, Close, CheckCircleOutlineRounded, ArrowDropDownRounded, SearchRounded, RadioButtonUnchecked } from '@mui/icons-material';
import { createTheme } from '@mui/material/styles';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}

const blue = {
    light: '#EAF2FF',
    main: '#2D9CDB',
    dark: '#006EA9',
};
const blue2 = {
    light: '#49A7FA',
    main: '#2F8DE5',
    dark: '#1F74C4',
};
const navyBlue = {
    light: '#1d3982',
    dark: '#0A1F57',
};
const red = {
    light: '#F15656',
    main: '#DC5252',
    dark: '#BF3636',
};
const yellow = {
    main: '#F0BB00',
};
const colors$1 = {
    orange: {
        light: '#FFBE6E',
        main: '#FFAD49',
        dark: '#FF9A20',
    },
    orange2: {
        light: '#FFF5E9',
        main: '#FEFAF5',
        dark: '#F1ECE3',
    },
    yellow,
    blue,
    red,
    blue2,
    navyBlue,
    green: {
        light: '#EAF7D5',
        main: '#6FCF97',
        dark: '#3c9d69',
    },
    grey: {
        50: '#FFFFFF',
        100: '#F1F4F9',
        200: '#D9DCE1',
        300: '#C1C4C9',
        400: '#A9ACB1',
        500: '#6B6E73',
        600: '#575A60',
        700: '#3B3E43',
        800: '#272A30',
        900: '#16181D',
        1000: '#000000',
    },
    purple: {
        light: '#E1E9FF',
        dark: '#242894',
    },
    common: {
        black: '#000',
        white: '#fff',
    },
    gradients: {
        orange: {
            main: 'linear-gradient(315deg, #F99A1C 0%, #FFB901 100%)',
            dark: 'radial-gradient(100% 100% at 50% 0%, #FFBA82 0%, #FF8B2D 100%)',
        },
        blue: {
            light: 'linear-gradient(135deg, #41B7FA 0%, #4F98FA 100%)',
            main: `linear-gradient(135deg, ${blue.main} 0%, ${blue2.main} 100%)`,
            dark: 'linear-gradient(135deg, #2F8BBF 0%, #105EC8 100%)',
        },
        red: {
            light: 'linear-gradient(315deg, #E34848 0%, #FF6666 100%)',
            main: `linear-gradient(315deg, #CC4C4C 0%, ${red.main} 100%)`,
            dark: 'linear-gradient(315deg, #B12F2F 0%, #CB3B3B 100%)',
        },
        yellow: {
            main: `linear-gradient(315deg, ${yellow.main} 0%, #FFEA00 100%)`,
        },
        green: {
            main: 'linear-gradient(315deg, #009C23 0%, #3CCE3C 100%)',
        },
    },
};

const useStyles$7 = makeStyles((theme) => {
    return {
        root: {
            display: 'flex',
        },
        rootClickable: {
            cursor: 'pointer',
            '&:hover': {
                opacity: 0.8,
            },
            '&:active': {
                opacity: 1,
            },
        },
        avatar: {
            height: 32,
            width: 32,
            border: 'none',
            backgroundColor: theme.palette.grey[100],
        },
        extraAvatar: {
            height: 32,
            width: 32,
            fontWeight: 600,
            fontSize: '0.75rem',
            lineHeight: 1.333333,
            color: theme.palette.common.white,
            background: colors$1.gradients.blue.main,
            // @TODO: @FIXME: Snapshot testing currently doesn't have access to our
            // customized theme, so pulling directly from colors, ideally we'd access like this
            // background: theme.palette.gradients.blue.main,
        },
    };
});
function AvatarGroup(_a) {
    var { children: childrenProp, max = 5, className } = _a, rest = __rest(_a, ["children", "max", "className"]);
    const classes = useStyles$7();
    const theme = useTheme();
    const clampedMax = max < 2 ? 2 : max;
    const marginLeft = parseInt(theme.spacing(1), 10) * -1;
    const children = React.Children.toArray(childrenProp).filter((child) => {
        return React.isValidElement(child);
    });
    const extraAvatars = children.length > clampedMax ? children.length - clampedMax + 1 : 0;
    return (React.createElement("div", Object.assign({ className: clsx(classes.root, typeof rest.onClick !== 'undefined' && classes.rootClickable, className) }, rest),
        children.slice(0, children.length - extraAvatars).map((child, index) => {
            const item = child;
            const itemProps = item.props;
            const propsClassName = itemProps.className;
            const propsStyle = itemProps.style;
            return React.cloneElement(item, {
                className: clsx(classes.avatar, propsClassName),
                style: Object.assign({ zIndex: index, marginLeft: index === 0 ? undefined : marginLeft }, propsStyle),
            });
        }),
        extraAvatars ? (React.createElement(Avatar, { className: clsx(classes.extraAvatar, classes.avatar), style: {
                zIndex: clampedMax,
                marginLeft,
            } },
            "+",
            extraAvatars)) : null));
}

/**
 * These two custom icons are used as the default Checkbox icons
 * see src/theme/index.tsx props
 */
const useStyles$6 = makeStyles((theme) => createStyles({
    icon: {
        borderRadius: 4,
        width: 24,
        height: 24,
        border: `1px solid ${theme.palette.grey[500]}`,
    },
    checkedIcon: {
        backgroundColor: theme.palette.primary.main,
        borderColor: 'transparent',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            margin: 6,
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M3.64697 9.32959C3.93164 9.32959 4.15186 9.21143 4.30762 8.98047L9.35645 1.11719C9.46924 0.939941 9.51758 0.789551 9.51758 0.644531C9.51758 0.263184 9.24902 0 8.8623 0C8.59912 0 8.43799 0.0966797 8.27686 0.349121L3.62012 7.73438L1.22998 4.66748C1.06885 4.45801 0.902344 4.37207 0.666016 4.37207C0.279297 4.37207 0 4.646 0 5.02197C0 5.18848 0.059082 5.34961 0.19873 5.51611L2.98096 8.98584C3.16895 9.22217 3.36768 9.32959 3.64697 9.32959Z' fill='white'/%3E%3C/svg%3E%0A")`,
            backgroundRepeat: 'no-repeat',
            content: '""',
        },
    },
    checkedIconIndeterminate: {
        '&:before': {
            width: 10,
            height: 2,
            background: 'white',
            marginTop: 10,
        },
    },
}));
const CheckboxIcon = () => {
    const classes = useStyles$6();
    return React.createElement("span", { className: clsx('checkbox-icon', classes.icon) });
};
const CheckboxCheckedIcon = () => {
    const classes = useStyles$6();
    return React.createElement("span", { className: clsx('checkbox-icon', classes.icon, classes.checkedIcon) });
};
const CheckboxCheckedIndeterminateIcon = () => {
    const classes = useStyles$6();
    return (React.createElement("span", { className: clsx('checkbox-icon', classes.icon, classes.checkedIcon, classes.checkedIconIndeterminate) }));
};

/**
 * For use as the default `action` prop for the MUI Snackbar, provides a close icon
 */
const DefaultSnackbarAction = ({ handleClose }) => (React.createElement(IconButton, { size: "small", "aria-label": "close", sx: (theme) => ({
        '& svg': {
            fill: theme.palette.common.white,
        },
        '&:hover': {
            backgroundColor: 'unset',
            '& svg': {
                fill: theme.palette.grey[200],
            },
        },
        '&:active': {
            backgroundColor: 'unset',
            '& svg': {
                fill: `${theme.palette.grey[300]} !important`,
            },
        },
    }), onClick: handleClose },
    React.createElement(CloseRounded, { fontSize: "small" })));

const KeywordChips = ({ color = 'secondary', onClick, keywords, }) => {
    return (React.createElement(React.Fragment, null, keywords.map((n, i) => (React.createElement(Chip, { color: color, size: "small", style: { maxWidth: 420 }, label: n, title: n, key: i, clickable: Boolean(onClick), onClick: onClick })))));
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @providesModule UserAgent_DEPRECATED
 */

/**
 *  Provides entirely client-side User Agent and OS detection. You should prefer
 *  the non-deprecated UserAgent module when possible, which exposes our
 *  authoritative server-side PHP-based detection to the client.
 *
 *  Usage is straightforward:
 *
 *    if (UserAgent_DEPRECATED.ie()) {
 *      //  IE
 *    }
 *
 *  You can also do version checks:
 *
 *    if (UserAgent_DEPRECATED.ie() >= 7) {
 *      //  IE7 or better
 *    }
 *
 *  The browser functions will return NaN if the browser does not match, so
 *  you can also do version compares the other way:
 *
 *    if (UserAgent_DEPRECATED.ie() < 7) {
 *      //  IE6 or worse
 *    }
 *
 *  Note that the version is a float and may include a minor version number,
 *  so you should always use range operators to perform comparisons, not
 *  strict equality.
 *
 *  **Note:** You should **strongly** prefer capability detection to browser
 *  version detection where it's reasonable:
 *
 *    http://www.quirksmode.org/js/support.html
 *
 *  Further, we have a large number of mature wrapper functions and classes
 *  which abstract away many browser irregularities. Check the documentation,
 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
 *  another copy of "event || window.event".
 *
 */

var _populated = false;

// Browsers
var _ie, _firefox, _opera, _webkit, _chrome;

// Actual IE browser for compatibility mode
var _ie_real_version;

// Platforms
var _osx, _windows, _linux, _android;

// Architectures
var _win64;

// Devices
var _iphone, _ipad, _native;

var _mobile;

function _populate() {
  if (_populated) {
    return;
  }

  _populated = true;

  // To work around buggy JS libraries that can't handle multi-digit
  // version numbers, Opera 10's user agent string claims it's Opera
  // 9, then later includes a Version/X.Y field:
  //
  // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
  var uas = navigator.userAgent;
  var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
  var os    = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);

  _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
  _ipad = /\b(iP[ao]d)/.exec(uas);
  _android = /Android/i.exec(uas);
  _native = /FBAN\/\w+;/i.exec(uas);
  _mobile = /Mobile/i.exec(uas);

  // Note that the IE team blog would have you believe you should be checking
  // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
  // from either x64 or ia64;  so ultimately, you should just check for Win64
  // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
  // Windows will send 'WOW64' instead.
  _win64 = !!(/Win64/.exec(uas));

  if (agent) {
    _ie = agent[1] ? parseFloat(agent[1]) : (
          agent[5] ? parseFloat(agent[5]) : NaN);
    // IE compatibility mode
    if (_ie && document && document.documentMode) {
      _ie = document.documentMode;
    }
    // grab the "true" ie version from the trident token if available
    var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
    _ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie;

    _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
    _opera   = agent[3] ? parseFloat(agent[3]) : NaN;
    _webkit  = agent[4] ? parseFloat(agent[4]) : NaN;
    if (_webkit) {
      // We do not add the regexp to the above test, because it will always
      // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
      // the userAgent string.
      agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
      _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
    } else {
      _chrome = NaN;
    }
  } else {
    _ie = _firefox = _opera = _chrome = _webkit = NaN;
  }

  if (os) {
    if (os[1]) {
      // Detect OS X version.  If no version number matches, set _osx to true.
      // Version examples:  10, 10_6_1, 10.7
      // Parses version number as a float, taking only first two sets of
      // digits.  If only one set of digits is found, returns just the major
      // version number.
      var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);

      _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
    } else {
      _osx = false;
    }
    _windows = !!os[2];
    _linux   = !!os[3];
  } else {
    _osx = _windows = _linux = false;
  }
}

var UserAgent_DEPRECATED$1 = {

  /**
   *  Check if the UA is Internet Explorer.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  ie: function() {
    return _populate() || _ie;
  },

  /**
   * Check if we're in Internet Explorer compatibility mode.
   *
   * @return bool true if in compatibility mode, false if
   * not compatibility mode or not ie
   */
  ieCompatibilityMode: function() {
    return _populate() || (_ie_real_version > _ie);
  },


  /**
   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
   * this when we don't need it -- tracked by #601957.
   */
  ie64: function() {
    return UserAgent_DEPRECATED$1.ie() && _win64;
  },

  /**
   *  Check if the UA is Firefox.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  firefox: function() {
    return _populate() || _firefox;
  },


  /**
   *  Check if the UA is Opera.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  opera: function() {
    return _populate() || _opera;
  },


  /**
   *  Check if the UA is WebKit.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  webkit: function() {
    return _populate() || _webkit;
  },

  /**
   *  For Push
   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
   */
  safari: function() {
    return UserAgent_DEPRECATED$1.webkit();
  },

  /**
   *  Check if the UA is a Chrome browser.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  chrome : function() {
    return _populate() || _chrome;
  },


  /**
   *  Check if the user is running Windows.
   *
   *  @return bool `true' if the user's OS is Windows.
   */
  windows: function() {
    return _populate() || _windows;
  },


  /**
   *  Check if the user is running Mac OS X.
   *
   *  @return float|bool   Returns a float if a version number is detected,
   *                       otherwise true/false.
   */
  osx: function() {
    return _populate() || _osx;
  },

  /**
   * Check if the user is running Linux.
   *
   * @return bool `true' if the user's OS is some flavor of Linux.
   */
  linux: function() {
    return _populate() || _linux;
  },

  /**
   * Check if the user is running on an iPhone or iPod platform.
   *
   * @return bool `true' if the user is running some flavor of the
   *    iPhone OS.
   */
  iphone: function() {
    return _populate() || _iphone;
  },

  mobile: function() {
    return _populate() || (_iphone || _ipad || _android || _mobile);
  },

  nativeApp: function() {
    // webviews inside of the native apps
    return _populate() || _native;
  },

  android: function() {
    return _populate() || _android;
  },

  ipad: function() {
    return _populate() || _ipad;
  }
};

var UserAgent_DEPRECATED_1 = UserAgent_DEPRECATED$1;

/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment$1 = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners:
    canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

var ExecutionEnvironment_1 = ExecutionEnvironment$1;

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */

var ExecutionEnvironment = ExecutionEnvironment_1;

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature =
    document.implementation &&
    document.implementation.hasFeature &&
    // always returns true in newer browsers as per the standard.
    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
    document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported$1(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM ||
      capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

var isEventSupported_1 = isEventSupported$1;

/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule normalizeWheel
 * @typechecks
 */

var UserAgent_DEPRECATED = UserAgent_DEPRECATED_1;

var isEventSupported = isEventSupported_1;


// Reasonable defaults
var PIXEL_STEP  = 10;
var LINE_HEIGHT = 40;
var PAGE_HEIGHT = 800;

/**
 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
 * complicated, thus this doc is long and (hopefully) detailed enough to answer
 * your questions.
 *
 * If you need to react to the mouse wheel in a predictable way, this code is
 * like your bestest friend. * hugs *
 *
 * As of today, there are 4 DOM event types you can listen to:
 *
 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
 *
 * So what to do?  The is the best:
 *
 *   normalizeWheel.getEventType();
 *
 * In your event callback, use this code to get sane interpretation of the
 * deltas.  This code will return an object with properties:
 *
 *   spinX   -- normalized spin speed (use for zoom) - x plane
 *   spinY   -- " - y plane
 *   pixelX  -- normalized distance (to pixels) - x plane
 *   pixelY  -- " - y plane
 *
 * Wheel values are provided by the browser assuming you are using the wheel to
 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
 * significantly on different platforms and browsers, forgetting that you can
 * scroll at different speeds.  Some devices (like trackpads) emit more events
 * at smaller increments with fine granularity, and some emit massive jumps with
 * linear speed or acceleration.
 *
 * This code does its best to normalize the deltas for you:
 *
 *   - spin is trying to normalize how far the wheel was spun (or trackpad
 *     dragged).  This is super useful for zoom support where you want to
 *     throw away the chunky scroll steps on the PC and make those equal to
 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
 *     resolve a single slow step on a wheel to 1.
 *
 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
 *     get the crazy differences between browsers, but at least it'll be in
 *     pixels!
 *
 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
 *     should translate to positive value zooming IN, negative zooming OUT.
 *     This matches the newer 'wheel' event.
 *
 * Why are there spinX, spinY (or pixels)?
 *
 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
 *     with a mouse.  It results in side-scrolling in the browser by default.
 *
 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
 *
 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
 *     probably is by browsers in conjunction with fancy 3D controllers .. but
 *     you know.
 *
 * Implementation info:
 *
 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
 * average mouse:
 *
 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
 *
 * On the trackpad:
 *
 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
 *
 * On other/older browsers.. it's more complicated as there can be multiple and
 * also missing delta values.
 *
 * The 'wheel' event is more standard:
 *
 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
 *
 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
 * backward compatibility with older events.  Those other values help us
 * better normalize spin speed.  Example of what the browsers provide:
 *
 *                          | event.wheelDelta | event.detail
 *        ------------------+------------------+--------------
 *          Safari v5/OS X  |       -120       |       0
 *          Safari v5/Win7  |       -120       |       0
 *         Chrome v17/OS X  |       -120       |       0
 *         Chrome v17/Win7  |       -120       |       0
 *                IE9/Win7  |       -120       |   undefined
 *         Firefox v4/OS X  |     undefined    |       1
 *         Firefox v4/Win7  |     undefined    |       3
 *
 */
function normalizeWheel$2(/*object*/ event) /*object*/ {
  var sX = 0, sY = 0,       // spinX, spinY
      pX = 0, pY = 0;       // pixelX, pixelY

  // Legacy
  if ('detail'      in event) { sY = event.detail; }
  if ('wheelDelta'  in event) { sY = -event.wheelDelta / 120; }
  if ('wheelDeltaY' in event) { sY = -event.wheelDeltaY / 120; }
  if ('wheelDeltaX' in event) { sX = -event.wheelDeltaX / 120; }

  // side scrolling on FF with DOMMouseScroll
  if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) { pY = event.deltaY; }
  if ('deltaX' in event) { pX = event.deltaX; }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode == 1) {          // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {                             // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  }

  // Fall-back if spin cannot be determined
  if (pX && !sX) { sX = (pX < 1) ? -1 : 1; }
  if (pY && !sY) { sY = (pY < 1) ? -1 : 1; }

  return { spinX  : sX,
           spinY  : sY,
           pixelX : pX,
           pixelY : pY };
}


/**
 * The best combination if you prefer spinX + spinY normalization.  It favors
 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
 * 'wheel' event, making spin speed determination impossible.
 */
normalizeWheel$2.getEventType = function() /*string*/ {
  return (UserAgent_DEPRECATED.firefox())
           ? 'DOMMouseScroll'
           : (isEventSupported('wheel'))
               ? 'wheel'
               : 'mousewheel';
};

var normalizeWheel_1 = normalizeWheel$2;

var normalizeWheel = normalizeWheel_1;

var normalizeWheel$1 = /*@__PURE__*/getDefaultExportFromCjs(normalizeWheel);

/**
 * Compute the dimension of the crop area based on media size,
 * aspect ratio and optionally rotation
 */
function getCropSize(mediaWidth, mediaHeight, containerWidth, containerHeight, aspect, rotation) {
  if (rotation === void 0) {
    rotation = 0;
  }
  var _a = rotateSize(mediaWidth, mediaHeight, rotation),
    width = _a.width,
    height = _a.height;
  var fittingWidth = Math.min(width, containerWidth);
  var fittingHeight = Math.min(height, containerHeight);
  if (fittingWidth > fittingHeight * aspect) {
    return {
      width: fittingHeight * aspect,
      height: fittingHeight
    };
  }
  return {
    width: fittingWidth,
    height: fittingWidth / aspect
  };
}
/**
 * Compute media zoom.
 * We fit the media into the container with "max-width: 100%; max-height: 100%;"
 */
function getMediaZoom(mediaSize) {
  // Take the axis with more pixels to improve accuracy
  return mediaSize.width > mediaSize.height ? mediaSize.width / mediaSize.naturalWidth : mediaSize.height / mediaSize.naturalHeight;
}
/**
 * Ensure a new media position stays in the crop area.
 */
function restrictPosition(position, mediaSize, cropSize, zoom, rotation) {
  if (rotation === void 0) {
    rotation = 0;
  }
  var _a = rotateSize(mediaSize.width, mediaSize.height, rotation),
    width = _a.width,
    height = _a.height;
  return {
    x: restrictPositionCoord(position.x, width, cropSize.width, zoom),
    y: restrictPositionCoord(position.y, height, cropSize.height, zoom)
  };
}
function restrictPositionCoord(position, mediaSize, cropSize, zoom) {
  var maxPosition = mediaSize * zoom / 2 - cropSize / 2;
  return clamp(position, -maxPosition, maxPosition);
}
function getDistanceBetweenPoints(pointA, pointB) {
  return Math.sqrt(Math.pow(pointA.y - pointB.y, 2) + Math.pow(pointA.x - pointB.x, 2));
}
function getRotationBetweenPoints(pointA, pointB) {
  return Math.atan2(pointB.y - pointA.y, pointB.x - pointA.x) * 180 / Math.PI;
}
/**
 * Compute the output cropped area of the media in percentages and pixels.
 * x/y are the top-left coordinates on the src media
 */
function computeCroppedArea(crop, mediaSize, cropSize, aspect, zoom, rotation, restrictPosition) {
  if (rotation === void 0) {
    rotation = 0;
  }
  if (restrictPosition === void 0) {
    restrictPosition = true;
  }
  // if the media is rotated by the user, we cannot limit the position anymore
  // as it might need to be negative.
  var limitAreaFn = restrictPosition ? limitArea : noOp;
  var mediaBBoxSize = rotateSize(mediaSize.width, mediaSize.height, rotation);
  var mediaNaturalBBoxSize = rotateSize(mediaSize.naturalWidth, mediaSize.naturalHeight, rotation);
  // calculate the crop area in percentages
  // in the rotated space
  var croppedAreaPercentages = {
    x: limitAreaFn(100, ((mediaBBoxSize.width - cropSize.width / zoom) / 2 - crop.x / zoom) / mediaBBoxSize.width * 100),
    y: limitAreaFn(100, ((mediaBBoxSize.height - cropSize.height / zoom) / 2 - crop.y / zoom) / mediaBBoxSize.height * 100),
    width: limitAreaFn(100, cropSize.width / mediaBBoxSize.width * 100 / zoom),
    height: limitAreaFn(100, cropSize.height / mediaBBoxSize.height * 100 / zoom)
  };
  // we compute the pixels size naively
  var widthInPixels = Math.round(limitAreaFn(mediaNaturalBBoxSize.width, croppedAreaPercentages.width * mediaNaturalBBoxSize.width / 100));
  var heightInPixels = Math.round(limitAreaFn(mediaNaturalBBoxSize.height, croppedAreaPercentages.height * mediaNaturalBBoxSize.height / 100));
  var isImgWiderThanHigh = mediaNaturalBBoxSize.width >= mediaNaturalBBoxSize.height * aspect;
  // then we ensure the width and height exactly match the aspect (to avoid rounding approximations)
  // if the media is wider than high, when zoom is 0, the crop height will be equals to image height
  // thus we want to compute the width from the height and aspect for accuracy.
  // Otherwise, we compute the height from width and aspect.
  var sizePixels = isImgWiderThanHigh ? {
    width: Math.round(heightInPixels * aspect),
    height: heightInPixels
  } : {
    width: widthInPixels,
    height: Math.round(widthInPixels / aspect)
  };
  var croppedAreaPixels = __assign(__assign({}, sizePixels), {
    x: Math.round(limitAreaFn(mediaNaturalBBoxSize.width - sizePixels.width, croppedAreaPercentages.x * mediaNaturalBBoxSize.width / 100)),
    y: Math.round(limitAreaFn(mediaNaturalBBoxSize.height - sizePixels.height, croppedAreaPercentages.y * mediaNaturalBBoxSize.height / 100))
  });
  return {
    croppedAreaPercentages: croppedAreaPercentages,
    croppedAreaPixels: croppedAreaPixels
  };
}
/**
 * Ensure the returned value is between 0 and max
 */
function limitArea(max, value) {
  return Math.min(max, Math.max(0, value));
}
function noOp(_max, value) {
  return value;
}
/**
 * Compute crop and zoom from the croppedAreaPercentages.
 */
function getInitialCropFromCroppedAreaPercentages(croppedAreaPercentages, mediaSize, rotation, cropSize, minZoom, maxZoom) {
  var mediaBBoxSize = rotateSize(mediaSize.width, mediaSize.height, rotation);
  // This is the inverse process of computeCroppedArea
  var zoom = clamp(cropSize.width / mediaBBoxSize.width * (100 / croppedAreaPercentages.width), minZoom, maxZoom);
  var crop = {
    x: zoom * mediaBBoxSize.width / 2 - cropSize.width / 2 - mediaBBoxSize.width * zoom * (croppedAreaPercentages.x / 100),
    y: zoom * mediaBBoxSize.height / 2 - cropSize.height / 2 - mediaBBoxSize.height * zoom * (croppedAreaPercentages.y / 100)
  };
  return {
    crop: crop,
    zoom: zoom
  };
}
/**
 * Compute zoom from the croppedAreaPixels
 */
function getZoomFromCroppedAreaPixels(croppedAreaPixels, mediaSize, cropSize) {
  var mediaZoom = getMediaZoom(mediaSize);
  return cropSize.height > cropSize.width ? cropSize.height / (croppedAreaPixels.height * mediaZoom) : cropSize.width / (croppedAreaPixels.width * mediaZoom);
}
/**
 * Compute crop and zoom from the croppedAreaPixels
 */
function getInitialCropFromCroppedAreaPixels(croppedAreaPixels, mediaSize, rotation, cropSize, minZoom, maxZoom) {
  if (rotation === void 0) {
    rotation = 0;
  }
  var mediaNaturalBBoxSize = rotateSize(mediaSize.naturalWidth, mediaSize.naturalHeight, rotation);
  var zoom = clamp(getZoomFromCroppedAreaPixels(croppedAreaPixels, mediaSize, cropSize), minZoom, maxZoom);
  var cropZoom = cropSize.height > cropSize.width ? cropSize.height / croppedAreaPixels.height : cropSize.width / croppedAreaPixels.width;
  var crop = {
    x: ((mediaNaturalBBoxSize.width - croppedAreaPixels.width) / 2 - croppedAreaPixels.x) * cropZoom,
    y: ((mediaNaturalBBoxSize.height - croppedAreaPixels.height) / 2 - croppedAreaPixels.y) * cropZoom
  };
  return {
    crop: crop,
    zoom: zoom
  };
}
/**
 * Return the point that is the center of point a and b
 */
function getCenter(a, b) {
  return {
    x: (b.x + a.x) / 2,
    y: (b.y + a.y) / 2
  };
}
function getRadianAngle(degreeValue) {
  return degreeValue * Math.PI / 180;
}
/**
 * Returns the new bounding area of a rotated rectangle.
 */
function rotateSize(width, height, rotation) {
  var rotRad = getRadianAngle(rotation);
  return {
    width: Math.abs(Math.cos(rotRad) * width) + Math.abs(Math.sin(rotRad) * height),
    height: Math.abs(Math.sin(rotRad) * width) + Math.abs(Math.cos(rotRad) * height)
  };
}
/**
 * Clamp value between min and max
 */
function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}
/**
 * Combine multiple class names into a single string.
 */
function classNames() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  return args.filter(function (value) {
    if (typeof value === 'string' && value.length > 0) {
      return true;
    }
    return false;
  }).join(' ').trim();
}

var css_248z = ".reactEasyCrop_Container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  user-select: none;\n  touch-action: none;\n  cursor: move;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.reactEasyCrop_Image,\n.reactEasyCrop_Video {\n  will-change: transform; /* this improves performances and prevent painting issues on iOS Chrome */\n}\n\n.reactEasyCrop_Contain {\n  max-width: 100%;\n  max-height: 100%;\n  margin: auto;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.reactEasyCrop_Cover_Horizontal {\n  width: 100%;\n  height: auto;\n}\n.reactEasyCrop_Cover_Vertical {\n  width: auto;\n  height: 100%;\n}\n\n.reactEasyCrop_CropArea {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-sizing: border-box;\n  box-shadow: 0 0 0 9999em;\n  color: rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n}\n\n.reactEasyCrop_CropAreaRound {\n  border-radius: 50%;\n}\n\n.reactEasyCrop_CropAreaGrid::before {\n  content: ' ';\n  box-sizing: border-box;\n  position: absolute;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  top: 0;\n  bottom: 0;\n  left: 33.33%;\n  right: 33.33%;\n  border-top: 0;\n  border-bottom: 0;\n}\n\n.reactEasyCrop_CropAreaGrid::after {\n  content: ' ';\n  box-sizing: border-box;\n  position: absolute;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  top: 33.33%;\n  bottom: 33.33%;\n  left: 0;\n  right: 0;\n  border-left: 0;\n  border-right: 0;\n}\n";

var MIN_ZOOM = 1;
var MAX_ZOOM = 3;
var Cropper = /** @class */function (_super) {
  __extends(Cropper, _super);
  function Cropper() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.imageRef = React.createRef();
    _this.videoRef = React.createRef();
    _this.containerPosition = {
      x: 0,
      y: 0
    };
    _this.containerRef = null;
    _this.styleRef = null;
    _this.containerRect = null;
    _this.mediaSize = {
      width: 0,
      height: 0,
      naturalWidth: 0,
      naturalHeight: 0
    };
    _this.dragStartPosition = {
      x: 0,
      y: 0
    };
    _this.dragStartCrop = {
      x: 0,
      y: 0
    };
    _this.gestureZoomStart = 0;
    _this.gestureRotationStart = 0;
    _this.isTouching = false;
    _this.lastPinchDistance = 0;
    _this.lastPinchRotation = 0;
    _this.rafDragTimeout = null;
    _this.rafPinchTimeout = null;
    _this.wheelTimer = null;
    _this.currentDoc = typeof document !== 'undefined' ? document : null;
    _this.currentWindow = typeof window !== 'undefined' ? window : null;
    _this.resizeObserver = null;
    _this.state = {
      cropSize: null,
      hasWheelJustStarted: false
    };
    _this.initResizeObserver = function () {
      if (typeof window.ResizeObserver === 'undefined' || !_this.containerRef) {
        return;
      }
      var isFirstResize = true;
      _this.resizeObserver = new window.ResizeObserver(function (entries) {
        if (isFirstResize) {
          isFirstResize = false; // observe() is called on mount, we don't want to trigger a recompute on mount
          return;
        }
        _this.computeSizes();
      });
      _this.resizeObserver.observe(_this.containerRef);
    };
    // this is to prevent Safari on iOS >= 10 to zoom the page
    _this.preventZoomSafari = function (e) {
      return e.preventDefault();
    };
    _this.cleanEvents = function () {
      if (!_this.currentDoc) return;
      _this.currentDoc.removeEventListener('mousemove', _this.onMouseMove);
      _this.currentDoc.removeEventListener('mouseup', _this.onDragStopped);
      _this.currentDoc.removeEventListener('touchmove', _this.onTouchMove);
      _this.currentDoc.removeEventListener('touchend', _this.onDragStopped);
      _this.currentDoc.removeEventListener('gesturemove', _this.onGestureMove);
      _this.currentDoc.removeEventListener('gestureend', _this.onGestureEnd);
      _this.currentDoc.removeEventListener('scroll', _this.onScroll);
    };
    _this.clearScrollEvent = function () {
      if (_this.containerRef) _this.containerRef.removeEventListener('wheel', _this.onWheel);
      if (_this.wheelTimer) {
        clearTimeout(_this.wheelTimer);
      }
    };
    _this.onMediaLoad = function () {
      var cropSize = _this.computeSizes();
      if (cropSize) {
        _this.emitCropData();
        _this.setInitialCrop(cropSize);
      }
      if (_this.props.onMediaLoaded) {
        _this.props.onMediaLoaded(_this.mediaSize);
      }
    };
    _this.setInitialCrop = function (cropSize) {
      if (_this.props.initialCroppedAreaPercentages) {
        var _a = getInitialCropFromCroppedAreaPercentages(_this.props.initialCroppedAreaPercentages, _this.mediaSize, _this.props.rotation, cropSize, _this.props.minZoom, _this.props.maxZoom),
          crop = _a.crop,
          zoom = _a.zoom;
        _this.props.onCropChange(crop);
        _this.props.onZoomChange && _this.props.onZoomChange(zoom);
      } else if (_this.props.initialCroppedAreaPixels) {
        var _b = getInitialCropFromCroppedAreaPixels(_this.props.initialCroppedAreaPixels, _this.mediaSize, _this.props.rotation, cropSize, _this.props.minZoom, _this.props.maxZoom),
          crop = _b.crop,
          zoom = _b.zoom;
        _this.props.onCropChange(crop);
        _this.props.onZoomChange && _this.props.onZoomChange(zoom);
      }
    };
    _this.computeSizes = function () {
      var _a, _b, _c, _d, _e, _f;
      var mediaRef = _this.imageRef.current || _this.videoRef.current;
      if (mediaRef && _this.containerRef) {
        _this.containerRect = _this.containerRef.getBoundingClientRect();
        _this.saveContainerPosition();
        var containerAspect = _this.containerRect.width / _this.containerRect.height;
        var naturalWidth = ((_a = _this.imageRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth) || ((_b = _this.videoRef.current) === null || _b === void 0 ? void 0 : _b.videoWidth) || 0;
        var naturalHeight = ((_c = _this.imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalHeight) || ((_d = _this.videoRef.current) === null || _d === void 0 ? void 0 : _d.videoHeight) || 0;
        var isMediaScaledDown = mediaRef.offsetWidth < naturalWidth || mediaRef.offsetHeight < naturalHeight;
        var mediaAspect = naturalWidth / naturalHeight;
        // We do not rely on the offsetWidth/offsetHeight if the media is scaled down
        // as the values they report are rounded. That will result in precision losses
        // when calculating zoom. We use the fact that the media is positionned relative
        // to the container. That allows us to use the container's dimensions
        // and natural aspect ratio of the media to calculate accurate media size.
        // However, for this to work, the container should not be rotated
        var renderedMediaSize = void 0;
        if (isMediaScaledDown) {
          var objectFit = _this.getObjectFit();
          switch (objectFit) {
            default:
            case 'contain':
              renderedMediaSize = containerAspect > mediaAspect ? {
                width: _this.containerRect.height * mediaAspect,
                height: _this.containerRect.height
              } : {
                width: _this.containerRect.width,
                height: _this.containerRect.width / mediaAspect
              };
              break;
            case 'horizontal-cover':
              renderedMediaSize = {
                width: _this.containerRect.width,
                height: _this.containerRect.width / mediaAspect
              };
              break;
            case 'vertical-cover':
              renderedMediaSize = {
                width: _this.containerRect.height * mediaAspect,
                height: _this.containerRect.height
              };
              break;
          }
        } else {
          renderedMediaSize = {
            width: mediaRef.offsetWidth,
            height: mediaRef.offsetHeight
          };
        }
        _this.mediaSize = __assign(__assign({}, renderedMediaSize), {
          naturalWidth: naturalWidth,
          naturalHeight: naturalHeight
        });
        // set media size in the parent
        if (_this.props.setMediaSize) {
          _this.props.setMediaSize(_this.mediaSize);
        }
        var cropSize = _this.props.cropSize ? _this.props.cropSize : getCropSize(_this.mediaSize.width, _this.mediaSize.height, _this.containerRect.width, _this.containerRect.height, _this.props.aspect, _this.props.rotation);
        if (((_e = _this.state.cropSize) === null || _e === void 0 ? void 0 : _e.height) !== cropSize.height || ((_f = _this.state.cropSize) === null || _f === void 0 ? void 0 : _f.width) !== cropSize.width) {
          _this.props.onCropSizeChange && _this.props.onCropSizeChange(cropSize);
        }
        _this.setState({
          cropSize: cropSize
        }, _this.recomputeCropPosition);
        // pass crop size to parent
        if (_this.props.setCropSize) {
          _this.props.setCropSize(cropSize);
        }
        return cropSize;
      }
    };
    _this.saveContainerPosition = function () {
      if (_this.containerRef) {
        var bounds = _this.containerRef.getBoundingClientRect();
        _this.containerPosition = {
          x: bounds.left,
          y: bounds.top
        };
      }
    };
    _this.onMouseDown = function (e) {
      if (!_this.currentDoc) return;
      e.preventDefault();
      _this.currentDoc.addEventListener('mousemove', _this.onMouseMove);
      _this.currentDoc.addEventListener('mouseup', _this.onDragStopped);
      _this.saveContainerPosition();
      _this.onDragStart(Cropper.getMousePoint(e));
    };
    _this.onMouseMove = function (e) {
      return _this.onDrag(Cropper.getMousePoint(e));
    };
    _this.onScroll = function (e) {
      if (!_this.currentDoc) return;
      e.preventDefault();
      _this.saveContainerPosition();
    };
    _this.onTouchStart = function (e) {
      if (!_this.currentDoc) return;
      _this.isTouching = true;
      if (_this.props.onTouchRequest && !_this.props.onTouchRequest(e)) {
        return;
      }
      _this.currentDoc.addEventListener('touchmove', _this.onTouchMove, {
        passive: false
      }); // iOS 11 now defaults to passive: true
      _this.currentDoc.addEventListener('touchend', _this.onDragStopped);
      _this.saveContainerPosition();
      if (e.touches.length === 2) {
        _this.onPinchStart(e);
      } else if (e.touches.length === 1) {
        _this.onDragStart(Cropper.getTouchPoint(e.touches[0]));
      }
    };
    _this.onTouchMove = function (e) {
      // Prevent whole page from scrolling on iOS.
      e.preventDefault();
      if (e.touches.length === 2) {
        _this.onPinchMove(e);
      } else if (e.touches.length === 1) {
        _this.onDrag(Cropper.getTouchPoint(e.touches[0]));
      }
    };
    _this.onGestureStart = function (e) {
      if (!_this.currentDoc) return;
      e.preventDefault();
      _this.currentDoc.addEventListener('gesturechange', _this.onGestureMove);
      _this.currentDoc.addEventListener('gestureend', _this.onGestureEnd);
      _this.gestureZoomStart = _this.props.zoom;
      _this.gestureRotationStart = _this.props.rotation;
    };
    _this.onGestureMove = function (e) {
      e.preventDefault();
      if (_this.isTouching) {
        // this is to avoid conflict between gesture and touch events
        return;
      }
      var point = Cropper.getMousePoint(e);
      var newZoom = _this.gestureZoomStart - 1 + e.scale;
      _this.setNewZoom(newZoom, point, {
        shouldUpdatePosition: true
      });
      if (_this.props.onRotationChange) {
        var newRotation = _this.gestureRotationStart + e.rotation;
        _this.props.onRotationChange(newRotation);
      }
    };
    _this.onGestureEnd = function (e) {
      _this.cleanEvents();
    };
    _this.onDragStart = function (_a) {
      var _b, _c;
      var x = _a.x,
        y = _a.y;
      _this.dragStartPosition = {
        x: x,
        y: y
      };
      _this.dragStartCrop = __assign({}, _this.props.crop);
      (_c = (_b = _this.props).onInteractionStart) === null || _c === void 0 ? void 0 : _c.call(_b);
    };
    _this.onDrag = function (_a) {
      var x = _a.x,
        y = _a.y;
      if (!_this.currentWindow) return;
      if (_this.rafDragTimeout) _this.currentWindow.cancelAnimationFrame(_this.rafDragTimeout);
      _this.rafDragTimeout = _this.currentWindow.requestAnimationFrame(function () {
        if (!_this.state.cropSize) return;
        if (x === undefined || y === undefined) return;
        var offsetX = x - _this.dragStartPosition.x;
        var offsetY = y - _this.dragStartPosition.y;
        var requestedPosition = {
          x: _this.dragStartCrop.x + offsetX,
          y: _this.dragStartCrop.y + offsetY
        };
        var newPosition = _this.props.restrictPosition ? restrictPosition(requestedPosition, _this.mediaSize, _this.state.cropSize, _this.props.zoom, _this.props.rotation) : requestedPosition;
        _this.props.onCropChange(newPosition);
      });
    };
    _this.onDragStopped = function () {
      var _a, _b;
      _this.isTouching = false;
      _this.cleanEvents();
      _this.emitCropData();
      (_b = (_a = _this.props).onInteractionEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    _this.onWheel = function (e) {
      if (!_this.currentWindow) return;
      if (_this.props.onWheelRequest && !_this.props.onWheelRequest(e)) {
        return;
      }
      e.preventDefault();
      var point = Cropper.getMousePoint(e);
      var pixelY = normalizeWheel$1(e).pixelY;
      var newZoom = _this.props.zoom - pixelY * _this.props.zoomSpeed / 200;
      _this.setNewZoom(newZoom, point, {
        shouldUpdatePosition: true
      });
      if (!_this.state.hasWheelJustStarted) {
        _this.setState({
          hasWheelJustStarted: true
        }, function () {
          var _a, _b;
          return (_b = (_a = _this.props).onInteractionStart) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
      }
      if (_this.wheelTimer) {
        clearTimeout(_this.wheelTimer);
      }
      _this.wheelTimer = _this.currentWindow.setTimeout(function () {
        return _this.setState({
          hasWheelJustStarted: false
        }, function () {
          var _a, _b;
          return (_b = (_a = _this.props).onInteractionEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
      }, 250);
    };
    _this.getPointOnContainer = function (_a, containerTopLeft) {
      var x = _a.x,
        y = _a.y;
      if (!_this.containerRect) {
        throw new Error('The Cropper is not mounted');
      }
      return {
        x: _this.containerRect.width / 2 - (x - containerTopLeft.x),
        y: _this.containerRect.height / 2 - (y - containerTopLeft.y)
      };
    };
    _this.getPointOnMedia = function (_a) {
      var x = _a.x,
        y = _a.y;
      var _b = _this.props,
        crop = _b.crop,
        zoom = _b.zoom;
      return {
        x: (x + crop.x) / zoom,
        y: (y + crop.y) / zoom
      };
    };
    _this.setNewZoom = function (zoom, point, _a) {
      var _b = _a === void 0 ? {} : _a,
        _c = _b.shouldUpdatePosition,
        shouldUpdatePosition = _c === void 0 ? true : _c;
      if (!_this.state.cropSize || !_this.props.onZoomChange) return;
      var newZoom = clamp(zoom, _this.props.minZoom, _this.props.maxZoom);
      if (shouldUpdatePosition) {
        var zoomPoint = _this.getPointOnContainer(point, _this.containerPosition);
        var zoomTarget = _this.getPointOnMedia(zoomPoint);
        var requestedPosition = {
          x: zoomTarget.x * newZoom - zoomPoint.x,
          y: zoomTarget.y * newZoom - zoomPoint.y
        };
        var newPosition = _this.props.restrictPosition ? restrictPosition(requestedPosition, _this.mediaSize, _this.state.cropSize, newZoom, _this.props.rotation) : requestedPosition;
        _this.props.onCropChange(newPosition);
      }
      _this.props.onZoomChange(newZoom);
    };
    _this.getCropData = function () {
      if (!_this.state.cropSize) {
        return null;
      }
      // this is to ensure the crop is correctly restricted after a zoom back (https://github.com/ValentinH/react-easy-crop/issues/6)
      var restrictedPosition = _this.props.restrictPosition ? restrictPosition(_this.props.crop, _this.mediaSize, _this.state.cropSize, _this.props.zoom, _this.props.rotation) : _this.props.crop;
      return computeCroppedArea(restrictedPosition, _this.mediaSize, _this.state.cropSize, _this.getAspect(), _this.props.zoom, _this.props.rotation, _this.props.restrictPosition);
    };
    _this.emitCropData = function () {
      var cropData = _this.getCropData();
      if (!cropData) return;
      var croppedAreaPercentages = cropData.croppedAreaPercentages,
        croppedAreaPixels = cropData.croppedAreaPixels;
      if (_this.props.onCropComplete) {
        _this.props.onCropComplete(croppedAreaPercentages, croppedAreaPixels);
      }
      if (_this.props.onCropAreaChange) {
        _this.props.onCropAreaChange(croppedAreaPercentages, croppedAreaPixels);
      }
    };
    _this.emitCropAreaChange = function () {
      var cropData = _this.getCropData();
      if (!cropData) return;
      var croppedAreaPercentages = cropData.croppedAreaPercentages,
        croppedAreaPixels = cropData.croppedAreaPixels;
      if (_this.props.onCropAreaChange) {
        _this.props.onCropAreaChange(croppedAreaPercentages, croppedAreaPixels);
      }
    };
    _this.recomputeCropPosition = function () {
      if (!_this.state.cropSize) return;
      var newPosition = _this.props.restrictPosition ? restrictPosition(_this.props.crop, _this.mediaSize, _this.state.cropSize, _this.props.zoom, _this.props.rotation) : _this.props.crop;
      _this.props.onCropChange(newPosition);
      _this.emitCropData();
    };
    return _this;
  }
  Cropper.prototype.componentDidMount = function () {
    if (!this.currentDoc || !this.currentWindow) return;
    if (this.containerRef) {
      if (this.containerRef.ownerDocument) {
        this.currentDoc = this.containerRef.ownerDocument;
      }
      if (this.currentDoc.defaultView) {
        this.currentWindow = this.currentDoc.defaultView;
      }
      this.initResizeObserver();
      // only add window resize listener if ResizeObserver is not supported. Otherwise, it would be redundant
      if (typeof window.ResizeObserver === 'undefined') {
        this.currentWindow.addEventListener('resize', this.computeSizes);
      }
      this.props.zoomWithScroll && this.containerRef.addEventListener('wheel', this.onWheel, {
        passive: false
      });
      this.containerRef.addEventListener('gesturestart', this.onGestureStart);
    }
    this.currentDoc.addEventListener('scroll', this.onScroll);
    if (!this.props.disableAutomaticStylesInjection) {
      this.styleRef = this.currentDoc.createElement('style');
      this.styleRef.setAttribute('type', 'text/css');
      if (this.props.nonce) {
        this.styleRef.setAttribute('nonce', this.props.nonce);
      }
      this.styleRef.innerHTML = css_248z;
      this.currentDoc.head.appendChild(this.styleRef);
    }
    // when rendered via SSR, the image can already be loaded and its onLoad callback will never be called
    if (this.imageRef.current && this.imageRef.current.complete) {
      this.onMediaLoad();
    }
    // set image and video refs in the parent if the callbacks exist
    if (this.props.setImageRef) {
      this.props.setImageRef(this.imageRef);
    }
    if (this.props.setVideoRef) {
      this.props.setVideoRef(this.videoRef);
    }
  };
  Cropper.prototype.componentWillUnmount = function () {
    var _a, _b;
    if (!this.currentDoc || !this.currentWindow) return;
    if (typeof window.ResizeObserver === 'undefined') {
      this.currentWindow.removeEventListener('resize', this.computeSizes);
    }
    (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
    if (this.containerRef) {
      this.containerRef.removeEventListener('gesturestart', this.preventZoomSafari);
    }
    if (this.styleRef) {
      (_b = this.styleRef.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(this.styleRef);
    }
    this.cleanEvents();
    this.props.zoomWithScroll && this.clearScrollEvent();
  };
  Cropper.prototype.componentDidUpdate = function (prevProps) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (prevProps.rotation !== this.props.rotation) {
      this.computeSizes();
      this.recomputeCropPosition();
    } else if (prevProps.aspect !== this.props.aspect) {
      this.computeSizes();
    } else if (prevProps.objectFit !== this.props.objectFit) {
      this.computeSizes();
    } else if (prevProps.zoom !== this.props.zoom) {
      this.recomputeCropPosition();
    } else if (((_a = prevProps.cropSize) === null || _a === void 0 ? void 0 : _a.height) !== ((_b = this.props.cropSize) === null || _b === void 0 ? void 0 : _b.height) || ((_c = prevProps.cropSize) === null || _c === void 0 ? void 0 : _c.width) !== ((_d = this.props.cropSize) === null || _d === void 0 ? void 0 : _d.width)) {
      this.computeSizes();
    } else if (((_e = prevProps.crop) === null || _e === void 0 ? void 0 : _e.x) !== ((_f = this.props.crop) === null || _f === void 0 ? void 0 : _f.x) || ((_g = prevProps.crop) === null || _g === void 0 ? void 0 : _g.y) !== ((_h = this.props.crop) === null || _h === void 0 ? void 0 : _h.y)) {
      this.emitCropAreaChange();
    }
    if (prevProps.zoomWithScroll !== this.props.zoomWithScroll && this.containerRef) {
      this.props.zoomWithScroll ? this.containerRef.addEventListener('wheel', this.onWheel, {
        passive: false
      }) : this.clearScrollEvent();
    }
    if (prevProps.video !== this.props.video) {
      (_j = this.videoRef.current) === null || _j === void 0 ? void 0 : _j.load();
    }
  };
  Cropper.prototype.getAspect = function () {
    var _a = this.props,
      cropSize = _a.cropSize,
      aspect = _a.aspect;
    if (cropSize) {
      return cropSize.width / cropSize.height;
    }
    return aspect;
  };
  Cropper.prototype.getObjectFit = function () {
    var _a, _b, _c, _d;
    if (this.props.objectFit === 'cover') {
      var mediaRef = this.imageRef.current || this.videoRef.current;
      if (mediaRef && this.containerRef) {
        this.containerRect = this.containerRef.getBoundingClientRect();
        var containerAspect = this.containerRect.width / this.containerRect.height;
        var naturalWidth = ((_a = this.imageRef.current) === null || _a === void 0 ? void 0 : _a.naturalWidth) || ((_b = this.videoRef.current) === null || _b === void 0 ? void 0 : _b.videoWidth) || 0;
        var naturalHeight = ((_c = this.imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalHeight) || ((_d = this.videoRef.current) === null || _d === void 0 ? void 0 : _d.videoHeight) || 0;
        var mediaAspect = naturalWidth / naturalHeight;
        return mediaAspect < containerAspect ? 'horizontal-cover' : 'vertical-cover';
      }
      return 'horizontal-cover';
    }
    return this.props.objectFit;
  };
  Cropper.prototype.onPinchStart = function (e) {
    var pointA = Cropper.getTouchPoint(e.touches[0]);
    var pointB = Cropper.getTouchPoint(e.touches[1]);
    this.lastPinchDistance = getDistanceBetweenPoints(pointA, pointB);
    this.lastPinchRotation = getRotationBetweenPoints(pointA, pointB);
    this.onDragStart(getCenter(pointA, pointB));
  };
  Cropper.prototype.onPinchMove = function (e) {
    var _this = this;
    if (!this.currentDoc || !this.currentWindow) return;
    var pointA = Cropper.getTouchPoint(e.touches[0]);
    var pointB = Cropper.getTouchPoint(e.touches[1]);
    var center = getCenter(pointA, pointB);
    this.onDrag(center);
    if (this.rafPinchTimeout) this.currentWindow.cancelAnimationFrame(this.rafPinchTimeout);
    this.rafPinchTimeout = this.currentWindow.requestAnimationFrame(function () {
      var distance = getDistanceBetweenPoints(pointA, pointB);
      var newZoom = _this.props.zoom * (distance / _this.lastPinchDistance);
      _this.setNewZoom(newZoom, center, {
        shouldUpdatePosition: false
      });
      _this.lastPinchDistance = distance;
      var rotation = getRotationBetweenPoints(pointA, pointB);
      var newRotation = _this.props.rotation + (rotation - _this.lastPinchRotation);
      _this.props.onRotationChange && _this.props.onRotationChange(newRotation);
      _this.lastPinchRotation = rotation;
    });
  };
  Cropper.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      image = _a.image,
      video = _a.video,
      mediaProps = _a.mediaProps,
      transform = _a.transform,
      _b = _a.crop,
      x = _b.x,
      y = _b.y,
      rotation = _a.rotation,
      zoom = _a.zoom,
      cropShape = _a.cropShape,
      showGrid = _a.showGrid,
      _c = _a.style,
      containerStyle = _c.containerStyle,
      cropAreaStyle = _c.cropAreaStyle,
      mediaStyle = _c.mediaStyle,
      _d = _a.classes,
      containerClassName = _d.containerClassName,
      cropAreaClassName = _d.cropAreaClassName,
      mediaClassName = _d.mediaClassName;
    var objectFit = this.getObjectFit();
    return React.createElement("div", {
      onMouseDown: this.onMouseDown,
      onTouchStart: this.onTouchStart,
      ref: function ref(el) {
        return _this.containerRef = el;
      },
      "data-testid": "container",
      style: containerStyle,
      className: classNames('reactEasyCrop_Container', containerClassName)
    }, image ? React.createElement("img", __assign({
      alt: "",
      className: classNames('reactEasyCrop_Image', objectFit === 'contain' && 'reactEasyCrop_Contain', objectFit === 'horizontal-cover' && 'reactEasyCrop_Cover_Horizontal', objectFit === 'vertical-cover' && 'reactEasyCrop_Cover_Vertical', mediaClassName)
    }, mediaProps, {
      src: image,
      ref: this.imageRef,
      style: __assign(__assign({}, mediaStyle), {
        transform: transform || "translate(".concat(x, "px, ").concat(y, "px) rotate(").concat(rotation, "deg) scale(").concat(zoom, ")")
      }),
      onLoad: this.onMediaLoad
    })) : video && React.createElement("video", __assign({
      autoPlay: true,
      loop: true,
      muted: true,
      className: classNames('reactEasyCrop_Video', objectFit === 'contain' && 'reactEasyCrop_Contain', objectFit === 'horizontal-cover' && 'reactEasyCrop_Cover_Horizontal', objectFit === 'vertical-cover' && 'reactEasyCrop_Cover_Vertical', mediaClassName)
    }, mediaProps, {
      ref: this.videoRef,
      onLoadedMetadata: this.onMediaLoad,
      style: __assign(__assign({}, mediaStyle), {
        transform: transform || "translate(".concat(x, "px, ").concat(y, "px) rotate(").concat(rotation, "deg) scale(").concat(zoom, ")")
      }),
      controls: false
    }), (Array.isArray(video) ? video : [{
      src: video
    }]).map(function (item) {
      return React.createElement("source", __assign({
        key: item.src
      }, item));
    })), this.state.cropSize && React.createElement("div", {
      style: __assign(__assign({}, cropAreaStyle), {
        width: this.state.cropSize.width,
        height: this.state.cropSize.height
      }),
      "data-testid": "cropper",
      className: classNames('reactEasyCrop_CropArea', cropShape === 'round' && 'reactEasyCrop_CropAreaRound', showGrid && 'reactEasyCrop_CropAreaGrid', cropAreaClassName)
    }));
  };
  Cropper.defaultProps = {
    zoom: 1,
    rotation: 0,
    aspect: 4 / 3,
    maxZoom: MAX_ZOOM,
    minZoom: MIN_ZOOM,
    cropShape: 'rect',
    objectFit: 'contain',
    showGrid: true,
    style: {},
    classes: {},
    mediaProps: {},
    zoomSpeed: 1,
    restrictPosition: true,
    zoomWithScroll: true
  };
  Cropper.getMousePoint = function (e) {
    return {
      x: Number(e.clientX),
      y: Number(e.clientY)
    };
  };
  Cropper.getTouchPoint = function (touch) {
    return {
      x: Number(touch.clientX),
      y: Number(touch.clientY)
    };
  };
  return Cropper;
}(React.Component);

//overriden font sizes that have been preset against the rule
const AVATAR_OVERRIDE_FONT_SIZES = { 160: '88px', 96: '56px', 80: '42px' };

/**
 * Control ID logic
 */
const controlIdMap = {
    link: 'lnk',
    button: 'btn',
    checkbox: 'chk',
    color: 'col',
    date: 'dat',
    email: 'eml',
    file: 'fil',
    hidden: 'hid',
    image: 'img',
    month: 'mon',
    number: 'num',
    password: 'pas',
    radio: 'rad',
    range: 'ran',
    reset: 'res',
    search: 'sea',
    submit: 'sub',
    select: 'sel',
    tel: 'tel',
    text: 'txt',
    time: 'tme',
    url: 'url',
    week: 'wek',
};
const getControlId = ({ type, name } = {}) => {
    const returnType = type && controlIdMap[type] ? controlIdMap[type] : 'id';
    const returnName = name ? name : '';
    const delimiter = returnName ? '-' : '';
    return `${returnType}${delimiter}${returnName}`;
};
const getInitials = (firstName = '', lastName = '') => {
    return `${firstName.substring(0, 1).toUpperCase()}${lastName.substring(0, 1).toUpperCase()}`;
};
//given avatarSize, return fontSize
const getAvatarFontSize = (avatarSize) => {
    const size = avatarSize * 8;
    const overrideMap = AVATAR_OVERRIDE_FONT_SIZES;
    if (size in overrideMap)
        return overrideMap[size];
    return `${size / 2}px`;
};

const createImage = (url) => new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener('load', () => resolve(image));
    image.addEventListener('error', (error) => reject(error));
    image.src = url;
});
/**
 * This function was adapted from the one in the README of https://github.com/DominicTobias/react-image-crop
 * To add in image rotation, view the initial commit of this file
 * @param {File} image - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 */
function getCroppedImg(imageSrc, pixelCrop, outputAsFile, filename) {
    return __awaiter(this, void 0, void 0, function* () {
        const image = yield createImage(imageSrc);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx)
            throw new Error('No ImageCropper canvas context found.');
        // In addition to cropping we also want to resize images to 200px square
        // we'll need a second canvas for that
        const resizeCanvas = document.createElement('canvas');
        resizeCanvas.width = 200;
        resizeCanvas.height = 200;
        const resizeCtx = resizeCanvas.getContext('2d');
        if (!resizeCtx)
            throw new Error('No ImageCropper resizeCanvas context found.');
        const maxSize = Math.max(image.width, image.height);
        const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));
        // set each dimensions to double largest dimension to allow for a safe area for the
        // image to rotate in without being clipped by canvas context
        canvas.width = safeArea;
        canvas.height = safeArea;
        // translate canvas context to a central location on image to allow rotating around the center.
        ctx.translate(safeArea / 2, safeArea / 2);
        ctx.translate(-safeArea / 2, -safeArea / 2);
        // draw rotated image and store data.
        ctx.drawImage(image, safeArea / 2 - image.width * 0.5, safeArea / 2 - image.height * 0.5);
        const data = ctx.getImageData(0, 0, safeArea, safeArea);
        // set canvas width to final desired crop size - this will clear existing context
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
        // paste generated rotate image with correct offsets for x,y crop values.
        ctx.putImageData(data, Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x), Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y));
        // Resize image to 200px square
        resizeCtx.drawImage(canvas, 0, 0, 200, 200);
        if (!outputAsFile) {
            // As Base64 string
            return new Promise((resolve) => {
                resolve(resizeCanvas.toDataURL('image/png'));
            });
        }
        return new Promise((resolve) => {
            resizeCanvas.toBlob(blob => {
                if (blob) {
                    const file = new File([blob], filename ? `${filename}.png` : 'image_file.png', { type: 'image/png' });
                    return resolve(file);
                }
                return resolve(null);
            });
        });
    });
}

const useStyles$5 = makeStyles((theme) => {
    return {
        cropContainer: {
            position: 'relative',
            width: '100%',
            height: 200,
            background: '#333',
            [theme.breakpoints.up('sm')]: {
                height: 400,
            },
        },
        sliderContainer: {
            display: 'flex',
            alignItems: 'center',
            '& .MuiTypography-h6': {
                marginRight: theme.spacing(3),
            },
        },
    };
});
function readFile(file) {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => resolve(reader.result), false);
        reader.readAsDataURL(file);
    });
}
function getImage(file) {
    return new Promise((resolve) => {
        const fileAsDataUrl = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
            resolve(img);
        };
        img.src = fileAsDataUrl || '';
    });
}
function ImageCropper({ maxFileSize = 8388608, minSize = 200, onClose, onSave, onError, saveButtonEnabled = true, errorMessage, children, cropperChildren, childrenBoxProps = {}, outputAsFile = false, }) {
    const theme = useTheme();
    const classes = useStyles$5();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [imageSrc, setImageSrc] = useState(undefined);
    const [filename, setFilename] = useState(undefined);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(undefined);
    const messages = {
        imageFileSizeTooLarge: `Please upload an image that is ${maxFileSize / (1024 * 1024)} MB or smaller.`,
        imageSizeTooSmall: `Please upload an image that is at least ${minSize}x${minSize} pixels.`,
    };
    const onCropComplete = useCallback((_croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    }, []);
    const showCroppedImageAsync = () => __awaiter(this, void 0, void 0, function* () {
        try {
            if (!imageSrc || !croppedAreaPixels)
                throw new Error('Missing imageSrc or croppedAreaPixels');
            const croppedImage = yield getCroppedImg(imageSrc, croppedAreaPixels, outputAsFile, filename);
            if (croppedImage) {
                yield onSave(croppedImage);
                setFilename(undefined);
                setImageSrc(undefined);
            }
            else {
                console.log('unable to generate image');
            }
        }
        catch (e) {
            console.error(e);
        }
    });
    const showCroppedImage = useCallback(() => {
        void showCroppedImageAsync();
    }, [imageSrc, croppedAreaPixels]);
    const inputFileRef = useRef(null);
    const onFileChangeAsync = (e) => __awaiter(this, void 0, void 0, function* () {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            setFilename(file.name.split('.')[0]);
            if (file.size > maxFileSize) {
                onError(messages.imageFileSizeTooLarge);
                return;
            }
            const imageDataUrl = yield readFile(file);
            const img = yield getImage(file);
            if (img && (img.width < minSize || img.height < minSize)) {
                onError(messages.imageSizeTooSmall);
                return;
            }
            if (imageDataUrl)
                setImageSrc(imageDataUrl);
        }
    });
    // Proxy function to satisfy TS return value
    const onFileChange = (e) => {
        void onFileChangeAsync(e);
    };
    const onCloseInternal = () => {
        setImageSrc(undefined);
        onClose();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, Object.assign({}, childrenBoxProps, { onClick: () => {
                var _a;
                (_a = inputFileRef.current) === null || _a === void 0 ? void 0 : _a.click();
            } }), children),
        React.createElement("input", { type: "file", ref: inputFileRef, onInput: onFileChange, accept: "image/*", style: { visibility: 'hidden', position: 'absolute' } }),
        errorMessage ? (React.createElement(React.Fragment, null,
            React.createElement(Dialog, { open: true, onClose: onCloseInternal, maxWidth: "xs", fullScreen: fullScreen },
                React.createElement(DialogTitle, { id: "form-dialog-title" },
                    React.createElement(Typography, { variant: "h4", style: { color: theme.palette.warning.main } }, "Something Went Wrong")),
                React.createElement(DialogContent, null, errorMessage),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { id: getControlId({ type: 'button', name: 'ok' }), variant: "contained", color: "secondary", onClick: onCloseInternal }, "OK"))))) : (React.createElement(React.Fragment, null,
            React.createElement(Dialog, { scroll: "body", open: Boolean(imageSrc), onClose: onCloseInternal, fullWidth: true, fullScreen: fullScreen, PaperProps: {
                    style: {
                        verticalAlign: 'top',
                    },
                }, "aria-labelledby": "form-dialog-title" },
                React.createElement(DialogTitle, { id: "form-dialog-title" },
                    React.createElement(Typography, { variant: "h4" }, "Crop Photo"),
                    React.createElement(IconButton, { id: getControlId({ type: 'button', name: 'close-dialog' }), onClick: onCloseInternal },
                        React.createElement(CloseRounded$1, null))),
                React.createElement(DialogContent, null,
                    React.createElement("div", null,
                        React.createElement("div", { className: classes.cropContainer },
                            React.createElement(Cropper, { image: imageSrc, crop: crop, zoom: zoom, aspect: 1, cropShape: "round", onCropChange: setCrop, onCropComplete: onCropComplete, onZoomChange: setZoom })),
                        React.createElement(Box, { className: classes.sliderContainer, px: fullScreen ? 4 : 14, py: 4, pb: 1 },
                            React.createElement(Typography, { variant: "h6", component: "span", color: "primary" }, "Zoom"),
                            React.createElement(Slider, { color: "secondary", size: "small", value: zoom, min: 1, max: 3, step: 0.1, "aria-labelledby": "Zoom", onChange: (_e, zoom) => {
                                    const z = typeof zoom === 'number' ? zoom : zoom[0];
                                    setZoom(z);
                                } })),
                        cropperChildren)),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { variant: "text", onClick: onCloseInternal }, "Cancel"),
                    React.createElement(Button, { type: "submit", id: getControlId({ type: 'button', name: 'submit' }), variant: "contained", color: "primary", disabled: !saveButtonEnabled, onClick: showCroppedImage }, "Save")))))));
}

// ES6 Map
var map;
try {
  map = Map;
} catch (_) { }
var set;

// ES6 Set
try {
  set = Set;
} catch (_) { }

function baseClone (src, circulars, clones) {
  // Null/undefined/functions/etc
  if (!src || typeof src !== 'object' || typeof src === 'function') {
    return src
  }

  // DOM Node
  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true)
  }

  // Date
  if (src instanceof Date) {
    return new Date(src.getTime())
  }

  // RegExp
  if (src instanceof RegExp) {
    return new RegExp(src)
  }

  // Arrays
  if (Array.isArray(src)) {
    return src.map(clone)
  }

  // ES6 Maps
  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()))
  }

  // ES6 Sets
  if (set && src instanceof set) {
    return new Set(Array.from(src.values()))
  }

  // Object
  if (src instanceof Object) {
    circulars.push(src);
    var obj = Object.create(src);
    clones.push(obj);
    for (var key in src) {
      var idx = circulars.findIndex(function (i) {
        return i === src[key]
      });
      obj[key] = idx > -1 ? clones[idx] : baseClone(src[key], circulars, clones);
    }
    return obj
  }

  // ???
  return src
}

function clone (src) {
  return baseClone(src, [], [])
}

const toString$2 = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString$1 = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString$1.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString$2.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} must be defined'
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must have ${length} items'
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
});

/** Used for built-in method references. */

var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas$1(object, key) {
  return object != null && hasOwnProperty$9.call(object, key);
}

var _baseHas = baseHas$1;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$8 = Array.isArray;

var isArray_1 = isArray$8;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$8 = freeGlobal || freeSelf || Function('return this')();

var _root = root$8;

var root$7 = _root;

/** Built-in value references. */
var Symbol$5 = root$7.Symbol;

var _Symbol = Symbol$5;

var Symbol$4 = _Symbol;

/** Used for built-in method references. */
var objectProto$b = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$b.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$4 ? Symbol$4.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$8.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$a = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$a.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$3 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$3 ? Symbol$3.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$5(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$5;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$5(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$5;

var baseGetTag$4 = _baseGetTag,
    isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$3(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$4(value) && baseGetTag$4(value) == symbolTag$1);
}

var isSymbol_1 = isSymbol$3;

var isArray$7 = isArray_1,
    isSymbol$2 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$7(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$2(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$3(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$3;

var baseGetTag$3 = _baseGetTag,
    isObject$2 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject$2(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$3(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

var root$6 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$6['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$1 = isFunction_1,
    isMasked = _isMasked,
    isObject$1 = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$9 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$7).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$6(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$6.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$5.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$2(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$2;

var eq$1 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var getNative$5 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$5(root$5, 'Map');

var _Map = Map$4;

var Hash = _Hash,
    ListCache$3 = _ListCache,
    Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$3 || ListCache$3),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;

var MapCache$2 = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$2);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache$2;

var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$1(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$1;

var Symbol$2 = _Symbol,
    arrayMap = _arrayMap,
    isArray$6 = isArray_1,
    isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$6(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString$1) + '';
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$1;

var isArray$5 = isArray_1,
    isKey$2 = _isKey,
    stringToPath = _stringToPath,
    toString = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$2(value, object) {
  if (isArray$5(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString(value));
}

var _castPath = castPath$2;

var baseGetTag$2 = _baseGetTag,
    isObjectLike$3 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$3(value) && baseGetTag$2(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$2 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$2 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$2(value) && hasOwnProperty$4.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$2;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$2(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$2;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength$3;

var isSymbol = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$4(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _toKey = toKey$4;

var castPath$1 = _castPath,
    isArguments$1 = isArguments_1,
    isArray$4 = isArray_1,
    isIndex$1 = _isIndex,
    isLength$2 = isLength_1,
    toKey$3 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$2(object, path, hasFunc) {
  path = castPath$1(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$3(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$2(length) && isIndex$1(key, length) &&
    (isArray$4(object) || isArguments$1(object));
}

var _hasPath = hasPath$2;

var baseHas = _baseHas,
    hasPath$1 = _hasPath;

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath$1(object, path, baseHas);
}

var has_1 = has;

var has$1 = /*@__PURE__*/getDefaultExportFromCjs(has_1);

const isSchema = obj => obj && obj.__isYupSchema__;

class Condition {
  constructor(refs, options) {
    this.fn = void 0;
    this.refs = refs;
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!has$1(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);

    this.fn = function (...args) {
      let options = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  resolve(base, options) {
    let values = this.refs.map(ref => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }

}

function toArray(value) {
  return value == null ? [] : [].concat(value);
}

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends$3({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }

  static isError(err) {
    return err && err.name === 'ValidationError';
  }

  constructor(errorOrErrors, value, field, type) {
    super();
    this.value = void 0;
    this.path = void 0;
    this.type = void 0;
    this.errors = void 0;
    this.params = void 0;
    this.inner = void 0;
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }

}

const once = cb => {
  let fired = false;
  return (...args) => {
    if (fired) return;
    fired = true;
    cb(...args);
  };
};

function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }

        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }

        nestedErrors.push(err);
      }

      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push(...errors);
          errors = nestedErrors;
        }

        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }

        callback(null, value);
      }
    });
  }
}

var getNative$4 = _getNative;

var defineProperty$1 = (function() {
  try {
    var func = getNative$4(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty$1;

var defineProperty = _defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$1(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$1;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$1 = createBaseFor();

var _baseFor = baseFor$1;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

var isBuffer$2 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

isBuffer$2.exports;

(function (module, exports) {
	var root = _root,
	    stubFalse = stubFalse_1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	module.exports = isBuffer; 
} (isBuffer$2, isBuffer$2.exports));

var isBufferExports = isBuffer$2.exports;

var baseGetTag$1 = _baseGetTag,
    isLength$1 = isLength_1,
    isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag = '[object Function]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    weakMapTag$1 = '[object WeakMap]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] =
typedArrayTags[dataViewTag$2] = typedArrayTags[dateTag$1] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag] =
typedArrayTags[mapTag$2] = typedArrayTags[numberTag$1] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$1] =
typedArrayTags[setTag$2] = typedArrayTags[stringTag$1] =
typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) &&
    isLength$1(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$1(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$1;

var _nodeUtil = {exports: {}};

_nodeUtil.exports;

(function (module, exports) {
	var freeGlobal = _freeGlobal;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil; 
} (_nodeUtil, _nodeUtil.exports));

var _nodeUtilExports = _nodeUtil.exports;

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$2;

var baseTimes = _baseTimes,
    isArguments = isArguments_1,
    isArray$3 = isArray_1,
    isBuffer$1 = isBufferExports,
    isIndex = _isIndex,
    isTypedArray$1 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$3(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$1;

/** Used for built-in method references. */

var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$1(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

  return value === proto;
}

var _isPrototype = isPrototype$1;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$1(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$1;

var overArg = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$1;

var isFunction = isFunction_1,
    isLength = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$1(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

var isArrayLike_1 = isArrayLike$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$3(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

var keys_1 = keys$3;

var baseFor = _baseFor,
    keys$2 = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$1(object, iteratee) {
  return object && baseFor(object, iteratee, keys$2);
}

var _baseForOwn = baseForOwn$1;

var ListCache$2 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$2;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

var ListCache$1 = _ListCache,
    Map$2 = _Map,
    MapCache$1 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$2(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$2.prototype.clear = stackClear;
Stack$2.prototype['delete'] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;

var _Stack = Stack$2;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;

var _SetCache = SetCache$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

var root$4 = _root;

/** Built-in value references. */
var Uint8Array$1 = root$4.Uint8Array;

var _Uint8Array = Uint8Array$1;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var Symbol$1 = _Symbol,
    Uint8Array = _Uint8Array,
    eq = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$1:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$1:
      var convert = mapToArray;

    case setTag$1:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$1(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$1;

var arrayPush = _arrayPush,
    isArray$2 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$2(object) ? result : arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$1;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$1() {
  return [];
}

var stubArray_1 = stubArray$1;

var arrayFilter = _arrayFilter,
    stubArray = stubArray_1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$2.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols$1;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys$1 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys$1, getSymbols);
}

var _getAllKeys = getAllKeys$1;

var getAllKeys = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$3 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative$3(root$3, 'DataView');

var _DataView = DataView$1;

var getNative$2 = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$2(root$2, 'Promise');

var _Promise = Promise$2;

var getNative$1 = _getNative,
    root$1 = _root;

/* Built-in method references that are verified to be native. */
var Set$2 = getNative$1(root$1, 'Set');

var _Set = Set$2;

var getNative = _getNative,
    root = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root, 'WeakMap');

var _WeakMap = WeakMap$1;

var DataView = _DataView,
    Map$1 = _Map,
    Promise$1 = _Promise,
    Set$1 = _Set,
    WeakMap = _WeakMap,
    baseGetTag = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$1 = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map$1 && getTag$1(new Map$1) != mapTag) ||
    (Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag$1(new Set$1) != setTag) ||
    (WeakMap && getTag$1(new WeakMap) != weakMapTag)) {
  getTag$1 = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

var _getTag = getTag$1;

var Stack$1 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag = _getTag,
    isArray$1 = isArray_1,
    isBuffer = isBufferExports,
    isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$1(object),
      othIsArr = isArray$1(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$1);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}

var _baseIsEqual = baseIsEqual$2;

var Stack = _Stack,
    baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

var castPath = _castPath,
    toKey$2 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$2(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$2(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$2;

var baseGet$1 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$1(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$1;

var baseIsEqual = _baseIsEqual,
    get = get_1,
    hasIn = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$1 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$1(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$1(value) {
  return value;
}

var identity_1 = identity$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity = identity_1,
    isArray = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$1(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$1;

var baseAssignValue = _baseAssignValue,
    baseForOwn = _baseForOwn,
    baseIteratee = _baseIteratee;

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

var mapValues_1 = mapValues;

var mapValues$1 = /*@__PURE__*/getDefaultExportFromCjs(mapValues_1);

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */

function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function () {
  this._size = 0;
  this._values = Object.create(null);
};
Cache.prototype.get = function (key) {
  return this._values[key]
};
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values)) this._size++;

  return (this._values[key] = value)
};

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512;

var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE);

var propertyExpr = {
  Cache: Cache,

  split: split,

  normalizePath: normalizePath,

  setter: function (path) {
    var parts = normalizePath(path);

    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0;
        var len = parts.length;
        var data = obj;

        while (index < len - 1) {
          var part = parts[index];
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }

          data = data[parts[index++]];
        }
        data[parts[index]] = value;
      })
    )
  },

  getter: function (path, safe) {
    var parts = normalizePath(path);
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length;
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]];
          else return
        }
        return data
      })
    )
  },

  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
  },
};

function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}

function split(path) {
  return path.match(SPLIT_REGEX) || ['']
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket;

  for (idx = 0; idx < len; idx++) {
    part = parts[idx];

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }

      isBracket = isQuoted(part);
      isArray = !isBracket && /^\d+$/.test(part);

      iter.call(thisArg, part, isBracket, isArray, idx, parts);
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}

const prefixes = {
  context: '$',
  value: '.'
};
class Reference {
  constructor(key, options = {}) {
    this.key = void 0;
    this.isContext = void 0;
    this.isValue = void 0;
    this.isSibling = void 0;
    this.path = void 0;
    this.getter = void 0;
    this.map = void 0;
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options.map;
  }

  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */


  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }

  resolve() {
    return this;
  }

  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }

  toString() {
    return `Ref(${this.key})`;
  }

  static isRef(value) {
    return value && value.__isYupRef;
  }

} // @ts-ignore

Reference.prototype.__isYupRef = true;

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = '',
      label,
      options,
      originalValue,
      sync
    } = _ref,
        rest = _objectWithoutPropertiesLoose$1(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;

    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }

    function createError(overrides = {}) {
      const nextParams = mapValues$1(_extends$2({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }

    let ctx = _extends$2({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);

    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(validOrError => {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        }).catch(cb);
      } catch (err) {
        cb(err);
      }

      return;
    }

    let result;

    try {
      var _ref2;

      result = test.call(ctx, value, ctx);

      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }

    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }

  validate.OPTIONS = config;
  return validate;
}

let trim = part => part.substr(0, part.length - 1).substr(1);

function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  propertyExpr.forEach(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });

    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

class ReferenceSet {
  constructor() {
    this.list = void 0;
    this.refs = void 0;
    this.list = new Set();
    this.refs = new Map();
  }

  get size() {
    return this.list.size + this.refs.size;
  }

  describe() {
    const description = [];

    for (const item of this.list) description.push(item);

    for (const [, ref] of this.refs) description.push(ref.describe());

    return description;
  }

  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }

  resolveAll(resolve) {
    return this.toArray().reduce((acc, e) => acc.concat(Reference.isRef(e) ? resolve(e) : e), []);
  }

  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }

  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }

  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }

  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach(value => next.add(value));
    newItems.refs.forEach(value => next.add(value));
    removeItems.list.forEach(value => next.delete(value));
    removeItems.refs.forEach(value => next.delete(value));
    return next;
  }

}

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

class BaseSchema {
  constructor(options) {
    this.deps = [];
    this.tests = void 0;
    this.transforms = void 0;
    this.conditions = [];
    this._mutate = void 0;
    this._typeError = void 0;
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.spec = void 0;
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = _extends$1({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove


  get _type() {
    return this.type;
  }

  _typeCheck(_value) {
    return true;
  }

  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    } // if the nested value is a schema we can skip cloning, since
    // they are already immutable


    const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = _extends$1({}, this.exclusiveTests); // @ts-expect-error this is readonly

    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone(_extends$1({}, this.spec, spec));
    return next;
  }

  label(label) {
    let next = this.clone();
    next.spec.label = label;
    return next;
  }

  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  } // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }


  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }

  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();

    const mergedSpec = _extends$1({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
    //   mergedSpec.nullable = base.spec.nullable;
    // if (combined.spec.presence === UNSET)
    //   mergedSpec.presence = base.spec.presence;


    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)

    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
    // the deduping logic is consistent

    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    combined.transforms = [...base.transforms, ...combined.transforms];
    return combined;
  }

  isType(v) {
    if (this.spec.nullable && v === null) return true;
    return this._typeCheck(v);
  }

  resolve(options) {
    let schema = this;

    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema, condition) => condition.resolve(schema, options), schema);
      schema = schema.resolve(options);
    }

    return schema;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */


  cast(value, options = {}) {
    let resolvedSchema = this.resolve(_extends$1({
      value
    }, options));

    let result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }

    return result;
  }

  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn) => fn.call(this, value, rawValue, this), rawValue);

    if (value === undefined) {
      value = this.getDefault();
    }

    return value;
  }

  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;

    if (!strict) {
      // this._validating = true;
      value = this._cast(value, _extends$1({
        assert: false
      }, options)); // this._validating = false;
    } // value is cast, we can check if it meets type requirements


    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError) initialTests.push(this._typeError);
    let finalTests = [];
    if (this._whitelistError) finalTests.push(this._whitelistError);
    if (this._blacklistError) finalTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, err => {
      if (err) return void cb(err, value);
      runTests({
        tests: this.tests.concat(finalTests),
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }

  validate(value, options, maybeCb) {
    let schema = this.resolve(_extends$1({}, options, {
      value
    })); // callback case is for nested validations

    return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value) => {
      if (err) reject(err);else resolve(value);
    }));
  }

  validateSync(value, options) {
    let schema = this.resolve(_extends$1({}, options, {
      value
    }));
    let result;

    schema._validate(value, _extends$1({}, options, {
      sync: true
    }), (err, value) => {
      if (err) throw err;
      result = value;
    });

    return result;
  }

  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }

  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }

  _getDefault() {
    let defaultValue = this.spec.default;

    if (defaultValue == null) {
      return defaultValue;
    }

    return typeof defaultValue === 'function' ? defaultValue.call(this) : clone(defaultValue);
  }

  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }

  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }

    let next = this.clone({
      default: def
    });
    return next;
  }

  strict(isStrict = true) {
    let next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }

  _isPresent(value) {
    return value != null;
  }

  defined(message = mixed.defined) {
    return this.test({
      message,
      name: 'defined',
      exclusive: true,

      test(value) {
        return value !== undefined;
      }

    });
  }

  required(message = mixed.required) {
    return this.clone({
      presence: 'required'
    }).withMutation(s => s.test({
      message,
      name: 'required',
      exclusive: true,

      test(value) {
        return this.schema._isPresent(value);
      }

    }));
  }

  notRequired() {
    let next = this.clone({
      presence: 'optional'
    });
    next.tests = next.tests.filter(test => test.OPTIONS.name !== 'required');
    return next;
  }

  nullable(isNullable = true) {
    let next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }

  transform(fn) {
    let next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */


  test(...args) {
    let opts;

    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }

    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;

    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  }

  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }

    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(new Condition(deps, options));
    return next;
  }

  typeError(message) {
    let next = this.clone();
    next._typeError = createValidation({
      message,
      name: 'typeError',

      test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }

    });
    return next;
  }

  oneOf(enums, message = mixed.oneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: 'oneOf',

      test(value) {
        if (value === undefined) return true;
        let valids = this.schema._whitelist;
        let resolved = valids.resolveAll(this.resolve);
        return resolved.includes(value) ? true : this.createError({
          params: {
            values: valids.toArray().join(', '),
            resolved
          }
        });
      }

    });
    return next;
  }

  notOneOf(enums, message = mixed.notOneOf) {
    let next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: 'notOneOf',

      test(value) {
        let invalids = this.schema._blacklist;
        let resolved = invalids.resolveAll(this.resolve);
        if (resolved.includes(value)) return this.createError({
          params: {
            values: invalids.toArray().join(', '),
            resolved
          }
        });
        return true;
      }

    });
    return next;
  }

  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }

} // eslint-disable-next-line @typescript-eslint/no-unused-vars

// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;

for (const method of ['validate', 'validateSync']) BaseSchema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], _extends$1({}, options, {
    parent,
    path
  }));
};

for (const alias of ['equals', 'is']) BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;

for (const alias of ['not', 'nope']) BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;

BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;

const isAbsent = value => value == null;

let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

let isTrimmed = value => isAbsent(value) || value === value.trim();

let objStringTag = {}.toString();
function create() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: 'string'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  }

  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }

  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;

    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }

    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      test: value => isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }

  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }

  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }

  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  } //-- transforms --


  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }

  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }

  lowercase(message = string.lowercase) {
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }

  uppercase(message = string.uppercase) {
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }

}
create.prototype = StringSchema.prototype; //
// String Interfaces
//

/* eslint-disable */

/**
 *
 * Date.parse with progressive enhancement for ISO 8601 <https://github.com/csnover/js-iso8601>
 * NON-CONFORMANT EDITION.
 * © 2011 Colin Snover <http://zetafleet.com>
 * Released under MIT license.
 */
//              1 YYYY                 2 MM        3 DD              4 HH     5 mm        6 ss            7 msec         8 Z 9 ±    10 tzHH    11 tzmm
var isoReg = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function parseIsoDate(date) {
  var numericKeys = [1, 4, 5, 6, 7, 10, 11],
      minutesOffset = 0,
      timestamp,
      struct;

  if (struct = isoReg.exec(date)) {
    // avoid NaN timestamps caused by “undefined” values being passed to Date.UTC
    for (var i = 0, k; k = numericKeys[i]; ++i) struct[k] = +struct[k] || 0; // allow undefined days and months


    struct[2] = (+struct[2] || 1) - 1;
    struct[3] = +struct[3] || 1; // allow arbitrary sub-second precision beyond milliseconds

    struct[7] = struct[7] ? String(struct[7]).substr(0, 3) : 0; // timestamps without timezone identifiers should be considered local time

    if ((struct[8] === undefined || struct[8] === '') && (struct[9] === undefined || struct[9] === '')) timestamp = +new Date(struct[1], struct[2], struct[3], struct[4], struct[5], struct[6], struct[7]);else {
      if (struct[8] !== 'Z' && struct[9] !== undefined) {
        minutesOffset = struct[10] * 60 + struct[11];
        if (struct[9] === '+') minutesOffset = 0 - minutesOffset;
      }

      timestamp = Date.UTC(struct[1], struct[2], struct[3], struct[4], struct[5] + minutesOffset, struct[6], struct[7]);
    }
  } else timestamp = Date.parse ? Date.parse(date) : NaN;

  return timestamp;
}

// @ts-ignore
let invalidDate = new Date('');

let isDate = obj => Object.prototype.toString.call(obj) === '[object Date]';
class DateSchema extends BaseSchema {
  constructor() {
    super({
      type: 'date'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        value = parseIsoDate(value); // 0 is a valid timestamp equivalent to 1970-01-01T00:00:00Z(unix epoch) or before.

        return !isNaN(value) ? new Date(value) : invalidDate;
      });
    });
  }

  _typeCheck(v) {
    return isDate(v) && !isNaN(v.getTime());
  }

  prepareParam(ref, name) {
    let param;

    if (!Reference.isRef(ref)) {
      let cast = this.cast(ref);
      if (!this._typeCheck(cast)) throw new TypeError(`\`${name}\` must be a Date or a value that can be \`cast()\` to a Date`);
      param = cast;
    } else {
      param = ref;
    }

    return param;
  }

  min(min, message = date.min) {
    let limit = this.prepareParam(min, 'min');
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return isAbsent(value) || value >= this.resolve(limit);
      }

    });
  }

  max(max, message = date.max) {
    let limit = this.prepareParam(max, 'max');
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value <= this.resolve(limit);
      }

    });
  }

}
DateSchema.INVALID_DATE = invalidDate;

var toposort$1 = {exports: {}};

/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

toposort$1.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
};

toposort$1.exports.array = toposort;

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes);

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  });

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set());
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch(e) {
        nodeRep = "";
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true;

    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);

    if (i = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i];
        visit(child, nodesHash.get(child), predecessors);
      } while (i)
      predecessors.delete(node);
    }

    sorted[--cursor] = node;
  }
}

function uniqueNodes(arr){
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res
}

const useStyles$4 = makeStyles((theme) => {
    return createStyles({
        chip: {
            marginRight: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
    });
});
const formatAndValidateValues = (values, textFieldValue) => {
    // Validator
    const email = create().email();
    // Combine with new values
    const vals = values.concat(textFieldValue
        // New lines, carriage returns and spaces become commas
        .replace(/(\r\n|\n|\r|\s)/gm, ',')
        // Delimit by said commas, accept empty values
        .split(',')
        // Remove empty values
        .filter((n) => Boolean(n)));
    // Dedupe and validate, convert to IEmailItems
    const componentVals = [...new Set(vals)].map((n) => {
        return {
            value: n,
            isValid: email.isValidSync(n),
        };
    });
    return componentVals;
};
const MultipleEmails = ({ onChange, textFieldProps, initialValues = [] }) => {
    const classes = useStyles$4();
    const [textFieldValue, setTextFieldValue] = useState('');
    const componentVals = formatAndValidateValues(initialValues, textFieldValue);
    const [componentValue, setComponentValue] = useState(componentVals);
    useEffect(() => {
        onChange(componentValue.map((n) => n.value));
    }, [componentValue]);
    const handleEnter = () => {
        const existingEmails = componentValue.map((n) => n.value);
        const componentVals = formatAndValidateValues(existingEmails, textFieldValue);
        setComponentValue(componentVals);
        setTimeout(() => {
            setTextFieldValue('');
        }, 0);
    };
    const onDelete = (i) => {
        const newComponentValue = [...componentValue];
        newComponentValue.splice(i, 1);
        setComponentValue(newComponentValue);
    };
    // Allow custom onBlur without overwriting component onBlur
    const onBlur = textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.onBlur;
    if (onBlur) {
        textFieldProps === null || textFieldProps === void 0 ? true : delete textFieldProps.onBlur;
    }
    return (React.createElement("div", null,
        React.createElement(TextField, Object.assign({ fullWidth: true, multiline: true, maxRows: 6, label: "Recipients*", value: textFieldValue, onChange: (e) => {
                setTextFieldValue(e.currentTarget.value);
            }, onKeyDown: (e) => {
                if (e.key === 'Enter') {
                    handleEnter();
                }
            }, onBlur: (e) => {
                if (onBlur && typeof onBlur === 'function') {
                    onBlur(e);
                }
                handleEnter();
            } }, textFieldProps)),
        React.createElement("div", null, componentValue.map((n, i) => (React.createElement(Chip, { size: "small", label: n.value, key: n.value, className: clsx(classes.chip, !n.isValid && 'colorErrorMain'), variant: "outlined", color: "secondary", deleteIcon: React.createElement(Close, null), onDelete: () => {
                onDelete(i);
            } }))))));
};

function PageLoading() {
    const theme = useTheme();
    const smUp = useMediaQuery(theme.breakpoints.up('sm'));
    return (React.createElement(Box, { display: "flex", justifyContent: "center" },
        React.createElement(Box, { mt: 15, width: smUp ? '400px' : '200px' },
            React.createElement(LinearProgress, null))));
}

const useStyles$3 = makeStyles((theme) => {
    return {
        root: {
            '& .phasePill': {
                height: 4,
                width: theme.spacing(5.5),
                borderRadius: '2px',
            },
        },
        label: {
            textAlign: 'center',
            marginBottom: theme.spacing(0.5),
        },
    };
});
const PhaseIndicator = ({ phase }) => {
    const classes = useStyles$3();
    const theme = useTheme();
    let phases = [];
    if (phase === 'Not Applicable') {
        return null;
    }
    if (phase === 'Phase 0' || phase === 'Early Phase 1') {
        phases.push('Phase 1');
    }
    else {
        phases = phase.split('/');
    }
    // Consider all phases to be in the past until we find an active one
    let future = false;
    // Studys have 4 phases
    const phaseDetails = Array(4)
        .fill({})
        .map((_n, i) => {
        // For a given phase, mark it active if it's in the list
        const active = phases.includes(`Phase ${i + 1}`);
        // Once we find an active phase, subsequent phases are in the future
        if (active) {
            future = true;
        }
        return {
            label: i + 1,
            active: active,
            past: !future,
        };
    });
    // If we haven't found an active phase, we have bad props and can't render
    if (future === false) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { display: "flex", className: classes.root }, phaseDetails.map((n) => {
            const pillLabelStyles = {
                color: theme.palette.grey[500],
            };
            const pillStyles = {
                backgroundColor: theme.palette.grey[300],
            };
            if (n.past) {
                pillStyles.backgroundColor = theme.palette.grey[700];
            }
            if (n.active) {
                pillStyles.backgroundColor = theme.palette.primary.main;
                pillLabelStyles.color = theme.palette.grey[800];
            }
            return (React.createElement(Box, { display: "flex", flexDirection: "column", mr: 0.5, key: n.label, className: "phaseContainer" },
                React.createElement(Box, { className: classes.label, flexGrow: 1, style: pillLabelStyles },
                    React.createElement(Typography, { variant: "body2", component: "div" },
                        React.createElement(Box, { component: "span", fontWeight: n.active ? '600' : 'normal' }, n.label))),
                React.createElement(Box, { height: "2px", className: "phasePill", style: pillStyles })));
        }))));
};

const useStyles$2 = makeStyles(() => {
    return {
        root: {
            position: 'relative',
        },
        readMoreLink: {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-end',
        },
    };
});
const ReadMore = ({ children, backgroundColorRgb = '255,255,255', toggleTextClosed = 'Read More', toggleTextOpen = 'Hide', showToggleTextOpen = true, }) => {
    const classes = useStyles$2();
    const [expanded, setExpanded] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { className: classes.root, pb: showToggleTextOpen && expanded ? 3 : 0 },
            React.createElement(Collapse, { in: expanded, collapsedSize: 150 }, children),
            !expanded && (React.createElement(Box, { className: classes.readMoreLink, style: {
                    backgroundColor: 'transparent',
                    backgroundImage: `linear-gradient(to bottom, rgba(${backgroundColorRgb},0) 25%, rgba(${backgroundColorRgb},1) 75%)`,
                } },
                React.createElement(Link, { href: "#", onClick: (e) => {
                        e.preventDefault();
                        setExpanded(true);
                    } }, toggleTextClosed))),
            showToggleTextOpen && expanded && (React.createElement(Box, { pt: 6, className: classes.readMoreLink, style: { top: 'unset' } },
                React.createElement(Link, { href: "#", onClick: (e) => {
                        e.preventDefault();
                        setExpanded(false);
                    } }, toggleTextOpen))))));
};

const useStyles$1 = makeStyles((theme) => {
    return {
        root: {
            display: 'inline-block',
            position: 'relative',
            bottom: 0,
            marginRight: theme.spacing(1),
        },
        dot: {
            background: theme.palette.info.main,
            borderRadius: '50%',
            width: 10,
            height: 10,
        },
        backgroundPrimary: {
            background: theme.palette.primary.main,
        },
        backgroundWarning: {
            background: theme.palette.warning.main,
        },
        backgroundErrorLight: {
            background: theme.palette.error.light,
        },
        backgroundErrorMain: {
            background: theme.palette.error.main,
        },
        backgroundSuccessMain: {
            background: theme.palette.success.main,
        },
        backgroundYellowMain: {
            background: theme.palette.gradients.yellow.main,
        },
        backgroundDisabled: {
            background: theme.palette.text.disabled,
        },
        small: {
            bottom: -1,
        },
        xSmall: {
            bottom: 0,
            width: 8,
            height: 8,
            marginRight: theme.spacing(0.75),
        },
        check: {
            width: 13.33,
            height: 13.33,
            bottom: -1,
            left: -1,
            marginRight: parseInt(theme.spacing(1), 10) - 3.33,
        },
        smallCheck: {
            bottom: -2,
        },
        xSmallCheck: {
            marginRight: parseInt(theme.spacing(1), 10) - 7,
            bottom: -1,
        },
    };
});
function Status(_a) {
    var { color, variant, size = 'large' } = _a, props = __rest(_a, ["color", "variant", "size"]);
    const classes = useStyles$1();
    const theme = useTheme();
    let colorCode = '';
    if (color === 'primary') {
        colorCode = theme.palette.primary.main;
    }
    else if (color === 'warning') {
        colorCode = theme.palette.warning.main;
    }
    else if (color === 'error.light') {
        colorCode = theme.palette.error.light;
    }
    else if (color === 'error.main') {
        colorCode = theme.palette.error.main;
    }
    else if (color === 'success.main') {
        colorCode = theme.palette.success.main;
    }
    else if (color === 'disabled') {
        colorCode = theme.palette.text.disabled;
    }
    else if (color === 'yellow.main') {
        colorCode = colors$1.yellow.main;
    }
    else {
        colorCode = theme.palette.info.main;
    }
    if (variant === 'checked') {
        return (React.createElement("div", Object.assign({ className: clsx(classes.root, classes.check, (size === 'small' || size === 'x-small') && classes.smallCheck, size === 'x-small' && classes.xSmallCheck) }, props),
            React.createElement(CheckCircleOutlineRounded, { style: {
                    width: size === 'x-small' ? 10 : 13.33,
                    height: size === 'x-small' ? 10 : 13.33,
                    color: colorCode,
                } })));
    }
    else {
        return (React.createElement("div", Object.assign({ className: clsx(classes.root, classes.dot, color === 'primary' && classes.backgroundPrimary, color === 'warning' && classes.backgroundWarning, color === 'error.light' && classes.backgroundErrorLight, color === 'error.main' && classes.backgroundErrorMain, color === 'success.main' && classes.backgroundSuccessMain, color === 'yellow.main' && classes.backgroundYellowMain, color === 'disabled' && classes.backgroundDisabled, size === 'small' && classes.small, size === 'x-small' && classes.xSmall) }, props)));
    }
}

/**
 * Generic basic TabPanel component for use with Tabs
 * see src/stories/Tabs.stories.tsx
 * https://material-ui.com/components/tabs/
 */
const TabPanel = ({ value, index, children, }) => {
    return React.createElement("div", { hidden: value !== index }, children);
};

const useStyles = makeStyles((theme) => {
    return {
        root: {},
        widthStyles: { minWidth: 272 },
        optionsBox: { maxHeight: 300, overflowY: 'auto' },
        actions: {
            display: 'flex',
        },
        chip: { marginRight: theme.spacing(1), marginBottom: theme.spacing(1) },
    };
});
const renderOption = (option, internalValue, onChange) => {
    const label = option;
    const optionValue = option;
    let checked = false;
    checked = Boolean(internalValue.includes(optionValue));
    return (React.createElement(FormControlLabel, { style: { flexGrow: 1, padding: '6px 16px' }, control: React.createElement(Checkbox, { style: { padding: '0px 8px' }, checked: checked, onChange: onChange }), label: label }));
};
const TagSelector = ({ options, id = 'specialties', label = 'Add Specialties', inputPlaceholder = 'Search for Specialties', noOptionsText = 'No options', clearText = 'Cancel', doneText = 'Apply', onChange, onSearchFilterChange, onClose, onClear, optionsLoading, value = [], }) => {
    const classes = useStyles();
    const theme = useTheme$1();
    // State
    const [internalValue, setInternalValue] = useState([...value]);
    const [searchFilter, setSearchFilter] = useState('');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    useEffect(() => {
        // Don't search until menu is open
        if (!open)
            return;
        onSearchFilterChange && onSearchFilterChange(searchFilter || '');
    }, [searchFilter, open]);
    const handleToggleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        if (typeof onClose !== 'undefined')
            onClose();
    };
    return (React.createElement(Box, { className: classes.root },
        value.map((n, i) => (React.createElement(Chip, { label: n, key: i, variant: "outlined", color: "primary", className: clsx(classes.chip), deleteIcon: React.createElement(Close, null), onDelete: () => {
                const updatedValue = [...value];
                updatedValue.splice(updatedValue.findIndex((val) => n === val), 1);
                setInternalValue(updatedValue);
                onChange && onChange(updatedValue);
            } }))),
        React.createElement(Chip, { label: label, color: "primary", className: clsx('filled', classes.chip), deleteIcon: React.createElement(ArrowDropDownRounded, null), onDelete: handleToggleClick, onClick: handleToggleClick }),
        React.createElement(Menu, { anchorEl: anchorEl, open: open, id: getControlId({ type: 'select', name: label }), anchorOrigin: {
                vertical: 45,
                horizontal: 'left',
            }, onClose: handleClose },
            React.createElement(Box, { mx: 2, mb: 0.5, className: classes.widthStyles },
                React.createElement(TextField, { id: getControlId({ type: 'search', name: `search-${id}` }), margin: "dense", fullWidth: true, autoFocus: true, value: searchFilter, placeholder: inputPlaceholder, onChange: (e) => {
                        setSearchFilter(e.currentTarget.value || '');
                    }, InputProps: {
                        endAdornment: (React.createElement(InputAdornment, { position: "end" },
                            React.createElement(SearchRounded, null))),
                    } })),
            React.createElement(Box, { className: clsx(classes.widthStyles, classes.optionsBox) }, optionsLoading ? (React.createElement(Box, { my: 14, textAlign: "center", style: { color: theme.palette.grey[500] } }, "Loading...")) : (React.createElement(React.Fragment, null,
                !options.length && (React.createElement(Box, { my: 14, textAlign: "center", fontWeight: "bold", style: { color: theme.palette.grey[500] } }, noOptionsText)),
                options.map((n, i) => (React.createElement(MenuItem, { style: { display: 'flex', padding: 0 }, key: i }, renderOption(n, internalValue, (_, checked) => {
                    if (checked) {
                        setInternalValue([...internalValue, n]);
                    }
                    else {
                        const updatedInternalValue = [...internalValue];
                        updatedInternalValue.splice(updatedInternalValue.findIndex((val) => n === val), 1);
                        setInternalValue(updatedInternalValue);
                    }
                }))))))),
            React.createElement(Box, { mt: 1 },
                React.createElement(Divider, null)),
            React.createElement(Box, { px: 2, py: 1, className: classes.actions },
                React.createElement(Box, { flexGrow: 1, pt: 1.25, style: { textAlign: 'right' } }, internalValue.length > 0 && (React.createElement(Link, { id: getControlId({ type: 'link', name: `clear-${id}` }), style: { textDecoration: 'none', cursor: 'pointer' }, className: "MuiTypography-body2", onClick: () => {
                        setInternalValue([...value]);
                        onClear && onClear();
                        handleClose();
                    } }, clearText))),
                React.createElement(Box, { ml: 2, pt: 1 },
                    React.createElement(Button, { id: getControlId({ type: 'button', name: `done-${id}` }), variant: "contained", color: "primary", size: "small", onClick: () => {
                            onChange && onChange(internalValue);
                            handleClose();
                        } }, doneText))))));
};

const UserAvatar = ({ userFirstName, userLastName, imageUrl, imageAlt, avatarSize = 20, additionalStyles = null, }) => {
    const theme = useTheme();
    return (React.createElement(Avatar, { src: imageUrl || '', alt: imageAlt, sx: {
            backgroundColor: colors$1.orange2.light,
            color: theme.palette.grey[500],
            height: theme.spacing(12),
            width: theme.spacing(12),
            border: imageUrl ? 'none' : `1px solid ${colors$1.orange2.dark}`,
            '& .MuiSvgIcon-root': {
                fontSize: '4rem',
            },
            [theme.breakpoints.up('md')]: {
                height: theme.spacing(20),
                width: theme.spacing(20),
                '& .MuiSvgIcon-root': {
                    fontSize: '7rem',
                },
            },
        }, style: Object.assign({ height: theme.spacing(avatarSize), width: theme.spacing(avatarSize), fontWeight: 700, color: !imageUrl ? theme.palette.grey[1000] : theme.palette.grey[500], background: !imageUrl ? colors$1.orange2.light : 'none', fontSize: getAvatarFontSize(avatarSize) }, additionalStyles) }, getInitials(userFirstName, userLastName)));
};

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

const _excluded = ["values", "unit", "step"];
const sortBreakpointsValues = values => {
  const breakpointsAsArray = Object.keys(values).map(key => ({
    key,
    val: values[key]
  })) || [];
  // Sort in ascending order
  breakpointsAsArray.sort((breakpoint1, breakpoint2) => breakpoint1.val - breakpoint2.val);
  return breakpointsAsArray.reduce((acc, obj) => {
    return _extends({}, acc, {
      [obj.key]: obj.val
    });
  }, {});
};

// Keep in mind that @media is inclusive by the CSS specification.
function createBreakpoints(breakpoints) {
  const {
      // The breakpoint **start** at this value.
      // For instance with the first breakpoint xs: [xs, sm).
      values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
      },

      unit = 'px',
      step = 5
    } = breakpoints,
    other = _objectWithoutPropertiesLoose(breakpoints, _excluded);
  const sortedValues = sortBreakpointsValues(values);
  const keys = Object.keys(sortedValues);
  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }
  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }
  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }
  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }
    return up(key);
  }
  function not(key) {
    // handle first and last key separately, for better readability
    const keyIndex = keys.indexOf(key);
    if (keyIndex === 0) {
      return up(keys[1]);
    }
    if (keyIndex === keys.length - 1) {
      return down(keys[keyIndex]);
    }
    return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
  }
  return _extends({
    keys,
    values: sortedValues,
    up,
    down,
    between,
    only,
    not,
    unit
  }, other);
}

const breakpoints$1 = {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
    },
};

/* IMPORTANT: changes to this theme will potentially be reflected in
the VSP theme as well, the VSP theme inherits this theme fully and just
overrides some properties.
See theme/vsp/theme.ts and theme/vspTheme.tsx for more details
*/
const breakpoints = createBreakpoints(Object.assign({}, breakpoints$1));
// Create a theme instance.
const themeDefinition = {
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                html: {
                    // CTV-2775
                    MozTextSizeAdjust: 'none',
                    WebkitTextSizeAdjust: 'none',
                    textSizeAdjust: 'none',
                },
                body: {
                    fontSize: '0.875rem',
                    lineHeight: 1.285714,
                    backgroundColor: colors$1.common.white,
                    color: colors$1.grey[800],
                },
                '.MuiChip-root.indicator': {
                    backgroundColor: colors$1.green.main,
                    fontSize: '0.876rem',
                    lineHeight: 1.428571,
                    color: colors$1.common.white,
                    fontWeight: 'bold',
                },
                '.MuiChip-root.colorErrorMain': {
                    color: colors$1.red.main,
                    '&[class*="MuiChip-outlined"]': {
                        borderColor: colors$1.red.main,
                        '& .MuiSvgIcon-root': {
                            color: colors$1.red.main,
                        },
                    },
                },
                '.MuiChip-root.filled, .MuiChip-filled': {
                    color: colors$1.grey[1000],
                    background: colors$1.orange.main,
                    cursor: 'pointer',
                    fontWeight: 500,
                    border: `1px solid ${colors$1.grey[800]}`,
                    '& .MuiSvgIcon-root': {
                        color: colors$1.grey[1000],
                        fontSize: 16,
                    },
                    '&:hover': {
                        background: colors$1.orange.light,
                        border: `1px solid ${colors$1.grey[700]}`,
                    },
                    '&:focus': {
                        background: colors$1.orange.dark,
                        border: `1px solid ${colors$1.grey[900]}`,
                    },
                    '&.lilac': {
                        border: 'none',
                        background: '#F1EAFF',
                    },
                    '&.purple': {
                        border: 'none',
                        background: colors$1.purple.dark,
                        color: colors$1.common.white,
                        fontWeight: 700,
                        '& .MuiSvgIcon-root': {
                            color: colors$1.common.white,
                        },
                    },
                    '&.siteBlue': {
                        border: 'none',
                        background: colors$1.navyBlue.dark,
                        color: colors$1.common.white,
                        '& .MuiSvgIcon-root': {
                            color: colors$1.common.white,
                        },
                        '&:hover': {
                            background: colors$1.navyBlue.light,
                        },
                    },
                },
                '.MuiChip-colorSecondary.filled, .MuiChip-colorSecondary.MuiChip-filled': {
                    color: colors$1.common.white,
                    background: colors$1.gradients.blue.main,
                    cursor: 'pointer',
                    '& .MuiSvgIcon-root': {
                        color: colors$1.grey[1000],
                    },
                    '&:hover': {
                        background: colors$1.gradients.blue.light,
                    },
                    '&:focus': {
                        background: colors$1.gradients.blue.main,
                    },
                },
                '.MuiChip-colorInfo.filled, .MuiChip-colorInfo.MuiChip-filled': {
                    color: colors$1.grey[1000],
                    background: colors$1.grey[100],
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: 500,
                    '& .MuiSvgIcon-root': {
                        color: colors$1.grey[1000],
                    },
                    '&:hover': {
                        background: colors$1.grey[100],
                        border: 'none',
                        color: colors$1.grey[700],
                    },
                    '&:focus': {
                        background: colors$1.grey[200],
                        border: 'none',
                    },
                },
                '.MuiChip-colorWarning.filled, .MuiChip-colorWarning.MuiChip-filled': {
                    color: colors$1.grey[1000],
                    background: colors$1.orange2.light,
                    fontWeight: 500,
                    border: 'none',
                    cursor: 'pointer',
                    '& .MuiSvgIcon-root': {
                        color: colors$1.grey[1000],
                    },
                    '&:hover': {
                        background: colors$1.orange2.main,
                        border: 'none',
                    },
                    '&:focus': {
                        background: colors$1.orange2.dark,
                        border: 'none',
                    },
                },
                '.MuiChip-colorError.MuiChip-filled': {
                    background: '#FFC7C7 !important',
                    border: 'none',
                },
                '.MuiChip-colorSuccess.filled, .MuiChip-colorSuccess.MuiChip-filled': {
                    color: colors$1.grey[1000],
                    background: colors$1.green.light,
                    fontWeight: 500,
                    border: 'none',
                    cursor: 'pointer',
                    '& .MuiSvgIcon-root': {
                        color: colors$1.grey[1000],
                    },
                },
                '.muicc-colorbox-hsvgradient': {
                    '& > div': {
                        borderRadius: '8px',
                        overflow: 'hidden',
                    },
                },
                '.ColorPicker-MuiSlider-rail': {
                    borderRadius: '8px !important;',
                },
                '.ColorPicker-MuiSlider-thumb': {
                    backgroundColor: 'transparent !important;',
                    border: `2px solid ${colors$1.common.white}`,
                },
                '.muicc-colorinput-raw': {
                    marginTop: '13px !important',
                },
                '.muicc-colorbox-inputs': {
                    padding: '5px 4px 8px 8px !important;',
                },
                '.muicc-colorbox-input': {
                    marginTop: '0 !important',
                },
                '.muicc-colorinput-label': {
                    left: '2px !important',
                },
                '.muicc-colorbox-sliders': {
                    padding: '0px 8px 0px 8px !important;',
                },
                '.muicc-colorbox-controls': {
                    '& button': {
                        padding: '4px 12px',
                        '& svg': {
                            fill: colors$1.common.black,
                        },
                        '&:disabled svg': {
                            fill: colors$1.grey[300],
                        },
                        background: colors$1.orange.main,
                        backgroundColor: colors$1.orange.main,
                        color: colors$1.grey[1000],
                        fontWeight: 500,
                        '&:disabled': {
                            background: colors$1.grey[100],
                        },
                        '&:hover': {
                            background: colors$1.orange.light,
                        },
                        '&:active': {
                            background: colors$1.orange.dark,
                        },
                    },
                },
                '.MuiPickersToolbar-root': {
                    background: colors$1.orange.main,
                    color: colors$1.grey[1000],
                    '& .MuiTypography-overline': {
                        color: colors$1.grey[1000],
                    },
                    '& .MuiPickersToolbar-penIconButton': {
                        display: 'none',
                    },
                },
                '.PrivatePickersYear-root': {
                    '& button': {
                        '&.Mui-selected': {
                            background: colors$1.orange.main,
                            backgroundColor: colors$1.orange.main,
                            '&:hover': {
                                backgroundColor: colors$1.orange.dark,
                            },
                            '&:focus': {
                                backgroundColor: colors$1.orange.main,
                            },
                        },
                    },
                },
            },
        },
        MuiAlert: {
            defaultProps: {
                severity: 'info',
                variant: 'outlined',
            },
            styleOverrides: {
                root: {
                    padding: 8,
                },
                outlinedInfo: {
                    background: '#F1F4F9',
                    borderColor: colors$1.blue.main,
                    borderWidth: 2,
                },
                icon: {
                    paddingTop: 0,
                    paddingRight: 10,
                    '& svg': {
                    // @FIXME: there's no way to change the background color _within_ the icon
                    // the below approach works but leaves a blurred edge
                    // background: '#DEEAF7',
                    // borderRadius: '50%',
                    },
                },
                message: {
                    padding: 0,
                    fontWeight: 400,
                    fontSize: '0.75rem',
                    lineHeight: 1.333333,
                },
                action: {
                    alignItems: 'start',
                    '& .MuiSvgIcon-fontSizeSmall': {
                        fontSize: '1.5rem',
                    },
                    '& .MuiButtonBase-root': {
                        paddingTop: 0,
                    },
                },
            },
        },
        MuiBadge: {
            styleOverrides: {
                badge: {
                    fontSize: '.625rem',
                    minWidth: '13px',
                    height: '13px',
                    padding: '1px 4px 0',
                    color: colors$1.grey[800],
                },
            },
        },
        MuiPaginationItem: {
            styleOverrides: {
                textSecondary: {
                    '&.Mui-selected': {
                        background: colors$1.gradients.blue.main,
                    },
                },
                page: {
                    transition: 'none',
                },
            },
        },
        MuiSnackbarContent: {
            styleOverrides: {
                root: {
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    backgroundColor: colors$1.grey[700],
                    color: colors$1.grey[100],
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                },
            },
        },
        MuiStepIcon: {
            styleOverrides: {
                root: {
                    color: colors$1.grey[500],
                    '&.Mui-active, &.Mui-completed': {
                        color: colors$1.blue.main,
                    },
                },
            },
        },
        MuiStepLabel: {
            styleOverrides: {
                root: {
                    '& .MuiStepLabel-label.Mui-completed, .MuiStepLabel-label.Mui-active': {
                        color: colors$1.blue.main,
                    },
                },
            },
        },
        MuiStepConnector: {
            styleOverrides: {
                line: {
                    borderColor: colors$1.grey[500],
                },
                root: {
                    '& .MuiStepConnector-lineHorizontal': {
                        borderTopWidth: 2,
                        borderRadius: 2,
                    },
                    '&.MuiStepConnector-active': {
                        '& .MuiStepConnector-line': {
                            borderColor: colors$1.blue.main,
                        },
                    },
                },
            },
        },
        MuiTableSortLabel: {
            styleOverrides: {
                root: {
                    color: colors$1.grey[500],
                    '&.MuiTableSortLabel-active': {
                        color: colors$1.grey[500],
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                root: {
                    verticalAlign: 'top',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    borderBottom: `1px solid ${colors$1.grey[100]}`,
                },
                stickyHeader: {
                    backgroundColor: 'inherit',
                },
            },
        },
        MuiTablePagination: {
            styleOverrides: {
                root: {
                    color: colors$1.grey[700],
                },
                selectRoot: {
                    border: `1px solid ${colors$1.grey[500]}`,
                    borderRadius: 8,
                    height: 24,
                    minWidth: 54,
                    paddingRight: 2,
                    '& .MuiTablePagination-select': {
                        paddingRight: 28,
                    },
                },
                input: {
                    marginRight: 10,
                },
                selectIcon: {
                    marginRight: 2,
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: '#F1F4F9',
                    color: colors$1.grey[800],
                },
            },
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    textShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                },
                fallback: {
                    fill: colors$1.grey[500],
                },
            },
        },
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiButton: {
            defaultProps: {
                color: 'inherit',
            },
            styleOverrides: {
                root: {
                    color: colors$1.grey[800],
                    boxShadow: 'none',
                    padding: '4px 12px',
                    backgroundColor: 'transparent',
                    transition: 'none',
                    '& svg': {
                        fill: colors$1.grey[800],
                    },
                    '&:disabled svg': {
                        fill: colors$1.grey[300],
                    },
                    // Wrap in MQ to prevent sticky hover on touch devices
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: 'none',
                            color: colors$1.grey[600],
                        },
                    },
                    '&:active': {
                        backgroundColor: 'none',
                        color: colors$1.grey[1000],
                    },
                },
                text: {
                    fontWeight: 500,
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: 'transparent',
                            '& svg': {
                                fill: colors$1.grey[600],
                            },
                        },
                    },
                    '&:disabled': {
                        backgroundColor: 'transparent !important',
                    },
                },
                textInfo: {
                    backgroundColor: 'transparent',
                    color: colors$1.blue2.main,
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: 'transparent',
                            color: colors$1.blue2.light,
                            '& svg': {
                                fill: colors$1.blue2.light,
                            },
                        },
                    },
                    '&:active': {
                        color: colors$1.blue2.dark,
                        '& svg': {
                            fill: colors$1.blue2.dark,
                        },
                    },
                    '& svg': {
                        fill: colors$1.blue2.main,
                    },
                },
                textWarning: {
                    backgroundColor: 'transparent',
                    color: colors$1.red.main,
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: 'transparent',
                            color: colors$1.red.light,
                            '& svg': {
                                fill: colors$1.red.light,
                            },
                        },
                    },
                    '&:active': {
                        color: colors$1.red.dark,
                        '& svg': {
                            fill: colors$1.red.dark,
                        },
                    },
                    '& svg': {
                        fill: colors$1.red.main,
                    },
                },
                contained: {
                    backgroundColor: colors$1.grey[50],
                    boxShadow: 'none',
                    // Do all this, or add !important to the contained boxShadow
                    '@media (hover: hover)': {
                        '&:hover': {
                            boxShadow: 'none',
                        },
                    },
                    '&:active': {
                        boxShadow: 'none',
                    },
                    '&.Mui-focusVisible': {
                        boxShadow: 'none',
                    },
                    '& svg': {
                        fill: colors$1.blue.main,
                    },
                },
                containedInherit: {
                    color: colors$1.blue.main,
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: colors$1.grey[200],
                        },
                    },
                },
                containedPrimary: {
                    background: colors$1.orange.main,
                    // @FIXME: background gradient transitions aren't supported
                    // transition: 'background 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                    backgroundColor: colors$1.orange.main,
                    border: `1px solid ${colors$1.grey[800]}`,
                    '&:disabled': {
                        background: colors$1.grey[100],
                        borderColor: colors$1.orange2.dark,
                    },
                    '@media (hover: hover)': {
                        '&:hover': {
                            background: colors$1.orange.light,
                            '& svg': {
                                fill: colors$1.grey[600],
                            },
                        },
                    },
                    '&:active': {
                        background: colors$1.orange.dark,
                    },
                    '& svg': {
                        fill: colors$1.grey[1000],
                    },
                },
                containedWarning: {
                    background: colors$1.gradients.red.main,
                    backgroundColor: colors$1.red.main,
                    color: colors$1.common.white,
                    '&:disabled': {
                        background: colors$1.grey[100],
                    },
                    '@media (hover: hover)': {
                        '&:hover': {
                            color: colors$1.common.white,
                            background: colors$1.gradients.red.light,
                        },
                    },
                    '&:active': {
                        color: colors$1.common.white,
                        background: colors$1.gradients.red.dark,
                    },
                    '& svg': {
                        fill: colors$1.common.white,
                    },
                },
                containedInfo: {
                    background: colors$1.grey[100],
                    backgroundColor: colors$1.grey[100],
                    color: colors$1.blue2.main,
                    '&:disabled': {
                        background: colors$1.grey[100],
                        color: colors$1.grey[300],
                        '& svg': {
                            fill: colors$1.grey[300],
                        },
                    },
                    '@media (hover: hover)': {
                        '&:hover': {
                            background: colors$1.grey[100],
                            color: colors$1.blue2.light,
                            '& svg': {
                                fill: colors$1.blue2.light,
                            },
                        },
                    },
                    '&:active': {
                        background: colors$1.grey[200],
                        color: colors$1.blue2.dark,
                        '& svg': {
                            fill: colors$1.blue2.dark,
                        },
                    },
                    '& svg': {
                        fill: colors$1.blue2.main,
                    },
                },
                outlined: {
                    padding: '4px 12px',
                    border: `1px solid ${colors$1.grey[800]}`,
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: 'transparent',
                            borderColor: colors$1.grey[600],
                            '& svg': {
                                fill: colors$1.grey[600],
                            },
                        },
                    },
                    '&:active': {
                        borderColor: colors$1.grey[1000],
                    },
                },
                outlinedPrimary: {
                    '& svg': {
                        fill: colors$1.orange.main,
                    },
                },
                outlinedSecondary: {
                    '& svg': {
                        fill: colors$1.blue.main,
                    },
                },
                sizeMedium: {
                    fontSize: '0.875rem',
                    lineHeight: 1.285714,
                    padding: '7px 12px',
                    height: 32,
                },
                containedSizeSmall: {
                    padding: '4px 12px',
                    fontSize: '0.875rem',
                    lineHeight: '1.25rem',
                },
                containedSizeLarge: {
                    padding: '18px 16px',
                    fontSize: '1rem',
                    lineHeight: 1.25,
                    fontWeight: 700,
                },
                textSizeSmall: {
                    fontSize: '0.875rem',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    backgroundColor: colors$1.grey[50],
                    borderRadius: '8px',
                    border: `1px solid #F1ECE3`,
                    boxShadow: 'none',
                    transition: 'none',
                    '&.clickable': {
                        cursor: 'pointer',
                        border: `1px solid #F1ECE3`,
                        '&:hover': {
                            backgroundColor: colors$1.common.white,
                            border: `1px solid ${colors$1.grey[400]}`,
                        },
                    },
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: 14,
                    '&:last-child': {
                        paddingBottom: 14,
                    },
                },
            },
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    '&.studyCardFlag': {
                        backgroundColor: colors$1.purple.light,
                        height: '2.25rem',
                    },
                },
                title: {
                    '&.studyCardFlag': {
                        fontSize: '.875rem',
                        fontWeight: 700,
                        color: colors$1.purple.dark,
                    },
                },
            },
        },
        MuiCheckbox: {
            defaultProps: {
                color: 'primary',
                icon: React.createElement(CheckboxIcon, null),
                checkedIcon: React.createElement(CheckboxCheckedIcon, null),
                indeterminateIcon: React.createElement(CheckboxCheckedIndeterminateIcon, null),
            },
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: 'transparent !important',
                    },
                    '&.Mui-focusVisible .checkbox-icon': {
                        borderColor: colors$1.orange.main,
                    },
                },
                colorPrimary: {
                    '& svg': {
                        fill: colors$1.orange.main,
                    },
                },
            },
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    backgroundColor: colors$1.grey[100],
                    color: colors$1.grey[800],
                    borderRadius: '8px',
                    pointerEvents: 'none',
                    fontSize: '0.75rem',
                    lineHeight: 1.333333,
                },
                outlined: {
                    background: colors$1.common.white,
                },
                outlinedSecondary: {
                    color: colors$1.blue.main,
                    '&:hover': {
                        '& .MuiChip-deleteIcon': {
                            color: colors$1.blue.dark,
                        },
                    },
                    '& .MuiChip-deleteIcon': {
                        color: colors$1.blue.main,
                    },
                },
                colorPrimary: {
                    backgroundColor: colors$1.grey[100],
                    color: colors$1.grey[1000],
                },
                colorSecondary: {
                    backgroundColor: colors$1.grey[100],
                    color: colors$1.blue2.main,
                },
                clickable: {
                    pointerEvents: 'auto',
                    '&.MuiChip-clickableColorInfo': {
                        textDecoration: 'underline',
                    },
                },
                clickableColorPrimary: {
                    '&:hover': {
                        backgroundColor: 'transparent',
                        borderColor: colors$1.orange.light,
                    },
                    '&:focus': {
                        backgroundColor: 'transparent',
                        borderColor: colors$1.orange.dark,
                    },
                },
                clickableColorSecondary: {
                    '&:hover': {
                        backgroundColor: 'transparent',
                        '& svg': {
                            color: 'inherit',
                        },
                    },
                    '&:focus': {
                        backgroundColor: colors$1.grey[300],
                    },
                },
                deletableColorSecondary: {
                    '&:focus': {
                        background: 'rgba(45, 156, 219, 0.04)',
                    },
                },
                deleteIcon: {
                    cursor: 'pointer',
                    pointerEvents: 'auto',
                    color: colors$1.grey[800],
                    '&:hover': {
                        color: colors$1.grey[600],
                    },
                    '&:focus': {
                        color: colors$1.grey[1000],
                    },
                },
                deleteIconColorSecondary: {
                    color: colors$1.blue2.main,
                },
                sizeMedium: {
                    fontWeight: 700,
                },
            },
        },
        MuiDialog: {
            defaultProps: {
                maxWidth: 'md',
                fullWidth: false,
                scroll: 'paper',
            },
            styleOverrides: {
                root: {
                    [breakpoints.down('md')]: {
                        margin: '12px',
                    },
                },
                paper: {
                    borderRadius: '8px',
                    overflow: 'hidden',
                    '& > form': {
                        display: 'contents',
                    },
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    position: 'relative',
                    padding: '32px 32px 16px',
                    '& .MuiButtonBase-root': {
                        position: 'absolute',
                        top: 32,
                        right: 32,
                    },
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    paddingLeft: 32,
                    paddingRight: 32,
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    paddingLeft: 32,
                    paddingRight: 32,
                    paddingBottom: 32,
                    '& .MuiButtonBase-root': {
                        minWidth: 120,
                    },
                    [breakpoints.down('md')]: {
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column-reverse',
                        '& .MuiButtonBase-root': {
                            width: '100%',
                        },
                    },
                },
                spacing: {
                    [breakpoints.up('md')]: {
                        '& > :not(:first-child)': {
                            marginLeft: 16, // Keep the left margin for only desktop view
                        },
                    },
                    [breakpoints.down('md')]: {
                        '& > :not(:last-child)': {
                            marginTop: 10,
                            marginLeft: 10,
                        },
                    },
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    fontSize: '0.875rem',
                    lineHeight: 1.428571,
                    position: 'relative',
                    top: -1,
                    paddingLeft: 4,
                },
            },
        },
        MuiBackdrop: {
            styleOverrides: {
                root: {
                    '&.MuiBackdrop-invisible': {
                        backgroundColor: 'transparent',
                    },
                    backgroundColor: 'rgba(51, 51, 51, 0.33)',
                },
            },
        },
        MuiIconButton: {
            defaultProps: {
                size: 'small',
            },
            styleOverrides: {
                root: {
                    width: 32,
                    height: 32,
                    backgroundColor: 'transparent',
                    '& svg': {
                        fontSize: '1.25rem',
                        fill: colors$1.grey[800],
                    },
                    '&:hover': {
                        backgroundColor: 'transparent',
                        '& svg': {
                            fill: colors$1.grey[600],
                        },
                    },
                    '&:active': {
                        backgroundColor: 'transparent',
                        '& svg': {
                            fill: `${colors$1.grey[1000]} !important`,
                        },
                    },
                    '&.x-small': {
                        width: 24,
                        height: 24,
                        '& svg': {
                            fontSize: '1rem',
                        },
                    },
                },
                sizeSmall: {
                    padding: 4,
                },
            },
        },
        MuiSvgIcon: {
            styleOverrides: {
                fontSizeLarge: {
                    fontSize: '1.875rem',
                },
                fontSizeSmall: {
                    fontSize: '1rem',
                },
            },
        },
        MuiSwitch: {
            defaultProps: {
                color: 'primary',
            },
            styleOverrides: {
                root: {
                    padding: 7,
                    width: 62,
                    '& .MuiIconButton-root': {
                        '&:hover': {
                            backgroundColor: 'transparent !important',
                        },
                    },
                },
                switchBase: {
                    '&:hover': {
                        backgroundColor: 'transparent',
                    },
                },
                track: {
                    borderRadius: 12,
                    backgroundColor: colors$1.grey[300],
                    transition: 'none',
                    opacity: 1,
                },
                colorPrimary: {
                    color: colors$1.common.white,
                    '&.Mui-checked': {
                        color: colors$1.common.white,
                        transform: 'translateX(24px)',
                    },
                    '&.Mui-checked + .MuiSwitch-track': {
                        background: colors$1.orange.main,
                        opacity: 1,
                    },
                },
            },
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    height: 4,
                    color: colors$1.orange.main,
                },
                track: {
                    height: 4,
                    borderRadius: 8,
                },
                rail: {
                    height: 4,
                    borderRadius: 8,
                },
                thumb: {
                    width: 24,
                    height: 24,
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                    '&.Mui-focusVisible': {
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15) !important',
                    },
                    '&:hover': {
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15) !important',
                        color: colors$1.orange.light,
                    },
                    '&:active': {
                        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                        color: colors$1.orange.dark,
                    },
                    '&.Mui-disabled': {
                        width: 24,
                        height: 24,
                    },
                },
            },
        },
        MuiLink: {
            defaultProps: {
                underline: 'always',
                color: 'secondary',
            },
            styleOverrides: {
                root: {
                    '&:hover': {
                        color: '#6FCDFF',
                    },
                    '&:active': {
                        color: colors$1.blue.dark,
                    },
                    '&.MuiTypography-colorPrimary': {
                        '&:hover': {
                            color: colors$1.orange.light,
                        },
                        '&:active': {
                            color: colors$1.orange.dark,
                        },
                    },
                },
            },
        },
        MuiFormControl: {
            styleOverrides: {
                marginNormal: {
                    marginTop: '20px',
                },
            },
        },
        MuiTextField: {
            defaultProps: {
                variant: 'outlined',
                size: 'small',
                margin: 'normal',
            },
        },
        MuiInputLabel: {
            defaultProps: {
                shrink: true,
            },
            styleOverrides: {
                formControl: {
                    top: '-8px',
                    left: '-14px',
                },
                root: {
                    color: colors$1.grey[500],
                    '& + .MuiOutlinedInput-root fieldset': {
                        top: -5,
                    },
                    '&.Mui-focused': {
                        color: colors$1.grey[800],
                    },
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    [breakpoints.down('sm')]: {
                        fontSize: '1rem',
                    },
                    //needed for safari to be able to display input value in disabled inputs CTV-1907
                    '&.Mui-disabled': {
                        '-webkit-text-fill-color': colors$1.grey[300],
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '& fieldset': {
                        top: 0,
                    },
                    '& input': {
                        paddingTop: 8.5,
                        paddingBottom: 8.5,
                    },
                    '& legend span': {
                        display: 'none',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors$1.grey[500],
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors$1.orange.light,
                        borderWidth: '1px',
                    },
                    '&.Mui-focused&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors$1.red.main,
                    },
                    '&.Mui-error': {
                        color: colors$1.red.main,
                    },
                    '&.Mui-focused': {
                        color: 'inherit',
                        borderWidth: '2px',
                    },
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors$1.red.main,
                    },
                },
                adornedStart: {
                    paddingLeft: 8,
                },
                adornedEnd: {
                    paddingRight: 8,
                },
                // For some reason this is not working
                // focused: {
                //   background: 'red',
                // },
            },
        },
        MuiInputAdornment: {
            styleOverrides: {
                positionStart: {
                    marginRight: 6,
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                contained: {
                    marginLeft: 0,
                    color: colors$1.grey[500],
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                inputRoot: {
                    paddingTop: '0px !important',
                    paddingBottom: '0px !important',
                },
                input: {
                    paddingTop: '8.5px !important',
                    paddingBottom: '8.5px !important',
                },
                option: {
                    minHeight: '32px !important',
                },
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    '&:focus': {
                        background: 'transparent !important',
                    },
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                outlined: {
                    borderColor: colors$1.grey[300],
                },
                rounded: {
                    borderRadius: '16px',
                },
            },
        },
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    '&:hover': {
                        backgroundColor: 'inherit',
                    },
                    '&.Mui-selected': {
                        background: colors$1.orange.main,
                        backgroundColor: colors$1.orange.main,
                        borderRadius: '8px',
                    },
                },
                today: {
                    color: colors$1.orange.main,
                    border: 'none !important',
                },
            },
        },
        MuiTabs: {
            defaultProps: {
                TabIndicatorProps: {
                    hidden: true,
                },
            },
            styleOverrides: {
                root: {
                    minHeight: 40,
                    borderBottom: `1px solid ${colors$1.grey[100]}`,
                },
            },
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    minHeight: 40,
                    [breakpoints.up('sm')]: {
                        minWidth: 184,
                    },
                },
                textColorPrimary: {
                    color: colors$1.grey[500],
                    '&:hover': {
                        background: colors$1.grey[100],
                        color: colors$1.grey[800],
                        borderRadius: '8px 8px 0 0',
                    },
                    '&.Mui-selected': {
                        background: colors$1.orange.main,
                        color: colors$1.grey[1000],
                        borderRadius: '8px 8px 0 0',
                        '&:hover': {
                            background: colors$1.orange.main,
                            color: colors$1.grey[1000],
                            borderRadius: '8px 8px 0 0',
                        },
                    },
                },
            },
        },
        MuiRadio: {
            defaultProps: {
                checkedIcon: React.createElement(RadioButtonUnchecked, { stroke: colors$1.orange.main, "stroke-width": 3 }),
            },
            styleOverrides: {
                root: {
                    color: colors$1.grey[500],
                    '&.Mui-disabled': {
                        '&.Mui-checked': {
                            '& svg': {
                                borderRadius: '100%',
                                background: colors$1.grey[100],
                                stroke: colors$1.grey[300],
                            },
                        },
                    },
                },
            },
        },
    },
    breakpoints,
    palette: {
        common: {
            black: colors$1.common.black,
            white: colors$1.common.white,
        },
        mode: 'light',
        primary: {
            light: colors$1.orange.main,
            main: colors$1.orange.main,
            dark: colors$1.orange.dark,
            contrastText: '#fff',
        },
        secondary: {
            light: colors$1.blue.light,
            main: colors$1.blue.main,
            dark: colors$1.blue.dark,
            // contrastText: '#fff',
        },
        error: {
            light: colors$1.red.light,
            main: colors$1.red.main,
            dark: colors$1.red.dark,
            // contrastText: '#fff',
        },
        warning: {
            light: '#ff7d78',
            main: '#CC4C4C',
            dark: '#951624',
            // contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        info: {
            light: colors$1.blue2.light,
            main: colors$1.blue2.main,
            dark: colors$1.blue2.dark,
            //   contrastText: '#fff',
        },
        success: {
            light: colors$1.green.light,
            main: colors$1.green.main,
            dark: colors$1.green.dark,
            // contrastText: 'rgba(0, 0, 0, 0.87)',
        },
        grey: {
            '50': colors$1.grey[50],
            '100': colors$1.grey[100],
            '200': colors$1.grey[200],
            '300': colors$1.grey[300],
            '400': colors$1.grey[400],
            '500': colors$1.grey[500],
            '600': colors$1.grey[600],
            '700': colors$1.grey[700],
            '800': colors$1.grey[800],
            '900': colors$1.grey[900],
            '1000': colors$1.grey[1000],
        },
        text: {
            primary: colors$1.common.black,
            secondary: colors$1.grey[700],
            disabled: colors$1.grey[300], // Neutral 4
            // hint: 'rgba(0, 0, 0, 0.38)',
        },
        divider: colors$1.grey[100],
        background: {
        // paper: '#fff',
        // default: '#fff',
        },
        action: {
            active: colors$1.grey[700],
            // hover: 'rgba(0, 0, 0, 0.04)',
            // hoverOpacity: 0.04,
            selected: colors$1.grey[300],
            // selectedOpacity: 0.08,
            disabled: colors$1.grey[300],
            disabledBackground: colors$1.grey[100],
            disabledOpacity: 0.38,
            focus: colors$1.grey[100],
            // focusOpacity: 0.12,
            // activatedOpacity: 0.12,
        },
        gradients: colors$1.gradients,
    },
    shadows: Array(25)
        .fill('')
        .map((_n, i) => {
        return `0px 0px ${i * 2}px rgba(0, 0, 0, 0.12)`;
    }),
    typography: {
        // htmlFontSize: 16,
        fontFamily: '"Poppins", "Helvetica", "Arial", sans-serif',
        // fontSize: 14,
        //   fontWeightLight: 300,
        fontWeightRegular: 500,
        //   fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: {
            //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            //     fontWeight: 300,
            fontSize: '2.625rem',
            lineHeight: 1.285714,
            letterSpacing: '-0.03px',
        },
        h2: {
            //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            //     fontWeight: 300,
            fontSize: '2.25rem',
            lineHeight: 1.333333,
            letterSpacing: '-0.03px',
        },
        h3: {
            //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            // fontWeight: 600,
            fontSize: '1.75rem',
            lineHeight: 1.285714,
            letterSpacing: '-0.03px',
        },
        h4: {
            //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            // fontWeight: 600,
            fontSize: '1.5rem',
            lineHeight: 1.333333,
            letterSpacing: '-0.03px',
        },
        h5: {
            //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            // fontWeight: 600,
            fontSize: '1.25rem',
            lineHeight: 1.2,
            letterSpacing: '-0.03px',
        },
        h6: {
            //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            // fontWeight: 500,
            fontSize: '1rem',
            lineHeight: 1.25,
            letterSpacing: '-0.03px',
        },
        subtitle1: {
            //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            //     fontWeight: 400,
            fontSize: '0.625rem',
            lineHeight: 1.4,
            //     letterSpacing: '0.00938em',
        },
        subtitle2: {
        //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
        //     fontWeight: 500,
        //     fontSize: '0.875rem',
        //     lineHeight: 1.57,
        //     letterSpacing: '0.00714em',
        },
        body1: {
            //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            fontWeight: 500,
            ////////////////////////////////////////////////////////
            // IMPORTANT: Any changes here need to be reflected in the global override above
            ////////////////////////////////////////////////////////
            fontSize: '0.875rem',
            lineHeight: 1.285714,
            letterSpacing: '-0.03px',
        },
        body2: {
            //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            fontWeight: 500,
            fontSize: '0.75rem',
            lineHeight: 1.333333,
            letterSpacing: '-0.03px',
        },
        button: {
            //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
            //     fontWeight: 500,
            fontSize: '1rem',
            lineHeight: 1.5,
            letterSpacing: '-0.03px',
            textTransform: 'none',
        },
        caption: {
        //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
        //     fontWeight: 400,
        //     fontSize: '0.75rem',
        //     lineHeight: 1.66,
        //     letterSpacing: '0.03333em',
        },
        overline: {
        //     fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
        //     fontWeight: 400,
        //     fontSize: '0.75rem',
        //     lineHeight: 2.66,
        //     letterSpacing: '0.08333em',
        //     textTransform: 'uppercase',
        },
    },
    shape: {
        borderRadius: 8,
    },
    transitions: {
        easing: {
        //     easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
        //     easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
        //     easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
        //     sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
        },
        duration: {
        //     shortest: 150,
        //     shorter: 200,
        //     short: 250,
        //     standard: 300,
        //     complex: 375,
        //     enteringScreen: 225,
        //     leavingScreen: 195,
        },
    },
    zIndex: {
    //   mobileStepper: 1000,
    //   speedDial: 1050,
    //   appBar: 1100,
    //   drawer: 1200,
    //   modal: 1300,
    //   snackbar: 1400,
    //   tooltip: 1500,
    },
};
const theme = createTheme(themeDefinition);

const colors = Object.assign(Object.assign({}, colors$1), { accent: {
        three: '#F1ECE3',
        five: '#E1E9FF',
        six: '#F1EAFF',
        fourteen: '#FFEFDC',
    }, vspBlue: {
        main: '#223354',
        light: '#344C7A',
        dark: '#1A263E',
    }, vspOrange: {
        main: '#CF7C17',
        light: '#E5922D',
        dark: '#B56B11',
    } });

const vspThemeDefinition = {
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                '.MuiDataGrid-root': {
                    borderColor: colors.grey[200],
                    '.MuiDataGrid-withBorderColor': {
                        borderColor: colors.grey[200],
                    },
                    '.MuiDataGrid-row--editing': {
                        '.MuiDataGrid-cell': {
                            backgroundColor: colors.accent.five,
                            '&.MuiDataGrid-cell--editing': {
                                '.MuiOutlinedInput-root': {
                                    '.MuiOutlinedInput-notchedOutline': {
                                        border: 0,
                                    },
                                },
                            },
                            '&:focus-within': {
                                backgroundColor: colors.common.white,
                            },
                        },
                    },
                },
            },
        },
        MuiButton: {
            defaultProps: {
                color: 'inherit',
            },
            styleOverrides: {
                root: {
                    color: colors.common.white,
                    boxShadow: 'none',
                    padding: '4px 12px',
                    backgroundColor: 'transparent',
                    transition: 'none',
                    '& svg': {
                        fill: colors.common.white,
                    },
                    '&:disabled svg': {
                        fill: colors.grey[300],
                    },
                    // Wrap in MQ to prevent sticky hover on touch devices
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: 'none',
                            color: colors.common.white,
                        },
                    },
                    '&:active': {
                        backgroundColor: 'none',
                        color: colors.common.white,
                    },
                },
                text: {
                    color: colors.grey[800],
                    fontWeight: 500,
                    '& svg': {
                        fill: colors.grey[800],
                    },
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: 'transparent',
                            color: colors.grey[600],
                            '& svg': {
                                fill: colors.grey[600],
                            },
                        },
                    },
                    '&:disabled': {
                        backgroundColor: 'transparent !important',
                    },
                },
                textInfo: {
                    backgroundColor: 'transparent',
                    color: colors.blue2.main,
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: 'transparent',
                            color: colors.blue2.light,
                            '& svg': {
                                fill: colors.blue2.light,
                            },
                        },
                    },
                    '&:active': {
                        color: colors.blue2.dark,
                        '& svg': {
                            fill: colors.blue2.dark,
                        },
                    },
                    '& svg': {
                        fill: colors.blue2.main,
                    },
                },
                textWarning: {
                    backgroundColor: 'transparent',
                    color: colors.red.main,
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: 'transparent',
                            color: colors.red.light,
                            '& svg': {
                                fill: colors.red.light,
                            },
                        },
                    },
                    '&:active': {
                        color: colors.red.dark,
                        '& svg': {
                            fill: colors.red.dark,
                        },
                    },
                    '& svg': {
                        fill: colors.red.main,
                    },
                },
                contained: {
                    backgroundColor: colors.grey[50],
                    boxShadow: 'none',
                    // Do all this, or add !important to the contained boxShadow
                    '@media (hover: hover)': {
                        '&:hover': {
                            boxShadow: 'none',
                        },
                    },
                    '&:active': {
                        boxShadow: 'none',
                    },
                    '&.Mui-focusVisible': {
                        boxShadow: 'none',
                    },
                    '& svg': {
                        fill: colors.blue.main,
                    },
                },
                containedInherit: {
                    color: colors.blue.main,
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: colors.grey[200],
                        },
                    },
                },
                containedPrimary: {
                    background: colors.vspBlue.main,
                    backgroundColor: colors.vspBlue.main,
                    '&:disabled': {
                        background: colors.grey[100],
                    },
                    '@media (hover: hover)': {
                        '&:hover': {
                            background: colors.vspBlue.light,
                            '& svg': {
                                fill: colors.common.white,
                            },
                        },
                    },
                    '&:active': {
                        background: colors.vspBlue.main,
                    },
                    '& svg': {
                        fill: colors.common.white,
                    },
                },
                containedWarning: {
                    background: colors.gradients.red.main,
                    backgroundColor: colors.red.main,
                    color: colors.common.white,
                    '&:disabled': {
                        background: colors.grey[100],
                    },
                    '@media (hover: hover)': {
                        '&:hover': {
                            color: colors.common.white,
                            background: colors.gradients.red.light,
                        },
                    },
                    '&:active': {
                        color: colors.common.white,
                        background: colors.gradients.red.dark,
                    },
                    '& svg': {
                        fill: colors.common.white,
                    },
                },
                containedInfo: {
                    background: colors.grey[100],
                    backgroundColor: colors.grey[100],
                    color: colors.blue2.main,
                    '&:disabled': {
                        background: colors.grey[100],
                        color: colors.grey[300],
                        '& svg': {
                            fill: colors.grey[300],
                        },
                    },
                    '@media (hover: hover)': {
                        '&:hover': {
                            background: colors.grey[100],
                            color: colors.blue2.light,
                            '& svg': {
                                fill: colors.blue2.light,
                            },
                        },
                    },
                    '&:active': {
                        background: colors.grey[200],
                        color: colors.blue2.dark,
                        '& svg': {
                            fill: colors.blue2.dark,
                        },
                    },
                    '& svg': {
                        fill: colors.blue2.main,
                    },
                },
                outlined: {
                    padding: '4px 12px',
                    border: `1px solid ${colors.grey[800]}`,
                    color: colors.grey[800],
                    '@media (hover: hover)': {
                        '&:hover': {
                            backgroundColor: 'transparent',
                            borderColor: colors.grey[600],
                            color: colors.grey[600],
                            '& svg': {
                                fill: colors.grey[600],
                            },
                        },
                    },
                    '&:active': {
                        borderColor: colors.grey[1000],
                        color: colors.grey[1000],
                        '& svg': {
                            fill: colors.grey[1000],
                        },
                    },
                    '& svg': {
                        fill: colors.grey[800],
                    },
                },
                outlinedPrimary: {
                    '& svg': {
                        fill: colors.vspBlue.main,
                    },
                },
                outlinedSecondary: {
                    '& svg': {
                        fill: colors.blue.main,
                    },
                },
                sizeMedium: {
                    fontSize: '0.875rem',
                    lineHeight: 1.285714,
                    padding: '7px 12px',
                    height: 32,
                },
                containedSizeSmall: {
                    padding: '4px 12px',
                    fontSize: '0.875rem',
                    lineHeight: '1.25rem',
                },
                containedSizeLarge: {
                    padding: '18px 16px',
                    fontSize: '1rem',
                    lineHeight: 1.25,
                    fontWeight: 700,
                },
                textSizeSmall: {
                    fontSize: '0.875rem',
                },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: colors.blue2.main,
                    '&:active': {
                        color: colors.blue2.dark,
                    },
                },
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '& fieldset': {
                        top: 0,
                    },
                    '& input': {
                        paddingTop: 8.5,
                        paddingBottom: 8.5,
                    },
                    '& legend span': {
                        display: 'none',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.grey[500],
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.vspBlue.light,
                        borderWidth: '1px',
                    },
                    '&.Mui-focused&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.red.main,
                    },
                    '&.Mui-error': {
                        color: colors.red.main,
                    },
                    '&.Mui-focused': {
                        color: 'inherit',
                        borderWidth: '2px',
                    },
                    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
                        borderColor: colors.red.main,
                    },
                },
                adornedStart: {
                    paddingLeft: 8,
                },
                adornedEnd: {
                    paddingRight: 8,
                },
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    fontSize: '1rem',
                    top: '-10px !important',
                },
            },
        },
    },
    /* Ts complains here that IPaletteOptions is missing properties
    gradients, grey. We inherit those from the ctv theme so this error is
    irrelevant in the context of the vsp theme.
    */
    // @ts-ignore
    palette: {
        primary: {
            light: colors.vspBlue.light,
            main: colors.vspBlue.main,
            dark: colors.vspBlue.dark,
        },
    },
};

const vspTheme = createTheme(themeDefinition, vspThemeDefinition);

const Error400Illustration = (props) => {
    return (React.createElement("svg", Object.assign({ width: "424", height: "208", viewBox: "0 0 424 208", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { "clip-path": "url(#clip0_3426_4787)" },
            React.createElement("rect", { width: "424", height: "24", fill: "#F1F4F9" }),
            React.createElement("g", { filter: "url(#filter0_d_3426_4787)" },
                React.createElement("rect", { x: "6", y: "6", width: "12", height: "12", rx: "6", fill: "url(#paint0_linear_3426_4787)" }),
                React.createElement("rect", { x: "24", y: "6", width: "12", height: "12", rx: "6", fill: "url(#paint1_linear_3426_4787)" }),
                React.createElement("rect", { x: "42", y: "6", width: "12", height: "12", rx: "6", fill: "url(#paint2_linear_3426_4787)" })),
            React.createElement("rect", { width: "424", height: "184", transform: "translate(0 24)", fill: "white" })),
        React.createElement("rect", { x: "0.5", y: "0.5", width: "423", height: "207", rx: "11.5", stroke: "#F1ECE3" }),
        React.createElement("path", { d: "M270.097 90.4639C270.097 89.1809 269.196 87.6209 268.085 86.9794L199.875 47.5983C198.764 46.9568 197.863 47.4768 197.863 48.7598L197.863 119.217L265.57 158.308C268.07 159.751 270.097 158.581 270.097 155.694L270.097 90.4639Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M270.556 90.0049C270.556 88.722 269.655 87.1619 268.544 86.5204L200.334 47.1393C199.223 46.4978 198.322 47.0179 198.322 48.3008L198.322 118.758L266.029 157.849C268.529 159.292 270.556 158.122 270.556 155.235L270.556 90.0049Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M271.015 89.546C271.015 88.263 270.114 86.703 269.003 86.0615L200.793 46.6804C199.682 46.0389 198.781 46.5589 198.781 47.8419L198.781 118.299L266.488 157.39C268.988 158.833 271.015 157.663 271.015 154.776L271.015 89.546Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M271.473 89.0871C271.473 87.8041 270.573 86.244 269.462 85.6026L201.251 46.2214C200.14 45.58 199.24 46.1 199.24 47.3829L199.24 117.84L266.947 156.931C269.447 158.374 271.473 157.204 271.473 154.317L271.473 89.0871Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M269.638 90.9229C269.638 89.64 268.737 88.0799 267.626 87.4384L199.416 48.0573C198.305 47.4158 197.404 47.9358 197.404 49.2188L197.404 119.676L265.111 158.767C267.611 160.21 269.638 159.04 269.638 156.153L269.638 90.9229Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M263.7 92.0275L203.341 57.1788L203.341 110.861L263.7 145.709L263.7 92.0275Z", fill: "white" }),
        React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M269.638 154.078V155.272V156.464V157.658V158.851L269.637 158.851L269.638 158.851L219.982 187.52C218.871 188.161 217.07 188.161 215.959 187.52L147.648 148.08C146.825 147.605 146.612 146.911 147.008 146.322C146.75 145.939 146.75 145.512 147.009 145.129C146.815 144.842 146.767 144.53 146.863 144.23C146.895 144.13 146.944 144.032 147.008 143.936C146.612 143.347 146.825 142.653 147.648 142.178L197.304 113.509L212.804 122.459L211.771 123.055L212.804 123.651L214.871 124.845L210.737 127.231L248.971 149.306L254.138 146.323L268.53 154.632L269.638 154.078Z", fill: "url(#paint3_linear_3426_4787)" }),
        React.createElement("path", { d: "M146.636 147.397L146.636 142.647L147.636 143.147L148.136 147.897L146.636 147.397Z", fill: "#F3F4F5" }),
        React.createElement("path", { d: "M207.637 124.666L248.637 148.315L222.108 125.878L215.475 119.815L207.637 124.666Z", fill: "#C7C6C6" }),
        React.createElement("path", { d: "M248.702 148.815L254.137 145.824V138.645L213.072 115.314V121.895L207.637 124.886L248.702 148.815Z", fill: "url(#paint4_linear_3426_4787)", "fill-opacity": "0.5" }),
        React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M254.137 145.627L269.638 154.576L219.994 183.718C218.881 184.372 217.058 184.373 215.942 183.721L147.624 143.806C146.525 143.163 146.53 142.128 147.636 141.49L197.304 112.814L212.804 121.763L207.637 124.746L248.971 148.61L254.137 145.627Z", fill: "white" }),
        React.createElement("path", { d: "M253.104 155.759L193.137 121.104L175.604 131.298L235.537 165.901L253.104 155.759Z", fill: "#DBDCDE" }),
        React.createElement("rect", { width: "31.0232", height: "14.3184", transform: "matrix(-0.866025 -0.5 -0.866025 0.5 213.837 160.543)", fill: "#F1F4F9" }),
        React.createElement("rect", { width: "69.2057", height: "20.2844", transform: "matrix(-0.866025 -0.5 -0.866025 0.5 253.104 156.963)", fill: "#F1F4F9" }),
        React.createElement("path", { d: "M193.137 122.355V121.105L175.637 131.355V132.605L193.137 122.355Z", fill: "#C4C4C4" }),
        React.createElement("path", { d: "M234.387 166.565L252.887 155.815L256.137 158.315L235.887 168.065L234.387 166.565Z", fill: "white" }),
        React.createElement("circle", { cx: "1.00001", cy: "1.00001", r: "1.00001", transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 234.637 71.3964)", fill: "#F1F4F9" }),
        React.createElement("rect", { width: "6.19621", height: "6.19621", transform: "matrix(0.866025 0.5 -0.866025 0.5 268.077 69.2439)", fill: "white" }),
        React.createElement("rect", { width: "6.19621", height: "6.19621", transform: "matrix(0.866025 0.5 -2.20305e-08 1 262.742 72.342)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "6.19621", height: "6.19621", transform: "matrix(-0.866025 0.5 2.20305e-08 1 273.443 72.342)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "6.19621", height: "6.19621", transform: "matrix(0.866025 0.5 -0.866025 0.5 162.512 124.321)", fill: "white" }),
        React.createElement("rect", { width: "6.19621", height: "6.19621", transform: "matrix(0.866025 0.5 -2.20305e-08 1 157.177 127.42)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "6.19621", height: "6.19621", transform: "matrix(-0.866025 0.5 2.20305e-08 1 167.879 127.42)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "5.96672", height: "5.96672", transform: "matrix(0.866025 0.5 -0.866025 0.5 213.781 163.335)", fill: "white" }),
        React.createElement("rect", { width: "5.96672", height: "5.96672", transform: "matrix(0.866025 0.5 -2.20305e-08 1 208.643 166.318)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "5.96672", height: "5.96672", transform: "matrix(-0.866025 0.5 2.20305e-08 1 218.948 166.318)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "2.91491", height: "2.91491", transform: "matrix(0.866025 0.5 -0.866025 0.5 219.338 173.432)", fill: "white" }),
        React.createElement("rect", { width: "2.91491", height: "2.91491", transform: "matrix(0.866025 0.5 -2.20305e-08 1 216.828 174.89)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "2.91491", height: "2.91491", transform: "matrix(-0.866025 0.5 2.20305e-08 1 221.862 174.89)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -0.866025 0.5 149.235 133.501)", fill: "white" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -2.20305e-08 1 147.061 134.763)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(-0.866025 0.5 2.20305e-08 1 151.421 134.763)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -0.866025 0.5 182.281 78.4236)", fill: "white" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -2.20305e-08 1 180.108 79.6857)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(-0.866025 0.5 2.20305e-08 1 184.468 79.6857)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -0.866025 0.5 274.995 95.865)", fill: "white" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -2.20305e-08 1 272.821 97.1272)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(-0.866025 0.5 2.20305e-08 1 277.181 97.1272)", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M172.487 109.935L168.815 113.606V104.656L172.487 106.492V109.935Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M148.391 86.4744L168.074 96.9206L168.992 104.367L174.094 107.869L176.124 99.6613L181.402 102.709L181.402 95.6266L176.124 92.5791L176.124 60.93L166.816 55.5562L149.309 77.3296L148.391 86.4744ZM168.614 88.508L156.964 81.5174L156.964 81.1459L168.75 66.4253L168.614 66.1524L168.614 88.508Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M166.75 55.5455L159.406 60.5943L168.815 66.102L176.159 61.0533L166.75 55.5455Z", fill: "white" }),
        React.createElement("path", { d: "M176.159 92.4933L168.815 97.5421L174.094 100.755L181.437 95.7062L176.159 92.4933Z", fill: "#EDEDED" }),
        React.createElement("path", { d: "M181.437 102.591L174.094 107.869V100.755L181.437 95.7062V102.591Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M162.16 84.2317L149.309 86.5266L162.16 94.0997V84.2317Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M142 89.3007L161.683 100.665L161.683 109.488L168.815 113.606L168.815 104.782L174.094 107.83L174.094 100.748L168.815 97.5419L168.815 66.0511L159.507 60.6773L142 82.4507L142 89.3007ZM161.764 93.6292L149.656 86.6385L149.656 86.267L161.442 71.5464L161.764 71.7325L161.764 84.3606L161.764 93.6292Z", fill: "#D9DCE1" }),
        React.createElement("path", { d: "M156.917 81.6365L149.803 86.6853V86.2263L161.277 71.539L161.736 71.7685V75.2108L156.917 81.1775V81.6365Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M273.463 168.225L269.791 171.896V162.946L273.463 164.782V168.225Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M249.366 144.765L269.049 155.211L269.967 162.657L275.069 166.159L277.099 157.951L282.378 160.999L282.378 153.917L277.099 150.869L277.099 119.22L267.792 113.846L250.284 135.62L249.366 144.765ZM269.589 146.798L257.94 139.808L257.94 139.436L269.726 124.715L269.589 124.443L269.589 146.798Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M267.725 113.836L260.382 118.884L269.791 124.392L277.135 119.343L267.725 113.836Z", fill: "white" }),
        React.createElement("path", { d: "M277.135 150.784L269.791 155.832L275.069 159.045L282.413 153.996L277.135 150.784Z", fill: "#EDEDED" }),
        React.createElement("path", { d: "M282.413 160.881L275.069 166.159V159.045L282.413 153.996V160.881Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M263.136 142.522L250.284 144.817L263.136 152.39V142.522Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M242.975 147.591L262.659 158.955L262.659 167.779L269.791 171.896L269.791 163.073L275.069 166.12L275.069 159.038L269.791 155.832L269.791 124.341L260.483 118.968L242.975 140.741L242.975 147.591ZM262.739 151.919L250.631 144.929L250.631 144.557L262.417 129.837L262.739 130.023L262.739 142.651L262.739 151.919Z", fill: "#D9DCE1" }),
        React.createElement("path", { d: "M257.892 139.927L250.778 144.975V144.517L262.253 129.829L262.712 130.059V133.501L257.892 139.468V139.927Z", fill: "#A9ACB1" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -0.866025 0.5 276.831 148.647)", fill: "white" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -2.20305e-08 1 274.657 149.909)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(-0.866025 0.5 2.20305e-08 1 279.017 149.909)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -0.866025 0.5 167.135 52.7209)", fill: "white" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -2.20305e-08 1 164.961 53.9831)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(-0.866025 0.5 2.20305e-08 1 169.321 53.9831)", fill: "#C1C4C9" }),
        React.createElement("g", { style: { mixBlendMode: 'multiply' }, opacity: "0.15", filter: "url(#filter1_f_3426_4787)" },
            React.createElement("path", { d: "M222.179 153.063L191.608 135.413L201.351 129.369L231.921 147.019L222.179 153.063Z", fill: "#A9ACB1" })),
        React.createElement("path", { d: "M191.944 91.2554L185.603 93.5803L191.31 96.962L193 93.1576L191.944 91.2554Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M219.209 135.64L213.502 141.77V134.372C214.178 134.879 218.152 135.711 219.209 135.64Z", fill: "#A9ACB1" }),
        React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M210.67 77.517L220.188 83.0123L220.188 90.871C221.56 92.0748 222.868 93.4229 224.093 94.8802L228.944 92.0794L235.674 103.737L231.042 106.411C231.975 108.694 232.692 111.023 233.151 113.323L238.859 116.618L238.859 127.608L233.052 124.256C232.613 125.792 231.974 127.114 231.164 128.206L234.898 134.673L228.168 138.559L224.302 131.864C223.018 131.934 221.638 131.776 220.189 131.374L220.189 137.965L210.671 132.47L210.671 125.764C209.044 124.294 207.511 122.622 206.105 120.808L202.023 123.165L195.293 111.508L199.594 109.024C199.003 107.395 198.524 105.751 198.174 104.12L192.366 100.767L192.366 89.776L198.074 93.0716C198.452 91.6151 199.004 90.3413 199.707 89.2639L195.249 81.5425L201.98 77.6567L206.306 85.15C207.656 84.9944 209.121 85.1022 210.67 85.4907L210.67 77.517ZM223.483 113.025C223.483 118.044 219.96 120.079 215.613 117.569C211.266 115.059 207.742 108.956 207.742 103.937C207.742 98.9172 211.266 96.8827 215.613 99.3924C219.96 101.902 223.483 108.006 223.483 113.025Z", fill: "url(#paint5_linear_3426_4787)" }),
        React.createElement("path", { d: "M203.991 85.1259L199.553 88.9304C200.821 90.4099 203.216 88.9304 203.991 89.3531V85.1259Z", fill: "#F1F4F9" }),
        React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M203.907 81.3212L213.425 86.8165L213.425 94.6755C214.796 95.8791 216.104 97.2271 217.329 98.6843L222.18 95.8834L228.911 107.541L224.279 110.215C225.212 112.498 225.929 114.827 226.387 117.127L232.095 120.422L232.095 131.413L226.288 128.06C225.85 129.596 225.211 130.919 224.401 132.011L228.134 138.477L221.404 142.363L217.538 135.668C216.254 135.739 214.875 135.58 213.425 135.178L213.425 141.77L203.907 136.274L203.907 129.568C202.281 128.098 200.747 126.426 199.342 124.612L195.259 126.97L188.529 115.312L192.831 112.829C192.239 111.199 191.761 109.556 191.41 107.924L185.603 104.571L185.603 93.5802L191.311 96.8756C191.688 95.4193 192.24 94.1456 192.944 93.0682L188.529 85.4215L195.259 81.5358L199.542 88.9543C200.893 88.7987 202.358 88.9065 203.907 89.295L203.907 81.3212ZM216.72 116.829C216.72 121.849 213.196 123.883 208.849 121.374C204.502 118.864 200.978 112.76 200.978 107.741C200.978 102.722 204.502 100.687 208.849 103.197C213.196 105.707 216.72 111.81 216.72 116.829Z", fill: "#D9DCE1" }),
        React.createElement("circle", { cx: "9.08834", cy: "9.08834", r: "11.9921", transform: "matrix(0.866025 0.5 -2.20305e-08 1 200.978 98.6526)", stroke: "#D9DCE1", "stroke-width": "5.80749" }),
        React.createElement("path", { d: "M228.931 92.1008L222.168 95.9052L228.931 107.53L235.694 103.725L228.931 92.1008Z", fill: "#F1F4F9" }),
        React.createElement("path", { d: "M232.102 120.423L238.865 116.618L233.158 113.448L226.395 117.252L232.102 120.423Z", fill: "#F1F4F9" }),
        React.createElement("path", { d: "M238.865 116.618L232.102 120.422V131.413L238.865 127.609V116.618Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M232.102 131.413L224.493 132.047C224.493 131.878 225.972 129.934 226.184 128.032L232.102 131.413Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M210.755 77.517L203.991 81.5327L213.502 86.8167L220.266 83.0122L210.755 77.517Z", fill: "#F1F4F9" }),
        React.createElement("path", { d: "M220.265 90.8324L213.291 94.6368L213.502 86.8166L220.265 83.0122V90.8324Z", fill: "#D9DCE1" }),
        React.createElement("circle", { cx: "9.08834", cy: "9.08834", r: "11.9921", transform: "matrix(0.866025 0.5 -2.20305e-08 1 200.749 98.6188)", stroke: "#F1F4F9", "stroke-width": "5.80749" }),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_3426_4787", x: "-6", y: "-2", width: "72", height: "36", filterUnits: "userSpaceOnUse", "color-interpolation-filters": "sRGB" },
                React.createElement("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: "4" }),
                React.createElement("feGaussianBlur", { stdDeviation: "6" }),
                React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }),
                React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_3426_4787" }),
                React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_3426_4787", result: "shape" })),
            React.createElement("filter", { id: "filter1_f_3426_4787", x: "187.174", y: "124.934", width: "49.1824", height: "32.5636", filterUnits: "userSpaceOnUse", "color-interpolation-filters": "sRGB" },
                React.createElement("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
                React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                React.createElement("feGaussianBlur", { stdDeviation: "2.21731", result: "effect1_foregroundBlur_3426_4787" })),
            React.createElement("linearGradient", { id: "paint0_linear_3426_4787", x1: "6", y1: "6", x2: "18", y2: "18", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "#B5BBC2" }),
                React.createElement("stop", { offset: "1", "stop-color": "#8C95A2" })),
            React.createElement("linearGradient", { id: "paint1_linear_3426_4787", x1: "36", y1: "18", x2: "24", y2: "6", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "#F99A1C" }),
                React.createElement("stop", { offset: "1", "stop-color": "#FFB901" })),
            React.createElement("linearGradient", { id: "paint2_linear_3426_4787", x1: "42", y1: "6", x2: "54", y2: "18", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "white" }),
                React.createElement("stop", { offset: "1", "stop-color": "#EFEFEF" })),
            React.createElement("linearGradient", { id: "paint3_linear_3426_4787", x1: "269.638", y1: "155.382", x2: "166.27", y2: "218.042", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "#B1AEAE" }),
                React.createElement("stop", { offset: "0.401042", "stop-color": "#BCC1C4" }),
                React.createElement("stop", { offset: "1", "stop-color": "white" })),
            React.createElement("linearGradient", { id: "paint4_linear_3426_4787", x1: "228.17", y1: "124.288", x2: "222.812", y2: "133.903", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "#C4C4C4", "stop-opacity": "0" }),
                React.createElement("stop", { offset: "0.947917", "stop-color": "#787878" })),
            React.createElement("linearGradient", { id: "paint5_linear_3426_4787", x1: "215.612", y1: "80.3703", x2: "191.817", y2: "121.585", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "#DBE0E8" }),
                React.createElement("stop", { offset: "1", "stop-color": "#969CA5" })),
            React.createElement("clipPath", { id: "clip0_3426_4787" },
                React.createElement("rect", { width: "424", height: "208", rx: "12", fill: "white" })))));
};

const Error403Illustration = (props) => (React.createElement("svg", Object.assign({ width: "424", height: "208", viewBox: "0 0 424 208", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { "clip-path": "url(#clip0_3426_4786)" },
        React.createElement("rect", { width: "424", height: "24", fill: "#F1F4F9" }),
        React.createElement("g", { filter: "url(#filter0_d_3426_4786)" },
            React.createElement("rect", { x: "6", y: "6", width: "12", height: "12", rx: "6", fill: "url(#paint0_linear_3426_4786)" }),
            React.createElement("rect", { x: "24", y: "6", width: "12", height: "12", rx: "6", fill: "url(#paint1_linear_3426_4786)" }),
            React.createElement("rect", { x: "42", y: "6", width: "12", height: "12", rx: "6", fill: "url(#paint2_linear_3426_4786)" })),
        React.createElement("rect", { width: "424", height: "184", transform: "translate(0 24)", fill: "white" })),
    React.createElement("rect", { x: "0.5", y: "0.5", width: "423", height: "207", rx: "11.5", stroke: "#F1ECE3" }),
    React.createElement("path", { d: "M270.096 90.4639C270.096 89.1809 269.196 87.6209 268.085 86.9794L199.875 47.5983C198.763 46.9568 197.863 47.4768 197.863 48.7598L197.863 119.217L265.57 158.308C268.07 159.751 270.096 158.581 270.096 155.694L270.096 90.4639Z", fill: "#A9ACB1" }),
    React.createElement("path", { d: "M270.556 90.0049C270.556 88.722 269.655 87.1619 268.544 86.5204L200.334 47.1393C199.223 46.4978 198.322 47.0179 198.322 48.3008L198.322 118.758L266.029 157.849C268.529 159.292 270.556 158.122 270.556 155.235L270.556 90.0049Z", fill: "#A9ACB1" }),
    React.createElement("path", { d: "M271.015 89.546C271.015 88.263 270.114 86.703 269.003 86.0615L200.793 46.6804C199.682 46.0389 198.781 46.5589 198.781 47.8419L198.781 118.299L266.488 157.39C268.988 158.833 271.015 157.663 271.015 154.776L271.015 89.546Z", fill: "#A9ACB1" }),
    React.createElement("path", { d: "M271.473 89.0871C271.473 87.8041 270.573 86.244 269.462 85.6026L201.251 46.2214C200.14 45.58 199.24 46.1 199.24 47.3829L199.24 117.84L266.947 156.931C269.447 158.374 271.473 157.204 271.473 154.317L271.473 89.0871Z", fill: "#A9ACB1" }),
    React.createElement("path", { d: "M269.638 90.9229C269.638 89.64 268.737 88.0799 267.626 87.4384L199.416 48.0573C198.305 47.4158 197.404 47.9358 197.404 49.2188L197.404 119.676L265.111 158.767C267.611 160.21 269.638 159.04 269.638 156.153L269.638 90.9229Z", fill: "#C1C4C9" }),
    React.createElement("path", { d: "M263.701 92.0275L203.341 57.1788L203.341 110.861L263.701 145.709L263.701 92.0275Z", fill: "url(#paint3_linear_3426_4786)" }),
    React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M269.638 154.078V155.272V156.464V157.658V158.851L269.637 158.851L269.638 158.851L219.982 187.52C218.871 188.161 217.07 188.161 215.959 187.52L147.648 148.08C146.825 147.605 146.612 146.911 147.008 146.322C146.75 145.939 146.75 145.512 147.009 145.129C146.944 145.033 146.896 144.935 146.863 144.835C146.783 144.585 146.803 144.327 146.924 144.081C146.948 144.032 146.976 143.984 147.008 143.936C146.612 143.347 146.825 142.653 147.648 142.178L197.304 113.509L212.804 122.459L211.771 123.055L212.804 123.651L214.871 124.845L210.737 127.231L248.971 149.306L254.138 146.323L268.53 154.632L269.638 154.078Z", fill: "url(#paint4_linear_3426_4786)" }),
    React.createElement("path", { d: "M146.636 147.397L146.636 142.647L147.636 143.147L148.136 147.897L146.636 147.397Z", fill: "#F3F4F5" }),
    React.createElement("path", { d: "M207.637 124.666L248.637 148.315L222.108 125.878L215.475 119.815L207.637 124.666Z", fill: "#C7C6C6" }),
    React.createElement("path", { d: "M248.702 148.815L254.137 145.824V138.645L213.072 115.314V121.895L207.637 124.886L248.702 148.815Z", fill: "url(#paint5_linear_3426_4786)", "fill-opacity": "0.5" }),
    React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M254.137 145.627L269.637 154.576L219.994 183.718C218.881 184.372 217.057 184.373 215.942 183.721L147.624 143.806C146.524 143.163 146.53 142.128 147.636 141.49L197.303 112.814L212.804 121.763L207.637 124.746L248.971 148.61L254.137 145.627Z", fill: "white" }),
    React.createElement("path", { d: "M253.104 155.759L193.137 121.104L175.603 131.298L235.537 165.901L253.104 155.759Z", fill: "#DBDCDE" }),
    React.createElement("rect", { width: "31.0232", height: "14.3184", transform: "matrix(-0.866025 -0.5 -0.866025 0.5 213.837 160.543)", fill: "#F1F4F9" }),
    React.createElement("rect", { width: "69.2057", height: "20.2844", transform: "matrix(-0.866025 -0.5 -0.866025 0.5 253.104 156.963)", fill: "#F1F4F9" }),
    React.createElement("path", { d: "M193.137 122.355V121.105L175.637 131.355V132.605L193.137 122.355Z", fill: "#C4C4C4" }),
    React.createElement("path", { d: "M234.387 166.565L252.887 155.815L256.137 158.315L235.887 168.065L234.387 166.565Z", fill: "white" }),
    React.createElement("circle", { cx: "1.00001", cy: "1.00001", r: "1.00001", transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 234.637 71.3964)", fill: "#F1F4F9" }),
    React.createElement("rect", { width: "6.19621", height: "6.19621", transform: "matrix(0.866025 0.5 -0.866025 0.5 268.078 69.244)", fill: "white" }),
    React.createElement("rect", { width: "6.19621", height: "6.19621", transform: "matrix(0.866025 0.5 -2.20305e-08 1 262.742 72.342)", fill: "#D9DCE1" }),
    React.createElement("rect", { width: "6.19621", height: "6.19621", transform: "matrix(-0.866025 0.5 2.20305e-08 1 273.444 72.342)", fill: "#C1C4C9" }),
    React.createElement("rect", { width: "6.19621", height: "6.19621", transform: "matrix(0.866025 0.5 -0.866025 0.5 162.512 124.321)", fill: "white" }),
    React.createElement("rect", { width: "6.19621", height: "6.19621", transform: "matrix(0.866025 0.5 -2.20305e-08 1 157.177 127.42)", fill: "#D9DCE1" }),
    React.createElement("rect", { width: "6.19621", height: "6.19621", transform: "matrix(-0.866025 0.5 2.20305e-08 1 167.879 127.42)", fill: "#C1C4C9" }),
    React.createElement("rect", { width: "5.96672", height: "5.96672", transform: "matrix(0.866025 0.5 -0.866025 0.5 213.781 163.335)", fill: "white" }),
    React.createElement("rect", { width: "5.96672", height: "5.96672", transform: "matrix(0.866025 0.5 -2.20305e-08 1 208.643 166.318)", fill: "#D9DCE1" }),
    React.createElement("rect", { width: "5.96672", height: "5.96672", transform: "matrix(-0.866025 0.5 2.20305e-08 1 218.948 166.318)", fill: "#C1C4C9" }),
    React.createElement("rect", { width: "2.91491", height: "2.91491", transform: "matrix(0.866025 0.5 -0.866025 0.5 219.338 173.432)", fill: "white" }),
    React.createElement("rect", { width: "2.91491", height: "2.91491", transform: "matrix(0.866025 0.5 -2.20305e-08 1 216.828 174.89)", fill: "#D9DCE1" }),
    React.createElement("rect", { width: "2.91491", height: "2.91491", transform: "matrix(-0.866025 0.5 2.20305e-08 1 221.862 174.89)", fill: "#C1C4C9" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -0.866025 0.5 149.235 133.501)", fill: "white" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -2.20305e-08 1 147.061 134.763)", fill: "#D9DCE1" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(-0.866025 0.5 2.20305e-08 1 151.421 134.763)", fill: "#C1C4C9" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -0.866025 0.5 182.281 78.4236)", fill: "white" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -2.20305e-08 1 180.108 79.6857)", fill: "#D9DCE1" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(-0.866025 0.5 2.20305e-08 1 184.468 79.6857)", fill: "#C1C4C9" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -0.866025 0.5 274.995 95.865)", fill: "white" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -2.20305e-08 1 272.821 97.1272)", fill: "#D9DCE1" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(-0.866025 0.5 2.20305e-08 1 277.181 97.1272)", fill: "#C1C4C9" }),
    React.createElement("path", { d: "M172.487 109.935L168.815 113.606V104.656L172.487 106.492V109.935Z", fill: "#A9ACB1" }),
    React.createElement("path", { d: "M148.391 86.4744L168.074 96.9206L168.992 104.367L174.094 107.869L176.124 99.6613L181.402 102.709L181.402 95.6266L176.124 92.5791L176.124 60.93L166.816 55.5562L149.309 77.3296L148.391 86.4744ZM168.614 88.508L156.964 81.5174L156.964 81.1459L168.75 66.4253L168.614 66.1524L168.614 88.508Z", fill: "#C1C4C9" }),
    React.createElement("path", { d: "M166.75 55.5455L159.406 60.5943L168.815 66.102L176.159 61.0533L166.75 55.5455Z", fill: "white" }),
    React.createElement("path", { d: "M176.159 92.4933L168.815 97.5421L174.094 100.755L181.437 95.7062L176.159 92.4933Z", fill: "#EDEDED" }),
    React.createElement("path", { d: "M181.437 102.591L174.094 107.869V100.755L181.437 95.7062V102.591Z", fill: "#C1C4C9" }),
    React.createElement("path", { d: "M162.16 84.2317L149.309 86.5266L162.16 94.0997V84.2317Z", fill: "#C1C4C9" }),
    React.createElement("path", { d: "M142 89.3006L161.683 100.665L161.683 109.488L168.815 113.606L168.815 104.782L174.094 107.83L174.094 100.748L168.815 97.5418L168.815 66.0511L159.507 60.6773L142 82.4506L142 89.3006ZM161.764 93.6291L149.656 86.6385L149.656 86.2669L161.442 71.5464L161.764 71.7325L161.764 84.3605L161.764 93.6291Z", fill: "#D9DCE1" }),
    React.createElement("path", { d: "M156.917 81.6365L149.803 86.6853V86.2263L161.277 71.539L161.736 71.7685V75.2108L156.917 81.1775V81.6365Z", fill: "#A9ACB1" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -0.866025 0.5 276.831 148.647)", fill: "white" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -2.20305e-08 1 274.657 149.909)", fill: "#D9DCE1" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(-0.866025 0.5 2.20305e-08 1 279.017 149.909)", fill: "#C1C4C9" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -0.866025 0.5 167.135 52.7209)", fill: "white" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(0.866025 0.5 -2.20305e-08 1 164.961 53.9831)", fill: "#D9DCE1" }),
    React.createElement("rect", { width: "2.52438", height: "2.52438", transform: "matrix(-0.866025 0.5 2.20305e-08 1 169.321 53.9831)", fill: "#C1C4C9" }),
    React.createElement("g", { style: { mixBlendMode: 'multiply' }, opacity: "0.15", filter: "url(#filter1_f_3426_4786)" },
        React.createElement("path", { d: "M222.179 153.063L191.608 135.413L201.351 129.369L231.921 147.019L222.179 153.063Z", fill: "#A9ACB1" })),
    React.createElement("path", { d: "M191.944 91.2554L185.603 93.5803L191.31 96.962L193.001 93.1576L191.944 91.2554Z", fill: "#A9ACB1" }),
    React.createElement("path", { d: "M219.209 135.64L213.502 141.769V134.372C214.179 134.879 218.152 135.711 219.209 135.64Z", fill: "#A9ACB1" }),
    React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M210.671 77.5169L220.189 83.0122L220.189 90.8713C221.56 92.075 222.868 93.423 224.093 94.8802L228.944 92.0794L235.674 103.737L231.042 106.411C231.975 108.694 232.692 111.023 233.151 113.322L238.859 116.618L238.859 127.609L233.051 124.256C232.613 125.792 231.974 127.114 231.164 128.206L234.898 134.673L228.167 138.559L224.302 131.864C223.017 131.934 221.638 131.776 220.189 131.374L220.189 137.965L210.671 132.47L210.671 125.764C209.044 124.294 207.511 122.622 206.105 120.808L202.023 123.165L195.292 111.508L199.594 109.024C199.002 107.395 198.524 105.751 198.174 104.119L192.366 100.766L192.366 89.7759L198.074 93.0713C198.451 91.615 199.004 90.3412 199.707 89.2639L195.249 81.5424L201.979 77.6567L206.306 85.1499C207.656 84.9944 209.121 85.1022 210.671 85.4907L210.671 77.5169ZM223.483 113.025C223.483 118.044 219.959 120.079 215.613 117.569C211.266 115.059 207.742 108.956 207.742 103.937C207.742 98.9172 211.266 96.8827 215.613 99.3924C219.959 101.902 223.483 108.006 223.483 113.025Z", fill: "url(#paint6_linear_3426_4786)" }),
    React.createElement("path", { d: "M203.991 85.1259L199.553 88.9304C200.821 90.4099 203.216 88.9304 203.991 89.3531V85.1259Z", fill: "#F1F4F9" }),
    React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M203.907 81.3212L213.425 86.8164L213.425 94.6755C214.796 95.8791 216.104 97.227 217.329 98.6842L222.18 95.8833L228.911 107.541L224.279 110.215C225.212 112.498 225.929 114.827 226.387 117.127L232.095 120.422L232.095 131.413L226.288 128.06C225.85 129.596 225.211 130.919 224.401 132.011L228.134 138.477L221.404 142.363L217.538 135.668C216.254 135.738 214.875 135.58 213.425 135.178L213.425 141.77L203.907 136.274L203.907 129.568C202.281 128.098 200.748 126.426 199.342 124.612L195.259 126.969L188.529 115.312L192.831 112.829C192.239 111.199 191.761 109.555 191.41 107.924L185.603 104.571L185.603 93.5801L191.311 96.8755C191.688 95.4192 192.24 94.1455 192.944 93.0682L188.529 85.4215L195.259 81.5357L199.542 88.9542C200.893 88.7987 202.358 88.9065 203.907 89.295L203.907 81.3212ZM216.72 116.829C216.72 121.849 213.196 123.883 208.849 121.374C204.502 118.864 200.978 112.76 200.978 107.741C200.978 102.722 204.502 100.687 208.849 103.197C213.196 105.707 216.72 111.81 216.72 116.829Z", fill: "#D9DCE1" }),
    React.createElement("circle", { cx: "9.08834", cy: "9.08834", r: "11.9921", transform: "matrix(0.866025 0.5 -2.20305e-08 1 200.979 98.6526)", stroke: "#D9DCE1", "stroke-width": "5.80749" }),
    React.createElement("path", { d: "M228.931 92.1007L222.168 95.9051L228.931 107.53L235.695 103.725L228.931 92.1007Z", fill: "#F1F4F9" }),
    React.createElement("path", { d: "M232.102 120.423L238.865 116.618L233.158 113.448L226.395 117.252L232.102 120.423Z", fill: "#F1F4F9" }),
    React.createElement("path", { d: "M238.865 116.618L232.102 120.422V131.413L238.865 127.609V116.618Z", fill: "#C1C4C9" }),
    React.createElement("path", { d: "M232.102 131.413L224.493 132.047C224.493 131.878 225.972 129.934 226.184 128.032L232.102 131.413Z", fill: "#A9ACB1" }),
    React.createElement("path", { d: "M210.755 77.517L203.991 81.5327L213.502 86.8167L220.266 83.0122L210.755 77.517Z", fill: "#F1F4F9" }),
    React.createElement("path", { d: "M220.266 90.8324L213.291 94.6368L213.502 86.8166L220.266 83.0122V90.8324Z", fill: "#D9DCE1" }),
    React.createElement("circle", { cx: "9.08834", cy: "9.08834", r: "11.9921", transform: "matrix(0.866025 0.5 -2.20305e-08 1 200.749 98.6188)", stroke: "#F1F4F9", "stroke-width": "5.80749" }),
    React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M256.481 159.302C258.713 161.719 261.257 163.752 264.113 165.401C267.046 167.094 269.648 168.025 271.918 168.193C274.188 168.36 275.967 167.82 277.255 166.571C278.556 165.329 279.2 163.423 279.187 160.851C279.2 158.06 278.447 155.296 276.93 152.559C275.761 150.428 274.177 148.495 272.178 146.759L259.733 140.864V142.807L263.386 144.916C264.866 145.77 266.141 146.77 267.212 147.916C268.296 149.069 269.125 150.28 269.699 151.549C270.286 152.811 270.579 154.043 270.579 155.244C270.579 156.431 270.305 157.32 269.756 157.912C269.208 158.504 268.449 158.776 267.48 158.729C266.511 158.683 265.395 158.295 264.133 157.566C262.921 156.867 261.831 156.01 260.861 154.996C259.892 153.982 259.114 152.896 258.528 151.737C257.954 150.57 257.641 149.423 257.59 148.295L249.25 143.479C249.289 146.124 249.945 148.818 251.221 151.562C252.509 154.298 254.262 156.878 256.481 159.302ZM259.733 140.442V135.818L263.386 137.927C264.636 138.649 265.739 139.037 266.696 139.091C267.665 139.152 268.417 138.898 268.953 138.328C269.489 137.743 269.756 136.858 269.756 135.671C269.756 134.543 269.52 133.418 269.049 132.295C268.59 131.166 267.939 130.116 267.097 129.147C266.269 128.185 265.299 127.384 264.19 126.743C263.068 126.095 262.041 125.737 261.11 125.668C260.179 125.585 259.433 125.806 258.872 126.332C258.311 126.858 258.011 127.681 257.973 128.802L250.035 124.219C250.073 121.647 250.717 119.734 251.967 118.477C253.216 117.221 254.9 116.647 257.017 116.756C259.146 116.857 261.55 117.681 264.228 119.227C266.932 120.788 269.297 122.718 271.325 125.017C273.353 127.315 274.927 129.748 276.05 132.316C277.185 134.876 277.746 137.339 277.733 139.705C277.746 142.232 277.064 143.941 275.686 144.831C274.322 145.728 272.543 145.77 270.349 144.958V145.31C270.551 145.456 270.749 145.603 270.943 145.752L259.733 140.442Z", fill: "white" }),
    React.createElement("path", { d: "M273.352 147.786L264.615 151.25L267.025 155.318L271.996 172.791L277.522 166.651C278.338 165.744 278.864 164.613 279.03 163.404L279.377 160.891C279.618 155.468 275.36 149.895 273.352 147.786Z", fill: "#A9ACB1" }),
    React.createElement("path", { d: "M251.811 154.866L252.564 154.112L263.109 162.397L264.766 165.711C264.314 165.711 262.506 165.53 258.891 164.807C255.276 164.084 252.665 157.878 251.811 154.866Z", fill: "white" }),
    React.createElement("path", { d: "M259.644 135.735L254.673 141.761C255.878 143.518 259.494 146.972 264.314 146.731C269.134 146.49 268.431 142.112 267.477 139.953L259.644 135.735Z", fill: "#C1C4C9" }),
    React.createElement("path", { d: "M249.251 143.568L244.129 149.518L252.414 154.263L258.138 148.539L249.251 143.568Z", fill: "#EDEDED" }),
    React.createElement("path", { d: "M251.962 118.563L246.238 125.342C251.108 126.898 261.572 130.403 264.464 131.969C267.356 133.536 270.389 144.572 271.544 149.895L276.515 144.171L265.218 122.178L251.962 118.563Z", fill: "white" }),
    React.createElement("path", { d: "M258.992 171.426C256.135 169.777 253.591 167.744 251.36 165.327C249.141 162.904 247.387 160.323 246.099 157.587C244.824 154.844 244.167 152.15 244.129 149.505L252.469 154.32C252.52 155.448 252.833 156.596 253.406 157.762C253.993 158.921 254.771 160.008 255.74 161.022C256.709 162.035 257.8 162.892 259.011 163.591C260.274 164.32 261.39 164.708 262.359 164.755C263.328 164.802 264.087 164.529 264.635 163.937C265.183 163.346 265.458 162.456 265.458 161.269C265.458 160.068 265.164 158.836 264.578 157.575C264.004 156.306 263.175 155.095 262.091 153.941C261.02 152.795 259.744 151.795 258.265 150.941L254.612 148.832L254.612 141.843L258.265 143.953C259.515 144.674 260.618 145.062 261.574 145.116C262.544 145.177 263.296 144.923 263.832 144.353C264.367 143.769 264.635 142.883 264.635 141.696C264.635 140.568 264.399 139.443 263.927 138.321C263.468 137.191 262.818 136.142 261.976 135.172C261.147 134.21 260.178 133.409 259.069 132.768C257.946 132.121 256.92 131.762 255.989 131.694C255.058 131.61 254.312 131.832 253.751 132.358C253.19 132.883 252.89 133.707 252.852 134.827L244.913 130.244C244.952 127.673 245.596 125.759 246.845 124.503C248.095 123.246 249.778 122.672 251.895 122.781C254.025 122.882 256.429 123.706 259.107 125.252C261.81 126.813 264.176 128.743 266.204 131.042C268.231 133.341 269.806 135.774 270.928 138.341C272.063 140.901 272.624 143.364 272.612 145.73C272.624 148.258 271.942 149.966 270.565 150.856C269.2 151.753 267.421 151.796 265.228 150.983L265.228 151.335C268.11 153.424 270.303 155.84 271.808 158.585C273.326 161.322 274.078 164.086 274.065 166.877C274.078 169.448 273.434 171.354 272.133 172.596C270.845 173.845 269.067 174.386 266.797 174.218C264.527 174.05 261.925 173.12 258.992 171.426Z", fill: "#D9DCE1" }),
    React.createElement("rect", { width: "3.65264", height: "3.65264", transform: "matrix(0.866025 0.5 -0.866025 0.5 278.323 158.179)", fill: "white" }),
    React.createElement("rect", { width: "3.65264", height: "3.65264", transform: "matrix(0.866025 0.5 -2.20305e-08 1 275.177 160.006)", fill: "#D9DCE1" }),
    React.createElement("rect", { width: "3.65264", height: "3.65264", transform: "matrix(-0.866025 0.5 2.20305e-08 1 281.486 160.006)", fill: "#C1C4C9" }),
    React.createElement("defs", null,
        React.createElement("filter", { id: "filter0_d_3426_4786", x: "-6", y: "-2", width: "72", height: "36", filterUnits: "userSpaceOnUse", "color-interpolation-filters": "sRGB" },
            React.createElement("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
            React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
            React.createElement("feOffset", { dy: "4" }),
            React.createElement("feGaussianBlur", { stdDeviation: "6" }),
            React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }),
            React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_3426_4786" }),
            React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_3426_4786", result: "shape" })),
        React.createElement("filter", { id: "filter1_f_3426_4786", x: "187.174", y: "124.934", width: "49.1824", height: "32.5636", filterUnits: "userSpaceOnUse", "color-interpolation-filters": "sRGB" },
            React.createElement("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
            React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
            React.createElement("feGaussianBlur", { stdDeviation: "2.21731", result: "effect1_foregroundBlur_3426_4786" })),
        React.createElement("linearGradient", { id: "paint0_linear_3426_4786", x1: "6", y1: "6", x2: "18", y2: "18", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { "stop-color": "#B5BBC2" }),
            React.createElement("stop", { offset: "1", "stop-color": "#8C95A2" })),
        React.createElement("linearGradient", { id: "paint1_linear_3426_4786", x1: "36", y1: "18", x2: "24", y2: "6", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { "stop-color": "#F99A1C" }),
            React.createElement("stop", { offset: "1", "stop-color": "#FFB901" })),
        React.createElement("linearGradient", { id: "paint2_linear_3426_4786", x1: "42", y1: "6", x2: "54", y2: "18", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { "stop-color": "white" }),
            React.createElement("stop", { offset: "1", "stop-color": "#EFEFEF" })),
        React.createElement("linearGradient", { id: "paint3_linear_3426_4786", x1: "233.614", y1: "128.338", x2: "267.116", y2: "95.5139", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { "stop-color": "white" }),
            React.createElement("stop", { offset: "1", "stop-color": "#F1F4F9" })),
        React.createElement("linearGradient", { id: "paint4_linear_3426_4786", x1: "269.638", y1: "155.382", x2: "166.27", y2: "218.042", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { "stop-color": "#B1AEAE" }),
            React.createElement("stop", { offset: "0.401042", "stop-color": "#BCC1C4" }),
            React.createElement("stop", { offset: "1", "stop-color": "white" })),
        React.createElement("linearGradient", { id: "paint5_linear_3426_4786", x1: "228.17", y1: "124.288", x2: "222.812", y2: "133.903", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { "stop-color": "#C4C4C4", "stop-opacity": "0" }),
            React.createElement("stop", { offset: "0.947917", "stop-color": "#787878" })),
        React.createElement("linearGradient", { id: "paint6_linear_3426_4786", x1: "215.613", y1: "80.3702", x2: "191.817", y2: "121.585", gradientUnits: "userSpaceOnUse" },
            React.createElement("stop", { "stop-color": "#DBE0E8" }),
            React.createElement("stop", { offset: "1", "stop-color": "#969CA5" })),
        React.createElement("clipPath", { id: "clip0_3426_4786" },
            React.createElement("rect", { width: "424", height: "208", rx: "12", fill: "white" })))));

const Error500Illustration = (props) => {
    return (React.createElement("svg", Object.assign({ width: "424", height: "208", viewBox: "0 0 424 208", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { "clip-path": "url(#clip0_3434_4754)" },
            React.createElement("rect", { width: "424", height: "24", fill: "#F1F4F9" }),
            React.createElement("g", { filter: "url(#filter0_d_3434_4754)" },
                React.createElement("rect", { x: "6", y: "6", width: "12", height: "12", rx: "6", fill: "url(#paint0_linear_3434_4754)" }),
                React.createElement("rect", { x: "24", y: "6", width: "12", height: "12", rx: "6", fill: "url(#paint1_linear_3434_4754)" }),
                React.createElement("rect", { x: "42", y: "6", width: "12", height: "12", rx: "6", fill: "url(#paint2_linear_3434_4754)" })),
            React.createElement("rect", { width: "424", height: "184", transform: "translate(0 24)", fill: "white" })),
        React.createElement("rect", { x: "0.5", y: "0.5", width: "423", height: "207", rx: "11.5", stroke: "#F1ECE3" }),
        React.createElement("path", { d: "M262.765 89.9312C262.765 88.9183 262.054 87.6866 261.177 87.1801L192.192 47.3515C191.315 46.845 190.603 47.2556 190.603 48.2685L190.603 119.142L259.192 158.742C261.165 159.881 262.765 158.957 262.765 156.678L262.765 89.9312Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M263.224 89.4727C263.224 88.4597 262.513 87.228 261.636 86.7215L192.65 46.8929C191.773 46.3864 191.062 46.797 191.062 47.8099L191.062 118.684L259.65 158.283C261.624 159.423 263.224 158.499 263.224 156.22L263.224 89.4727Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M263.682 89.0142C263.682 88.0013 262.971 86.7696 262.094 86.2631L193.109 46.4345C192.232 45.928 191.52 46.3386 191.52 47.3515L191.52 118.225L260.109 157.825C262.082 158.964 263.682 158.04 263.682 155.761L263.682 89.0142Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M264.141 88.5557C264.141 87.5428 263.43 86.3111 262.552 85.8046L193.567 45.976C192.69 45.4695 191.979 45.8801 191.979 46.893L191.979 117.767L260.567 157.366C262.541 158.506 264.141 157.582 264.141 155.303L264.141 88.5557Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M262.307 90.3897C262.307 89.3768 261.596 88.1451 260.719 87.6386L191.733 47.81C190.856 47.3035 190.145 47.7141 190.145 48.727L190.145 119.601L258.733 159.2C260.707 160.34 262.307 159.416 262.307 157.137L262.307 90.3897Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M256.376 91.9799L196.076 57.1659L196.076 110.794L256.376 145.608L256.376 91.9799Z", fill: "url(#paint3_linear_3434_4754)" }),
        React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M262.307 158.736L262.306 158.737L262.307 158.737L212.279 187.62C211.402 188.127 209.98 188.127 209.102 187.62L140.017 147.734C139.308 147.324 139.172 146.709 139.609 146.221C139.275 145.848 139.275 145.401 139.61 145.029C139.557 144.97 139.512 144.909 139.476 144.847C139.284 144.517 139.328 144.151 139.609 143.837C139.172 143.349 139.308 142.734 140.017 142.324L190.044 113.441L205.529 122.381L204.498 122.976L205.529 123.572L207.594 124.764L203.464 127.149L241.66 149.201L246.822 146.221L261.199 154.522L262.307 153.968V156.353V158.736Z", fill: "url(#paint4_linear_3434_4754)" }),
        React.createElement("path", { d: "M139.428 147.294L139.428 142.549L140.427 143.048L140.926 147.794L139.428 147.294Z", fill: "#F3F4F5" }),
        React.createElement("path", { d: "M200.368 124.586L241.327 148.211L214.824 125.797L208.198 119.739L200.368 124.586Z", fill: "#C7C6C6" }),
        React.createElement("path", { d: "M241.393 148.711L246.822 145.723V138.551L205.798 115.244V121.818L200.368 124.806L241.393 148.711Z", fill: "url(#paint5_linear_3434_4754)", "fill-opacity": "0.5" }),
        React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M246.822 145.526L262.307 154.466L212.288 183.828C211.41 184.344 209.97 184.345 209.089 183.83L139.998 143.463C139.13 142.956 139.134 142.139 140.008 141.634L190.044 112.745L205.529 121.686L200.368 124.666L241.66 148.506L246.822 145.526Z", fill: "white" }),
        React.createElement("path", { d: "M245.79 155.647L185.882 121.027L168.366 131.211L228.24 165.779L245.79 155.647Z", fill: "#DBDCDE" }),
        React.createElement("rect", { width: "30.9924", height: "14.3042", transform: "matrix(-0.866025 -0.5 -0.866025 0.5 206.562 160.427)", fill: "#F1F4F9" }),
        React.createElement("rect", { width: "69.137", height: "20.2643", transform: "matrix(-0.866025 -0.5 -0.866025 0.5 245.79 156.85)", fill: "#F1F4F9" }),
        React.createElement("path", { d: "M185.882 122.277V121.028L168.399 131.268V132.517L185.882 122.277Z", fill: "#C4C4C4" }),
        React.createElement("path", { d: "M227.091 166.444L245.573 155.704L248.82 158.202L228.59 167.942L227.091 166.444Z", fill: "white" }),
        React.createElement("circle", { cx: "0.999016", cy: "0.999016", r: "0.999016", transform: "matrix(-0.866025 -0.5 -2.20305e-08 1 227.341 71.3691)", fill: "#F1F4F9" }),
        React.createElement("rect", { width: "6.19006", height: "6.19006", transform: "matrix(0.866025 0.5 -0.866025 0.5 260.748 69.2188)", fill: "white" }),
        React.createElement("rect", { width: "6.19006", height: "6.19006", transform: "matrix(0.866025 0.5 -2.20305e-08 1 255.418 72.314)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "6.19006", height: "6.19006", transform: "matrix(-0.866025 0.5 2.20305e-08 1 266.109 72.314)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "6.19006", height: "6.19006", transform: "matrix(0.866025 0.5 -0.866025 0.5 248.806 170.707)", fill: "white" }),
        React.createElement("rect", { width: "6.19006", height: "6.19006", transform: "matrix(0.866025 0.5 -2.20305e-08 1 243.475 173.802)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "6.19006", height: "6.19006", transform: "matrix(-0.866025 0.5 2.20305e-08 1 254.166 173.802)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "6.19006", height: "6.19006", transform: "matrix(0.866025 0.5 -0.866025 0.5 155.288 124.241)", fill: "white" }),
        React.createElement("rect", { width: "6.19006", height: "6.19006", transform: "matrix(0.866025 0.5 -2.20305e-08 1 149.958 127.336)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "6.19006", height: "6.19006", transform: "matrix(-0.866025 0.5 2.20305e-08 1 160.649 127.336)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "5.9608", height: "5.9608", transform: "matrix(0.866025 0.5 -0.866025 0.5 206.506 163.216)", fill: "white" }),
        React.createElement("rect", { width: "5.9608", height: "5.9608", transform: "matrix(0.866025 0.5 -2.20305e-08 1 201.373 166.197)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "5.9608", height: "5.9608", transform: "matrix(-0.866025 0.5 2.20305e-08 1 211.668 166.197)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "2.91201", height: "2.91201", transform: "matrix(0.866025 0.5 -0.866025 0.5 212.057 173.304)", fill: "white" }),
        React.createElement("rect", { width: "2.91201", height: "2.91201", transform: "matrix(0.866025 0.5 -2.20305e-08 1 209.55 174.76)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "2.91201", height: "2.91201", transform: "matrix(-0.866025 0.5 2.20305e-08 1 214.579 174.76)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "2.52188", height: "2.52188", transform: "matrix(0.866025 0.5 -0.866025 0.5 142.024 133.412)", fill: "white" }),
        React.createElement("rect", { width: "2.52188", height: "2.52188", transform: "matrix(0.866025 0.5 -2.20305e-08 1 139.852 134.673)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "2.52188", height: "2.52188", transform: "matrix(-0.866025 0.5 2.20305e-08 1 144.208 134.673)", fill: "#C1C4C9" }),
        React.createElement("rect", { width: "2.52188", height: "2.52188", transform: "matrix(0.866025 0.5 -0.866025 0.5 267.659 95.8136)", fill: "white" }),
        React.createElement("rect", { width: "2.52188", height: "2.52188", transform: "matrix(0.866025 0.5 -2.20305e-08 1 265.487 97.0743)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "2.52188", height: "2.52188", transform: "matrix(-0.866025 0.5 2.20305e-08 1 269.843 97.0743)", fill: "#C1C4C9" }),
        React.createElement("g", { style: { mixBlendMode: 'multiply' }, opacity: "0.15", filter: "url(#filter1_f_3434_4754)" },
            React.createElement("path", { d: "M214.895 152.955L184.355 135.322L194.088 129.284L224.628 146.916L214.895 152.955Z", fill: "#A9ACB1" })),
        React.createElement("path", { d: "M188.904 94.5181L182.569 96.8407L188.27 100.219L189.959 96.4184L188.904 94.5181Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M216.142 138.859L210.441 144.982V137.592C211.116 138.099 215.086 138.929 216.142 138.859Z", fill: "#A9ACB1" }),
        React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M207.612 80.7925L217.12 86.2823L217.12 94.1345C218.49 95.3368 219.797 96.6831 221.02 98.1387L225.867 95.3403L232.59 106.986L227.963 109.658C228.895 111.938 229.611 114.265 230.07 116.562L235.772 119.854L235.772 130.834L229.971 127.485C229.533 129.019 228.895 130.341 228.085 131.432L231.815 137.892L225.091 141.773L221.23 135.086C219.947 135.157 218.569 134.998 217.12 134.597L217.12 141.18L207.612 135.691L207.612 128.993C205.987 127.524 204.455 125.853 203.05 124.041L198.972 126.395L192.249 114.749L196.546 112.268C195.955 110.641 195.477 108.999 195.127 107.368L189.326 104.019L189.326 93.0393L195.028 96.3315C195.405 94.8768 195.957 93.6045 196.659 92.5283L192.205 84.8139L198.929 80.932L203.252 88.4188C204.601 88.2634 206.064 88.3712 207.612 88.7593L207.612 80.7925ZM220.412 116.266C220.412 121.28 216.891 123.313 212.549 120.806C208.206 118.299 204.686 112.201 204.686 107.187C204.686 102.172 208.206 100.14 212.549 102.647C216.891 105.154 220.412 111.252 220.412 116.266Z", fill: "url(#paint6_linear_3434_4754)" }),
        React.createElement("path", { d: "M200.939 88.3945L196.505 92.1952C197.772 93.6732 200.165 92.1952 200.939 92.6175V88.3945Z", fill: "#F1F4F9" }),
        React.createElement("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M200.855 84.5948L210.363 90.0846L210.363 97.9351C211.733 99.1377 213.04 100.484 214.264 101.94L219.11 99.1422L225.834 110.788L221.206 113.46C222.139 115.741 222.855 118.067 223.313 120.365L229.015 123.657L229.015 134.637L223.214 131.287C222.776 132.822 222.137 134.142 221.328 135.233L225.058 141.693L218.335 145.575L214.473 138.887C213.19 138.957 211.812 138.799 210.364 138.398L210.364 144.983L200.855 139.493L200.855 132.793C199.23 131.325 197.699 129.655 196.294 127.843L192.216 130.197L185.492 118.552L189.79 116.071C189.199 114.443 188.721 112.801 188.371 111.171L182.569 107.822L182.569 96.8421L188.271 100.134C188.648 98.6788 189.2 97.4059 189.903 96.3293L185.492 88.6903L192.216 84.8084L196.495 92.2197C197.844 92.0643 199.307 92.172 200.855 92.5601L200.855 84.5948ZM213.655 120.067C213.655 125.081 210.135 127.114 205.792 124.607C201.45 122.099 197.929 116.002 197.929 110.988C197.929 105.973 201.45 103.941 205.792 106.448C210.135 108.955 213.655 115.053 213.655 120.067Z", fill: "#D9DCE1" }),
        React.createElement("circle", { cx: "9.07932", cy: "9.07932", r: "11.3719", transform: "matrix(0.866025 0.5 -2.20305e-08 1 197.929 101.908)", stroke: "#D9DCE1", "stroke-width": "4.58523" }),
        React.createElement("path", { d: "M225.854 95.3628L219.098 99.1634L225.854 110.777L232.611 106.976L225.854 95.3628Z", fill: "#F1F4F9" }),
        React.createElement("path", { d: "M229.022 123.657L235.778 119.856L230.077 116.689L223.321 120.49L229.022 123.657Z", fill: "#F1F4F9" }),
        React.createElement("path", { d: "M235.778 119.855L229.021 123.656V134.636L235.778 130.835V119.855Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M229.022 134.636L221.42 135.27C221.42 135.101 222.898 133.158 223.109 131.258L229.022 134.636Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M207.696 80.7935L200.939 84.8053L210.441 90.0839L217.197 86.2833L207.696 80.7935Z", fill: "#F1F4F9" }),
        React.createElement("path", { d: "M217.197 94.0952L210.229 97.8958L210.441 90.0834L217.197 86.2827V94.0952Z", fill: "#D9DCE1" }),
        React.createElement("circle", { cx: "9.07932", cy: "9.07932", r: "11.3719", transform: "matrix(0.866025 0.5 -2.20305e-08 1 197.701 101.874)", stroke: "#F1F4F9", "stroke-width": "4.58523" }),
        React.createElement("path", { d: "M254.408 160.926L263.437 155.809L268.554 163.785C269.958 165.841 271.443 170.225 266.146 171.309C260.849 172.392 256.114 164.838 254.408 160.926Z", fill: "white" }),
        React.createElement("path", { d: "M271.88 170.418C268.465 168.432 265.527 165.765 263.065 162.418C260.617 159.079 258.731 155.201 257.408 150.785C256.097 146.376 255.449 141.608 255.462 136.481C255.462 131.361 256.117 127.376 257.427 124.526C258.751 121.684 260.637 120.029 263.085 119.563C265.547 119.089 268.478 119.834 271.88 121.798C275.281 123.762 278.206 126.398 280.654 129.707C283.116 133.023 285.009 136.866 286.332 141.237C287.656 145.593 288.311 150.326 288.297 155.438C288.297 160.588 287.636 164.607 286.312 167.496C285.002 170.392 283.123 172.096 280.674 172.608C278.226 173.119 275.294 172.39 271.88 170.418ZM271.88 162.189C274.209 163.534 276.069 163.255 277.458 161.352C278.848 159.45 279.536 155.79 279.523 150.372C279.523 146.811 279.205 143.663 278.57 140.928C277.948 138.2 277.061 135.907 275.91 134.051C274.772 132.202 273.428 130.83 271.88 129.936C269.564 128.599 267.711 128.866 266.321 130.738C264.932 132.61 264.23 136.209 264.217 141.535C264.217 145.142 264.528 148.332 265.15 151.106C265.785 153.872 266.679 156.191 267.83 158.063C268.981 159.92 270.331 161.295 271.88 162.189Z", fill: "white" }),
        React.createElement("path", { d: "M260.879 120.445L252.151 125.411L252.001 130.076L267.2 124.809L260.879 120.445Z", fill: "white" }),
        React.createElement("path", { d: "M283.602 137.902L270.961 143.921L259.826 128.722L274.423 126.314L283.602 137.902Z", fill: "white" }),
        React.createElement("path", { d: "M284.505 136.246L270.962 143.921L273.219 160.624C273.219 160.624 288.418 163.634 288.267 154.906C288.117 146.178 287.063 142.717 284.505 136.246Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M283.753 171.309L272.918 177.629L277.733 154.605L287.816 148.586C289.501 163.634 285.809 170.005 283.753 171.309Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M270.51 135.343L280.593 129.625C281.917 131.19 283.753 134.792 284.505 136.397L274.874 141.965L270.51 135.343Z", fill: "#F1F4F9" }),
        React.createElement("path", { d: "M254.258 142.867L264.641 136.848C264.491 135.644 260.578 132.183 257.117 133.989C254.348 135.433 254.057 140.51 254.258 142.867Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M264.34 144.824C263.979 141.694 264.29 138.303 264.491 136.999L253.506 141.363V150.993L264.34 144.824Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M265.996 154.304C264.792 149.97 264.39 146.278 264.34 144.974L254.559 150.391L255.462 160.474L265.996 154.304Z", fill: "#F1F4F9" }),
        React.createElement("path", { d: "M262.571 175.773C259.157 173.787 256.219 171.12 253.757 167.773C251.308 164.434 249.422 160.556 248.099 156.14C246.789 151.731 246.14 146.963 246.154 141.836C246.154 136.716 246.809 132.731 248.119 129.881C249.442 127.039 251.328 125.384 253.777 124.918C256.238 124.444 259.17 125.189 262.571 127.153C265.973 129.117 268.897 131.753 271.346 135.062C273.807 138.378 275.7 142.221 277.024 146.592C278.347 150.947 279.002 155.681 278.989 160.793C278.989 165.943 278.327 169.962 277.004 172.851C275.693 175.747 273.814 177.451 271.366 177.962C268.917 178.474 265.986 177.745 262.571 175.773ZM262.571 167.544C264.901 168.889 266.76 168.61 268.15 166.707C269.539 164.805 270.227 161.144 270.214 155.727C270.214 152.166 269.897 149.018 269.261 146.283C268.639 143.555 267.753 141.262 266.601 139.406C265.463 137.557 264.12 136.185 262.571 135.291C260.255 133.954 258.402 134.221 257.013 136.093C255.623 137.965 254.922 141.564 254.908 146.89C254.908 150.497 255.219 153.687 255.841 156.461C256.477 159.227 257.37 161.546 258.521 163.418C259.673 165.274 261.023 166.65 262.571 167.544Z", fill: "#D9DCE1" }),
        React.createElement("path", { d: "M159.543 105.479C156.858 103.929 154.465 101.977 152.363 99.6234C150.274 97.2768 148.615 94.7474 147.387 92.0353C146.159 89.3231 145.52 86.6585 145.469 84.0414L153.446 88.6469C153.535 90.438 154.168 92.2144 155.345 93.9762C156.523 95.738 157.922 97.0867 159.543 98.0224C160.834 98.7681 161.974 99.0971 162.961 99.0093C163.962 98.9143 164.74 98.4355 165.297 97.5729C165.867 96.7029 166.152 95.4931 166.152 93.9433C166.152 92.3642 165.861 90.8071 165.278 89.272C164.709 87.7441 163.917 86.3515 162.904 85.0941C161.891 83.8367 160.733 82.8243 159.429 82.0567C158.289 81.3987 157.181 81.0296 156.105 80.9492C155.041 80.8761 154.212 81.1356 153.617 81.7277L146.305 75.9927L148.147 53.3709L171.926 67.0997L171.926 74.8633L154.927 65.0492L153.921 75.7186L154.149 75.8502C154.832 75.1338 155.864 74.8085 157.245 74.8743C158.625 74.9401 160.169 75.4664 161.879 76.4533C164.221 77.8057 166.31 79.6479 168.146 81.9799C169.982 84.3119 171.432 86.8961 172.496 89.7325C173.559 92.5543 174.085 95.4017 174.072 98.2746C174.085 101.308 173.477 103.648 172.249 105.293C171.033 106.93 169.33 107.789 167.14 107.869C164.962 107.943 162.43 107.146 159.543 105.479Z", fill: "white" }),
        React.createElement("path", { d: "M142.471 94.8631L152.553 88.8438C153.306 88.9942 155.442 90.1078 157.971 93.3582C161.131 97.4213 160.83 103.441 153.005 106.149C146.745 108.316 143.374 99.5281 142.471 94.8631Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M154.66 75.5158L144.126 81.5351L145.48 70.1839L155.563 74.6984L154.66 75.5158Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M143.675 84.9314L136 89.4458L143.825 94.1108L153.306 88.3925L143.675 84.9314Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M170.009 107.202L160.679 112.319L163.388 99.8288L173.771 93.8095C174.223 97.5716 174.223 98.1735 173.771 101.936C173.41 104.945 171.213 106.45 170.009 107.202Z", fill: "#A9ACB1" }),
        React.createElement("path", { d: "M167.902 81.6202L158.573 87.0377L160.83 97.12L164.14 99.3772L173.771 93.8094C173.22 91.502 171.273 85.8338 167.902 81.6202Z", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M162.485 72.506L138.679 58.7368L148.189 53.2441L171.966 67.0886L162.485 72.506Z", fill: "white" }),
        React.createElement("rect", { width: "2.52188", height: "2.52188", transform: "matrix(0.866025 0.5 -0.866025 0.5 158.65 56.9413)", fill: "white" }),
        React.createElement("rect", { width: "2.52188", height: "2.52188", transform: "matrix(0.866025 0.5 -2.20305e-08 1 156.478 58.2021)", fill: "#D9DCE1" }),
        React.createElement("rect", { width: "2.52188", height: "2.52188", transform: "matrix(-0.866025 0.5 2.20305e-08 1 160.834 58.2021)", fill: "#C1C4C9" }),
        React.createElement("path", { d: "M157.519 87.6399L167.902 81.6205C167.18 80.6574 165.695 79.3131 165.043 78.7614L154.961 75.3002L144.578 81.1691L157.519 87.6399Z", fill: "#F1F4F9" }),
        React.createElement("path", { d: "M150.074 110.811C147.389 109.261 144.996 107.309 142.894 104.955C140.805 102.609 139.146 100.079 137.918 97.3672C136.69 94.6551 136.051 91.9905 136 89.3734L143.977 93.9789C144.066 95.7699 144.699 97.5463 145.876 99.3081C147.054 101.07 148.453 102.419 150.074 103.354C151.365 104.1 152.505 104.429 153.492 104.341C154.493 104.246 155.271 103.767 155.828 102.905C156.398 102.035 156.683 100.825 156.683 99.2752C156.683 97.6962 156.392 96.1391 155.809 94.6039C155.24 93.076 154.448 91.6834 153.435 90.426C152.422 89.1687 151.264 88.1562 149.96 87.3886C148.82 86.7307 147.712 86.3615 146.636 86.2811C145.572 86.208 144.743 86.4675 144.148 87.0596L136.836 81.3247L138.678 58.7029L162.485 72.4411L162.485 80.1839L145.458 70.3811L144.452 81.0505L144.68 81.1821C145.363 80.4657 146.395 80.1404 147.776 80.2062C149.156 80.272 150.7 80.7983 152.41 81.7852C154.752 83.1376 156.841 84.9798 158.677 87.3118C160.513 89.6438 161.963 92.228 163.027 95.0645C164.09 97.8862 164.616 100.734 164.603 103.607C164.616 106.64 164.008 108.98 162.78 110.625C161.564 112.262 159.861 113.121 157.671 113.201C155.493 113.274 152.961 112.478 150.074 110.811Z", fill: "#D9DCE1" }),
        React.createElement("path", { d: "M171.965 74.914L162.485 80.1809V72.5063L171.965 67.0889V74.914Z", fill: "#C1C4C9" }),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_3434_4754", x: "-6", y: "-2", width: "72", height: "36", filterUnits: "userSpaceOnUse", "color-interpolation-filters": "sRGB" },
                React.createElement("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: "4" }),
                React.createElement("feGaussianBlur", { stdDeviation: "6" }),
                React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }),
                React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_3434_4754" }),
                React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow_3434_4754", result: "shape" })),
            React.createElement("filter", { id: "filter1_f_3434_4754", x: "180.854", y: "125.782", width: "47.2757", height: "30.6734", filterUnits: "userSpaceOnUse", "color-interpolation-filters": "sRGB" },
                React.createElement("feFlood", { "flood-opacity": "0", result: "BackgroundImageFix" }),
                React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }),
                React.createElement("feGaussianBlur", { stdDeviation: "1.75065", result: "effect1_foregroundBlur_3434_4754" })),
            React.createElement("linearGradient", { id: "paint0_linear_3434_4754", x1: "6", y1: "6", x2: "18", y2: "18", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "#B5BBC2" }),
                React.createElement("stop", { offset: "1", "stop-color": "#8C95A2" })),
            React.createElement("linearGradient", { id: "paint1_linear_3434_4754", x1: "36", y1: "18", x2: "24", y2: "6", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "#F99A1C" }),
                React.createElement("stop", { offset: "1", "stop-color": "#FFB901" })),
            React.createElement("linearGradient", { id: "paint2_linear_3434_4754", x1: "42", y1: "6", x2: "54", y2: "18", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "white" }),
                React.createElement("stop", { offset: "1", "stop-color": "#EFEFEF" })),
            React.createElement("linearGradient", { id: "paint3_linear_3434_4754", x1: "226.319", y1: "128.255", x2: "259.788", y2: "95.4629", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "white" }),
                React.createElement("stop", { offset: "1", "stop-color": "#F1F4F9" })),
            React.createElement("linearGradient", { id: "paint4_linear_3434_4754", x1: "262.307", y1: "155.352", x2: "158.84", y2: "218.079", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "#B1AEAE" }),
                React.createElement("stop", { offset: "0.401042", "stop-color": "#BCC1C4" }),
                React.createElement("stop", { offset: "1", "stop-color": "white" })),
            React.createElement("linearGradient", { id: "paint5_linear_3434_4754", x1: "220.88", y1: "124.208", x2: "215.528", y2: "133.813", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "#C4C4C4", "stop-opacity": "0" }),
                React.createElement("stop", { offset: "0.947917", "stop-color": "#787878" })),
            React.createElement("linearGradient", { id: "paint6_linear_3434_4754", x1: "212.549", y1: "83.643", x2: "188.777", y2: "124.817", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { "stop-color": "#DBE0E8" }),
                React.createElement("stop", { offset: "1", "stop-color": "#969CA5" })),
            React.createElement("clipPath", { id: "clip0_3434_4754" },
                React.createElement("rect", { width: "424", height: "208", rx: "12", fill: "white" })))));
};

export { AvatarGroup, CheckboxCheckedIcon, CheckboxIcon, DefaultSnackbarAction, Error400Illustration, Error403Illustration, Error500Illustration, ImageCropper, KeywordChips, MultipleEmails, PageLoading, PhaseIndicator, ReadMore, Status, TabPanel, TagSelector, UserAvatar, breakpoints$1 as breakpoints, colors$1 as colors, theme, colors as vspColors, vspTheme };
//# sourceMappingURL=index.esm.js.map
